/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: string;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AnyEnergySystemParametersInput = {
  domesticHotWater?: Maybe<DomesticHotWaterParametersInput>;
  ventilation?: Maybe<VentilationParametersInput>;
  cooling?: Maybe<CoolingParametersInput>;
  heatLoad?: Maybe<HeatLoadParametersInput>;
  electricityConsumption?: Maybe<ElectricityConsumptionParametersInput>;
  spaceHeating?: Maybe<SpaceHeatingParametersInput>;
};

export type AnyProviderParametersInput = {
  inefficientDevice?: Maybe<InefficientParametersInput>;
  heatBoiler?: Maybe<HeatBoilerParametersInput>;
  heatingAirHeatPump?: Maybe<HeatingAirHeatPumpParametersInput>;
  heatingGroundHeatPump?: Maybe<HeatingGroundHeatPumpParametersInput>;
  coolingAirHeatPump?: Maybe<CoolingAirHeatPumpParametersInput>;
  coolingGroundHeatPump?: Maybe<CoolingGroundHeatPumpParametersInput>;
  waterCoolingHeatPump?: Maybe<WaterCoolingHeatPumpParametersInput>;
  circulationHeatPump?: Maybe<CirculationHeatPumpParametersInput>;
  hybridHeatPump?: Maybe<HybridHeatPumpParametersInput>;
  preheater?: Maybe<PreheaterParametersInput>;
  solarPanel?: Maybe<SolarPanelParametersInput>;
  battery?: Maybe<BatteryParametersInput>;
};

export type BatteryParameters = ProviderParameters & {
  __typename?: 'BatteryParameters';
  isWasteSold?: Maybe<Scalars['Boolean']>;
  capacity: Scalars['Float'];
  chargePower: Scalars['Float'];
  dischargePower: Scalars['Float'];
};

export type BatteryParametersInput = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
  capacity: Scalars['Float'];
  chargePower: Scalars['Float'];
  dischargePower: Scalars['Float'];
};

export type BemCorrectionFactorsData = {
  __typename?: 'BemCorrectionFactorsData';
  energyType: ConsumptionEnergyType;
  correctionFactor: Scalars['Float'];
  energyFactor: Scalars['Float'];
};

export type BemCorrectionFactorsDataInput = {
  energyType: ConsumptionEnergyType;
  correctionFactor: Scalars['Float'];
  energyFactor: Scalars['Float'];
};

export type BemLimitValuesData = {
  __typename?: 'BemLimitValuesData';
  winterTempStart: Scalars['Float'];
  winterTempEnd: Scalars['Float'];
  summerTempStart: Scalars['Float'];
  summerTempEnd: Scalars['Float'];
  zeroWeatherTempStart: Scalars['Float'];
  zeroWeatherTempEnd: Scalars['Float'];
  morningStartHour: Scalars['Int'];
  morningEndHour: Scalars['Int'];
  dayStartHour: Scalars['Int'];
  dayEndHour: Scalars['Int'];
  eveningStartHour: Scalars['Int'];
  eveningEndHour: Scalars['Int'];
  nightStartHour: Scalars['Int'];
  nightEndHour: Scalars['Int'];
};

export type BemLimitValuesDataInput = {
  winterTempStart: Scalars['Float'];
  winterTempEnd: Scalars['Float'];
  summerTempStart: Scalars['Float'];
  summerTempEnd: Scalars['Float'];
  zeroWeatherTempStart: Scalars['Float'];
  zeroWeatherTempEnd: Scalars['Float'];
  morningStartHour: Scalars['Int'];
  morningEndHour: Scalars['Int'];
  dayStartHour: Scalars['Int'];
  dayEndHour: Scalars['Int'];
  eveningStartHour: Scalars['Int'];
  eveningEndHour: Scalars['Int'];
  nightStartHour: Scalars['Int'];
  nightEndHour: Scalars['Int'];
};

export enum BoreholeConfirmationType {
  BasedOnModeling = 'BasedOnModeling',
  BasedOnInherentValues = 'BasedOnInherentValues',
  NoConfirmation = 'NoConfirmation'
}

export type BoreholeFieldConfirmation = {
  __typename?: 'BoreholeFieldConfirmation';
  id: Scalars['ID'];
  type: BoreholeConfirmationType;
  date: Scalars['DateTime'];
  confirmer: User;
  data: BoreholeFieldConfirmationData;
};

export type BoreholeFieldConfirmationData = {
  __typename?: 'BoreholeFieldConfirmationData';
  holeCount: Scalars['Int'];
  holeDepth: Scalars['Float'];
  holeUsageForHeatingMonthlyTotal?: Maybe<Array<Scalars['Float']>>;
  holeUsageForHeatingMonthlyMax?: Maybe<Array<Scalars['Float']>>;
  holeUsageForCoolingMonthlyTotal?: Maybe<Array<Scalars['Float']>>;
  holeUsageForCoolingMonthlyMax?: Maybe<Array<Scalars['Float']>>;
};

export type BoreholeFieldConfirmationDataInput = {
  holeCount: Scalars['Int'];
  holeDepth: Scalars['Float'];
  holeUsageForHeatingMonthlyTotal?: Maybe<Array<Scalars['Float']>>;
  holeUsageForHeatingMonthlyMax?: Maybe<Array<Scalars['Float']>>;
  holeUsageForCoolingMonthlyTotal?: Maybe<Array<Scalars['Float']>>;
  holeUsageForCoolingMonthlyMax?: Maybe<Array<Scalars['Float']>>;
};

export type BoreholeFieldConfirmationInput = {
  type: BoreholeConfirmationType;
  data: BoreholeFieldConfirmationDataInput;
};

export type BoreholeFieldContainerInput = {
  holeCount?: Maybe<Scalars['Int']>;
  holeDepth?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  modelingInformation?: Maybe<Scalars['String']>;
  pathToSimulation?: Maybe<Scalars['String']>;
  confirmationType?: Maybe<BoreholeConfirmationType>;
  confirmation?: Maybe<BoreholeFieldConfirmationInput>;
};

export type Building = {
  __typename?: 'Building';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  holeCount: Scalars['Int'];
  holeDepth: Scalars['Float'];
  description: Scalars['String'];
  modelingInformation: Scalars['String'];
  pathToSimulation: Scalars['String'];
  confirmationType: BoreholeConfirmationType;
  confirmation?: Maybe<BoreholeFieldConfirmation>;
  projectVersion: ProjectVersion;
  providers: Array<Provider>;
  demands: Array<Demand>;
  parts: Array<HourSeriesCollection>;
  emissions: Array<Emission>;
  name: Scalars['String'];
  area: Scalars['Float'];
  type: BuildingType;
  multiplier: Scalars['Float'];
};

export type BuildingEnergyModel = {
  __typename?: 'BuildingEnergyModel';
  id: Scalars['ID'];
  project: Project;
  energySystems: Array<EnergySystem>;
  schedules: Array<Schedule>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  area: Scalars['Float'];
  type: BuildingType;
  correctionFactors?: Maybe<Array<BemCorrectionFactorsData>>;
  calibrationDescription?: Maybe<Scalars['String']>;
  calibrationArea?: Maybe<Scalars['Float']>;
  calibrationCorrection?: Maybe<Scalars['Float']>;
  calibrationStart?: Maybe<Scalars['DateTime']>;
  calOutdoorHourSeries?: Maybe<HourSeries>;
  calHeatingHourSeries?: Maybe<HourSeries>;
  calElectricityHourSeries?: Maybe<HourSeries>;
  calCoolingHourSeries?: Maybe<HourSeries>;
  calibrationWeeklyProfile?: Maybe<Array<OnOff>>;
  calibrationMonthlyProfile?: Maybe<Array<OnOff>>;
  calibrationLimitValues?: Maybe<BemLimitValuesData>;
};

export enum BuildingType {
  DetachedHouse = 'DetachedHouse',
  ApartmentBuilding = 'ApartmentBuilding',
  OfficeBuilding = 'OfficeBuilding',
  CommercialBuilding = 'CommercialBuilding',
  School = 'School',
  Hotel = 'Hotel',
  SportsCenter = 'SportsCenter',
  SwimmingPool = 'SwimmingPool',
  IceSkatingHall = 'IceSkatingHall',
  Hospital = 'Hospital',
  HybridBuilding = 'HybridBuilding',
  Other = 'Other'
}

export type CirculationHeatPumpParameters = ProviderParameters & {
  __typename?: 'CirculationHeatPumpParameters';
  isWasteSold?: Maybe<Scalars['Boolean']>;
  cop: Scalars['Float'];
  maxPower: Scalars['Float'];
};

export type CirculationHeatPumpParametersInput = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
  cop: Scalars['Float'];
  maxPower: Scalars['Float'];
};

export type Comment = {
  __typename?: 'Comment';
  id: Scalars['ID'];
  project?: Maybe<Project>;
  projectVersion?: Maybe<ProjectVersion>;
  relationType: CommentRelationType;
  locationType: CommentLocationType;
  text: Scalars['String'];
};

export enum CommentLocationType {
  EnergyCalculation = 'EnergyCalculation',
  Costs = 'Costs',
  CarbonFootprint = 'CarbonFootprint',
  FinnishEer = 'FinnishEer'
}

export enum CommentRelationType {
  ProjectSpecific = 'ProjectSpecific',
  VersionSpecific = 'VersionSpecific'
}

export enum ConsumptionEnergyType {
  DhwCirculationHeating = 'DhwCirculationHeating',
  DhwHeating = 'DhwHeating',
  VentilationHeating = 'VentilationHeating',
  SpaceHeating = 'SpaceHeating',
  AhuCooling = 'AhuCooling',
  SpaceCooling = 'SpaceCooling',
  SystemCooling = 'SystemCooling',
  BaseLoadElectricity = 'BaseLoadElectricity',
  VentilationElectricity = 'VentilationElectricity',
  LightingElectricity = 'LightingElectricity',
  AppliancesElectricity = 'AppliancesElectricity',
  OccupantsElectricity = 'OccupantsElectricity',
  PropertyElectricity = 'PropertyElectricity',
  WasteWaterHeatRecovery = 'WasteWaterHeatRecovery',
  ExhaustAirHeatPumpPotential = 'ExhaustAirHeatPumpPotential'
}

export type CoolingAirHeatPumpParameters = ProviderParameters & {
  __typename?: 'CoolingAirHeatPumpParameters';
  isWasteSold?: Maybe<Scalars['Boolean']>;
  eer: Scalars['Float'];
  maxPower: Scalars['Float'];
  freeCooling: Scalars['Boolean'];
  freeCoolingMaxOutdoorTemperature?: Maybe<Scalars['Float']>;
  freeCoolingEer?: Maybe<Scalars['Float']>;
  freeCoolingMaxPower?: Maybe<Scalars['Float']>;
};

export type CoolingAirHeatPumpParametersInput = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
  eer: Scalars['Float'];
  maxPower: Scalars['Float'];
  freeCooling: Scalars['Boolean'];
  freeCoolingMaxOutdoorTemperature?: Maybe<Scalars['Float']>;
  freeCoolingEer?: Maybe<Scalars['Float']>;
  freeCoolingMaxPower?: Maybe<Scalars['Float']>;
};

export type CoolingGroundHeatPumpParameters = ProviderParameters & {
  __typename?: 'CoolingGroundHeatPumpParameters';
  isWasteSold?: Maybe<Scalars['Boolean']>;
  eer: Scalars['Float'];
  maxPower: Scalars['Float'];
  freeCooling: Scalars['Boolean'];
  freeCoolingEer?: Maybe<Scalars['Float']>;
  freeCoolingMaxPower?: Maybe<Scalars['Float']>;
};

export type CoolingGroundHeatPumpParametersInput = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
  eer: Scalars['Float'];
  maxPower: Scalars['Float'];
  freeCooling: Scalars['Boolean'];
  freeCoolingEer?: Maybe<Scalars['Float']>;
  freeCoolingMaxPower?: Maybe<Scalars['Float']>;
};

export type CoolingParameters = EnergySystemParameters & {
  __typename?: 'CoolingParameters';
  _?: Maybe<Scalars['String']>;
  systemCoolingPower: Scalars['Float'];
  scStartTemp: Scalars['Float'];
  scIncreaseSlope: Scalars['Float'];
  scIncreaseExtraCoef: Scalars['Float'];
  scExtraCoefStartTemp: Scalars['Float'];
  scDistributionEfficiency: Scalars['Float'];
  scSpacesPortion: Scalars['Float'];
  acDemandDisplacementConstant: Scalars['Float'];
  acCorrectionCoef: Scalars['Float'];
  acIncreaseExtraCoef: Scalars['Float'];
  acExtraCoefStartTemp: Scalars['Float'];
  acDistributionEfficiency: Scalars['Float'];
};

export type CoolingParametersInput = {
  _?: Maybe<Scalars['String']>;
  systemCoolingPower: Scalars['Float'];
  scStartTemp: Scalars['Float'];
  scIncreaseSlope: Scalars['Float'];
  scIncreaseExtraCoef: Scalars['Float'];
  scExtraCoefStartTemp: Scalars['Float'];
  scDistributionEfficiency: Scalars['Float'];
  scSpacesPortion: Scalars['Float'];
  acDemandDisplacementConstant: Scalars['Float'];
  acCorrectionCoef: Scalars['Float'];
  acIncreaseExtraCoef: Scalars['Float'];
  acExtraCoefStartTemp: Scalars['Float'];
  acDistributionEfficiency: Scalars['Float'];
};

export type Cost = {
  __typename?: 'Cost';
  id: Scalars['ID'];
  projectVersion: ProjectVersion;
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['String']>;
  costType: CostType;
  recurrencePeriodInYears?: Maybe<Scalars['Int']>;
  occurrenceYear?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  value: Scalars['Float'];
  description: Scalars['String'];
};

export enum CostType {
  Initial = 'Initial',
  Upkeep = 'Upkeep',
  Renewal = 'Renewal',
  OtherOneTime = 'OtherOneTime',
  OtherRecurring = 'OtherRecurring',
  OtherAnnual = 'OtherAnnual'
}

export type CreateBuildingEnergyModelInput = {
  name: Scalars['String'];
  area: Scalars['Float'];
  type: BuildingType;
  correctionFactors?: Maybe<Array<BemCorrectionFactorsDataInput>>;
  calibrationDescription?: Maybe<Scalars['String']>;
  calibrationArea?: Maybe<Scalars['Float']>;
  calibrationCorrection?: Maybe<Scalars['Float']>;
  calibrationStart?: Maybe<Scalars['DateTime']>;
  calOutdoorHourSeriesId?: Maybe<Scalars['String']>;
  calHeatingHourSeriesId?: Maybe<Scalars['String']>;
  calElectricityHourSeriesId?: Maybe<Scalars['String']>;
  calCoolingHourSeriesId?: Maybe<Scalars['String']>;
  calibrationWeeklyProfile?: Maybe<Array<OnOff>>;
  calibrationMonthlyProfile?: Maybe<Array<OnOff>>;
  calibrationLimitValues?: Maybe<BemLimitValuesDataInput>;
};

export type CreateBuildingInput = {
  name: Scalars['String'];
  area: Scalars['Float'];
  type: BuildingType;
  multiplier: Scalars['Float'];
  createdParts: Array<CreateBuildingPartInput>;
  demandHourSeriesIds: Array<Scalars['String']>;
};

export type CreateBuildingPartInput = {
  templateId: Scalars['ID'];
  area: Scalars['Float'];
};

export type CreateCommentInput = {
  locationType: CommentLocationType;
  text: Scalars['String'];
};

export type CreateCostInput = {
  costType: CostType;
  recurrencePeriodInYears?: Maybe<Scalars['Int']>;
  occurrenceYear?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  value: Scalars['Float'];
  description: Scalars['String'];
};

export type CreateEmissionInput = {
  emissionType: EmissionType;
  value: Scalars['Float'];
};

export type CreateEnergyBusInput = {
  wasteHourSeriesId?: Maybe<Scalars['ID']>;
};

export type CreateEnergySystemInput = {
  name: Scalars['String'];
  type: EnergySystemType;
  scheduleId?: Maybe<Scalars['String']>;
  parameters: AnyEnergySystemParametersInput;
};

export type CreateHourSeriesCollectionInput = {
  hourSeries: Array<HourSeriesDataInput>;
  type: HourSeriesCollectionType;
  name: Scalars['String'];
};

export type CreateLocalGridInput = {
  type: LocalGridType;
};

export type CreatePricingModelInput = {
  name: Scalars['String'];
  buildingYear: Scalars['Int'];
  inspectionLengthInYears: Scalars['Int'];
  yearlyDiscountRate: Scalars['Float'];
  yearlyMaintenanceIncreaseRate: Scalars['Float'];
  prices: Array<PricingModelPriceDataInput>;
  sellingPrices: Array<PricingModelPriceDataInput>;
  priceIncreaseRates: Array<PricingModelPriceDataInput>;
};

export type CreateProjectInput = {
  projectId: Scalars['String'];
  name: Scalars['String'];
  versionName: Scalars['String'];
  calendarYear: Scalars['Int'];
};

export type CreateProjectVersionInput = {
  name: Scalars['String'];
  omitBaseVersion?: Maybe<Scalars['Boolean']>;
};

export type CreateProviderInput = {
  name: Scalars['String'];
  type: ProviderType;
  parameters: AnyProviderParametersInput;
  hourSeriesIds: Array<Scalars['String']>;
  performanceTableIds: Array<Scalars['String']>;
  temperatureCurveIds: Array<Scalars['String']>;
  demands: Array<ProviderDemandInput>;
  providesElectricityForProviders: Scalars['Boolean'];
};

export type CreateScheduleInput = {
  name: Scalars['String'];
  hourlyProfiles: Array<ScheduleHourlyProfileDataInput>;
  weeklyProfile: ScheduleWeeklyProfileDataInput;
  monthlyProfile: ScheduleMonthlyProfileDataInput;
  exceptionData: ScheduleExceptionDataInput;
};

export type CreateTemperatureCurveInput = {
  name: Scalars['String'];
  table: Array<TemperatureCurveRowInput>;
};

export type CreateUserGroupInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  userIds: Array<Scalars['ID']>;
};


export enum DayProfileType {
  Off = 'Off',
  Normal = 'Normal',
  Always = 'Always',
  Exception = 'Exception'
}

export type Demand = {
  __typename?: 'Demand';
  id: Scalars['ID'];
  hourSeries: HourSeries;
  building: Building;
  providers: Array<ProviderDemand>;
  type: DemandType;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export enum DemandType {
  Heating = 'Heating',
  Cooling = 'Cooling',
  Electricity = 'Electricity',
  HeatingDensity = 'HeatingDensity',
  CoolingDensity = 'CoolingDensity',
  ElectricityDensity = 'ElectricityDensity'
}

export enum DhwHeatingMode {
  PreheatAlways = 'PreheatAlways',
  PreheatOnHeatingSeason = 'PreheatOnHeatingSeason',
  HeatAlways = 'HeatAlways'
}

export type DomesticHotWaterParameters = EnergySystemParameters & {
  __typename?: 'DomesticHotWaterParameters';
  _?: Maybe<Scalars['String']>;
  consumptionDensity: Scalars['Float'];
  distributionEfficiency: Scalars['Float'];
  consumptionFactor: Scalars['Float'];
  circulationSpecificLength: Scalars['Float'];
  circulationSpecificHeatLoss: Scalars['Float'];
  circulationHeatersAmount: Scalars['Int'];
  circulationHeatersPower: Scalars['Float'];
  wasteWaterHeatContentRatio: Scalars['Float'];
};

export type DomesticHotWaterParametersInput = {
  _?: Maybe<Scalars['String']>;
  consumptionDensity: Scalars['Float'];
  distributionEfficiency: Scalars['Float'];
  consumptionFactor: Scalars['Float'];
  circulationSpecificLength: Scalars['Float'];
  circulationSpecificHeatLoss: Scalars['Float'];
  circulationHeatersAmount: Scalars['Int'];
  circulationHeatersPower: Scalars['Float'];
  wasteWaterHeatContentRatio: Scalars['Float'];
};

export type ElectricityConsumptionParameters = EnergySystemParameters & {
  __typename?: 'ElectricityConsumptionParameters';
  _?: Maybe<Scalars['String']>;
  electricityBaseLoad: Scalars['Float'];
  occupantLightingElShare: Scalars['Float'];
  occupantApplianceElShare: Scalars['Float'];
  occupantVentilationElShare: Scalars['Float'];
  occupantBaseLoadElShare: Scalars['Float'];
};

export type ElectricityConsumptionParametersInput = {
  electricityBaseLoad: Scalars['Float'];
  baseLoadScheduleId?: Maybe<Scalars['String']>;
  occupantLightingElShare: Scalars['Float'];
  occupantApplianceElShare: Scalars['Float'];
  occupantVentilationElShare: Scalars['Float'];
  occupantBaseLoadElShare: Scalars['Float'];
};

export type Emission = {
  __typename?: 'Emission';
  id: Scalars['ID'];
  projectVersion: ProjectVersion;
  building: Building;
  buildingId: Scalars['String'];
  emissionType: EmissionType;
  value: Scalars['Float'];
};

export enum EmissionType {
  Energy = 'Energy',
  Initial = 'Initial',
  Recurring = 'Recurring',
  Maintenance = 'Maintenance',
  Disassembly = 'Disassembly',
  Handprint = 'Handprint'
}

export type EnergyBus = {
  __typename?: 'EnergyBus';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  holeCount: Scalars['Int'];
  holeDepth: Scalars['Float'];
  description: Scalars['String'];
  modelingInformation: Scalars['String'];
  pathToSimulation: Scalars['String'];
  confirmationType: BoreholeConfirmationType;
  confirmation?: Maybe<BoreholeFieldConfirmation>;
  projectVersion: ProjectVersion;
  wasteHourSeries?: Maybe<HourSeries>;
};

export type EnergySystem = {
  __typename?: 'EnergySystem';
  id: Scalars['ID'];
  name: Scalars['String'];
  buildingEnergyModel: BuildingEnergyModel;
  type: EnergySystemType;
  parameters: EnergySystemParameters;
  schedule?: Maybe<Schedule>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type EnergySystemParameters = {
  _?: Maybe<Scalars['String']>;
};

export enum EnergySystemType {
  DomesticHotWater = 'DomesticHotWater',
  Ventilation = 'Ventilation',
  Cooling = 'Cooling',
  HeatLoad = 'HeatLoad',
  ElectricityConsumption = 'ElectricityConsumption',
  SpaceHeating = 'SpaceHeating'
}

export enum FuelType {
  NaturalGas = 'NaturalGas',
  WoodPellet = 'WoodPellet',
  Oil = 'Oil',
  BioOil = 'BioOil'
}

export type HeatBoilerParameters = ProviderParameters & {
  __typename?: 'HeatBoilerParameters';
  isWasteSold?: Maybe<Scalars['Boolean']>;
  efficiency: Scalars['Float'];
  fuelType: FuelType;
};

export type HeatBoilerParametersInput = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
  efficiency: Scalars['Float'];
  fuelType: FuelType;
};

export type HeatCircuit = {
  __typename?: 'HeatCircuit';
  demandId: Scalars['String'];
  temperatureCurveId: Scalars['String'];
  isDhwCircuit: Scalars['Boolean'];
};

export type HeatCircuitInput = {
  demandId: Scalars['String'];
  temperatureCurveId: Scalars['String'];
  isDhwCircuit: Scalars['Boolean'];
};

export type HeatLoadParameters = EnergySystemParameters & {
  __typename?: 'HeatLoadParameters';
  _?: Maybe<Scalars['String']>;
  occupantHeatLoad: Scalars['Float'];
  occupantHeatLoadUtilFactor: Scalars['Float'];
  occupantScheduleId?: Maybe<Scalars['String']>;
  applianceHeatLoad: Scalars['Float'];
  applianceHeatLoadUtilFactor: Scalars['Float'];
  applianceScheduleId?: Maybe<Scalars['String']>;
  lightingHeatLoad: Scalars['Float'];
  lightingHeatLoadUtilFactor: Scalars['Float'];
  lightingScheduleId?: Maybe<Scalars['String']>;
  heatLoadUtilStartTemp: Scalars['Float'];
  affectingSpaceHeatingStartTemp: Scalars['Float'];
};

export type HeatLoadParametersInput = {
  _?: Maybe<Scalars['String']>;
  occupantHeatLoad: Scalars['Float'];
  occupantHeatLoadUtilFactor: Scalars['Float'];
  occupantScheduleId?: Maybe<Scalars['String']>;
  applianceHeatLoad: Scalars['Float'];
  applianceHeatLoadUtilFactor: Scalars['Float'];
  applianceScheduleId?: Maybe<Scalars['String']>;
  lightingHeatLoad: Scalars['Float'];
  lightingHeatLoadUtilFactor: Scalars['Float'];
  lightingScheduleId?: Maybe<Scalars['String']>;
  heatLoadUtilStartTemp: Scalars['Float'];
  affectingSpaceHeatingStartTemp: Scalars['Float'];
};

export type HeatingAirHeatPumpParameters = ProviderParameters & {
  __typename?: 'HeatingAirHeatPumpParameters';
  isWasteSold?: Maybe<Scalars['Boolean']>;
  cop: Scalars['Float'];
  maxPower: Scalars['Float'];
  minOutdoorTemperature: Scalars['Float'];
};

export type HeatingAirHeatPumpParametersInput = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
  cop: Scalars['Float'];
  maxPower: Scalars['Float'];
  minOutdoorTemperature: Scalars['Float'];
};

export type HeatingGroundHeatPumpParameters = ProviderParameters & {
  __typename?: 'HeatingGroundHeatPumpParameters';
  isWasteSold?: Maybe<Scalars['Boolean']>;
  cop: Scalars['Float'];
  maxPower: Scalars['Float'];
};

export type HeatingGroundHeatPumpParametersInput = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
  cop: Scalars['Float'];
  maxPower: Scalars['Float'];
};

export enum HeatingOrCoolingSource {
  None = 'None',
  Ground = 'Ground',
  Air = 'Air',
  EnergyBus = 'EnergyBus'
}

export type HourSeries = {
  __typename?: 'HourSeries';
  id: Scalars['ID'];
  collection: HourSeriesCollection;
  type: HourSeriesType;
  name: Scalars['String'];
  values: Array<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  calOutdoorHourSeriesBems: Array<BuildingEnergyModel>;
  calHeatingHourSeriesBems: Array<BuildingEnergyModel>;
  calElectricityHourSeriesBems: Array<BuildingEnergyModel>;
  calCoolingHourSeriesBems: Array<BuildingEnergyModel>;
  isInUse: Scalars['Boolean'];
};

export type HourSeriesCollection = {
  __typename?: 'HourSeriesCollection';
  id: Scalars['ID'];
  project?: Maybe<Project>;
  building?: Maybe<Building>;
  hourSeries: Array<HourSeries>;
  type: HourSeriesCollectionType;
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  originalGlobalCollection?: Maybe<HourSeriesCollection>;
  partArea?: Maybe<Scalars['Float']>;
  isInUse: Scalars['Boolean'];
};

export enum HourSeriesCollectionType {
  Global = 'Global',
  ProjectSpecific = 'ProjectSpecific',
  BuildingPart = 'BuildingPart',
  AutogeneratedForTemperatures = 'AutogeneratedForTemperatures'
}

export type HourSeriesDataInput = {
  name: Scalars['String'];
  type: HourSeriesType;
  values: Array<Scalars['Float']>;
};

export enum HourSeriesType {
  HeatingDemand = 'HeatingDemand',
  CoolingDemand = 'CoolingDemand',
  ElectricityDemand = 'ElectricityDemand',
  MeasuredHeatingDemand = 'MeasuredHeatingDemand',
  MeasuredCoolingDemand = 'MeasuredCoolingDemand',
  MeasuredElectricityDemand = 'MeasuredElectricityDemand',
  HeatingDemandDensity = 'HeatingDemandDensity',
  CoolingDemandDensity = 'CoolingDemandDensity',
  ElectricityDemandDensity = 'ElectricityDemandDensity',
  OutdoorTemperature = 'OutdoorTemperature',
  MeasuredOutdoorTemperature = 'MeasuredOutdoorTemperature',
  SolarPanelRatedPowerDensity = 'SolarPanelRatedPowerDensity',
  WasteHeating = 'WasteHeating',
  Other = 'Other'
}

export type HybridHeatPumpParameters = ProviderParameters & {
  __typename?: 'HybridHeatPumpParameters';
  isWasteSold?: Maybe<Scalars['Boolean']>;
  performanceTableId: Scalars['String'];
  copModifier: Scalars['Float'];
  heatSourceAvailable: Scalars['Boolean'];
  heatExhaustAvailable: Scalars['Boolean'];
  heatRecycleAvailable: Scalars['Boolean'];
  heatingPower: Scalars['Float'];
  heatingTemperatureCurveId?: Maybe<Scalars['String']>;
  dhwHeatingMode?: Maybe<DhwHeatingMode>;
  heatCircuits?: Maybe<Array<HeatCircuit>>;
  coolingTemperatureCurveId?: Maybe<Scalars['String']>;
  baseHeatSource?: Maybe<HeatingOrCoolingSource>;
  groundHeatSourceTemperature?: Maybe<Scalars['Float']>;
  groundHeatSourceMaxPower?: Maybe<Scalars['Float']>;
  airHeatSourceMinTemperature?: Maybe<Scalars['Float']>;
  wasteHeatSourceAHourSeriesId?: Maybe<Scalars['String']>;
  wasteHeatSourceATemperature?: Maybe<Scalars['Float']>;
  wasteHeatSourceBHourSeriesId?: Maybe<Scalars['String']>;
  wasteHeatSourceBTemperature?: Maybe<Scalars['Float']>;
  freeCoolingSource?: Maybe<HeatingOrCoolingSource>;
  freeGroundCoolingMaxPower?: Maybe<Scalars['Float']>;
  freeAirCoolingMaxTemperature?: Maybe<Scalars['Float']>;
  freeCoolingEer?: Maybe<Scalars['Float']>;
  coolingSource?: Maybe<HeatingOrCoolingSource>;
  groundExhaustTemperature?: Maybe<Scalars['Float']>;
};

export type HybridHeatPumpParametersInput = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
  performanceTableId: Scalars['String'];
  copModifier: Scalars['Float'];
  heatSourceAvailable: Scalars['Boolean'];
  heatExhaustAvailable: Scalars['Boolean'];
  heatRecycleAvailable: Scalars['Boolean'];
  heatingPower: Scalars['Float'];
  heatingTemperatureCurveId?: Maybe<Scalars['String']>;
  dhwHeatingMode?: Maybe<DhwHeatingMode>;
  heatCircuits?: Maybe<Array<HeatCircuitInput>>;
  coolingTemperatureCurveId?: Maybe<Scalars['String']>;
  baseHeatSource?: Maybe<HeatingOrCoolingSource>;
  groundHeatSourceTemperature?: Maybe<Scalars['Float']>;
  groundHeatSourceMaxPower?: Maybe<Scalars['Float']>;
  airHeatSourceMinTemperature?: Maybe<Scalars['Float']>;
  wasteHeatSourceAHourSeriesId?: Maybe<Scalars['String']>;
  wasteHeatSourceATemperature?: Maybe<Scalars['Float']>;
  wasteHeatSourceBHourSeriesId?: Maybe<Scalars['String']>;
  wasteHeatSourceBTemperature?: Maybe<Scalars['Float']>;
  freeCoolingSource?: Maybe<HeatingOrCoolingSource>;
  freeGroundCoolingMaxPower?: Maybe<Scalars['Float']>;
  freeAirCoolingMaxTemperature?: Maybe<Scalars['Float']>;
  freeCoolingEer?: Maybe<Scalars['Float']>;
  coolingSource?: Maybe<HeatingOrCoolingSource>;
  groundExhaustTemperature?: Maybe<Scalars['Float']>;
};

export type InefficientParameters = ProviderParameters & {
  __typename?: 'InefficientParameters';
  isWasteSold?: Maybe<Scalars['Boolean']>;
  efficiency: Scalars['Float'];
};

export type InefficientParametersInput = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
  efficiency: Scalars['Float'];
};

export type LocalGrid = {
  __typename?: 'LocalGrid';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  holeCount: Scalars['Int'];
  holeDepth: Scalars['Float'];
  description: Scalars['String'];
  modelingInformation: Scalars['String'];
  pathToSimulation: Scalars['String'];
  confirmationType: BoreholeConfirmationType;
  confirmation?: Maybe<BoreholeFieldConfirmation>;
  projectVersion: ProjectVersion;
  providers: Array<Provider>;
  type: LocalGridType;
};

export enum LocalGridType {
  Water = 'Water',
  Electricity = 'Electricity'
}

export type Mutation = {
  __typename?: 'Mutation';
  createProject: Project;
  updateProject: Project;
  deleteProject: Scalars['Boolean'];
  restoreProject: Scalars['Boolean'];
  createProjectVersion: ProjectVersion;
  updateProjectVersion: ProjectVersion;
  deleteProjectVersion: Array<ProjectVersion>;
  updateUser: User;
  createUserGroup: UserGroup;
  updateUserGroup: UserGroup;
  deleteUserGroup: Scalars['Boolean'];
  createHourSeriesCollections: Array<HourSeriesCollection>;
  createHourSeriesCollection: HourSeriesCollection;
  updateHourSeriesCollection: HourSeriesCollection;
  deleteHourSeriesCollection: Scalars['Boolean'];
  createGlobalHourSeriesCollections: Array<HourSeriesCollection>;
  createBuilding: Building;
  updateBuilding: Building;
  updateBuildingBoreholeField: Building;
  deleteBuilding: Scalars['Boolean'];
  createBuildingEnergyModel: BuildingEnergyModel;
  updateBuildingEnergyModel: BuildingEnergyModel;
  deleteBuildingEnergyModel: Scalars['Boolean'];
  createLocalGrid: LocalGrid;
  updateLocalGrid: LocalGrid;
  updateLocalGridBoreholeField: LocalGrid;
  deleteLocalGrid: Scalars['Boolean'];
  createEnergyBus: EnergyBus;
  updateEnergyBus: EnergyBus;
  updateEnergyBusBoreholeField: EnergyBus;
  deleteEnergyBus: Scalars['Boolean'];
  createProvider: Provider;
  updateProvider: Provider;
  deleteProvider: Scalars['Boolean'];
  createProjectSpecificTemperatureCurve: TemperatureCurve;
  updateTemperatureCurve: TemperatureCurve;
  deleteTemperatureCurve: Scalars['Boolean'];
  createGlobalPricingModel: PricingModel;
  createPricingModel: PricingModel;
  updatePricingModel: PricingModel;
  deletePricingModel: Scalars['Boolean'];
  createCost: Cost;
  updateCost: Cost;
  deleteCost: Scalars['Boolean'];
  createEmission: Emission;
  updateEmission: Emission;
  deleteEmission: Scalars['Boolean'];
  createComment: Comment;
  updateComment: Comment;
  deleteComment: Scalars['Boolean'];
  createEnergySystem: EnergySystem;
  updateEnergySystem: EnergySystem;
  deleteEnergySystem: Scalars['Boolean'];
  createSchedule: Schedule;
  updateSchedule: Schedule;
  deleteSchedule: Scalars['Boolean'];
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationUpdateProjectArgs = {
  id: Scalars['String'];
  input: UpdateProjectInput;
};


export type MutationDeleteProjectArgs = {
  id: Scalars['String'];
};


export type MutationRestoreProjectArgs = {
  id: Scalars['String'];
};


export type MutationCreateProjectVersionArgs = {
  projectId: Scalars['String'];
  input: CreateProjectVersionInput;
  copyOfVersionId?: Maybe<Scalars['String']>;
};


export type MutationUpdateProjectVersionArgs = {
  id: Scalars['String'];
  input: UpdateProjectVersionInput;
};


export type MutationDeleteProjectVersionArgs = {
  id: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  id: Scalars['String'];
  input: UserInput;
};


export type MutationCreateUserGroupArgs = {
  input: CreateUserGroupInput;
};


export type MutationUpdateUserGroupArgs = {
  id: Scalars['String'];
  input: UpdateUserGroupInput;
};


export type MutationDeleteUserGroupArgs = {
  id: Scalars['String'];
};


export type MutationCreateHourSeriesCollectionsArgs = {
  projectId: Scalars['String'];
  hourSeriesFile: Scalars['Upload'];
  shouldOverwrite: Scalars['Boolean'];
};


export type MutationCreateHourSeriesCollectionArgs = {
  projectId: Scalars['String'];
  input: CreateHourSeriesCollectionInput;
  shouldOverwrite: Scalars['Boolean'];
};


export type MutationUpdateHourSeriesCollectionArgs = {
  id: Scalars['String'];
  input: UpdateHourSeriesCollectionInput;
};


export type MutationDeleteHourSeriesCollectionArgs = {
  id: Scalars['String'];
};


export type MutationCreateGlobalHourSeriesCollectionsArgs = {
  hourSeriesFile: Scalars['Upload'];
  shouldOverwrite: Scalars['Boolean'];
};


export type MutationCreateBuildingArgs = {
  projectVersionId: Scalars['String'];
  input: CreateBuildingInput;
};


export type MutationUpdateBuildingArgs = {
  id: Scalars['String'];
  input: UpdateBuildingInput;
};


export type MutationUpdateBuildingBoreholeFieldArgs = {
  id: Scalars['String'];
  input: BoreholeFieldContainerInput;
};


export type MutationDeleteBuildingArgs = {
  id: Scalars['String'];
};


export type MutationCreateBuildingEnergyModelArgs = {
  projectId: Scalars['String'];
  input: CreateBuildingEnergyModelInput;
};


export type MutationUpdateBuildingEnergyModelArgs = {
  id: Scalars['String'];
  input: UpdateBuildingEnergyModelInput;
};


export type MutationDeleteBuildingEnergyModelArgs = {
  id: Scalars['String'];
};


export type MutationCreateLocalGridArgs = {
  projectVersionId: Scalars['String'];
  input: CreateLocalGridInput;
};


export type MutationUpdateLocalGridArgs = {
  id: Scalars['String'];
  input: UpdateLocalGridInput;
};


export type MutationUpdateLocalGridBoreholeFieldArgs = {
  id: Scalars['String'];
  input: BoreholeFieldContainerInput;
};


export type MutationDeleteLocalGridArgs = {
  id: Scalars['String'];
};


export type MutationCreateEnergyBusArgs = {
  projectVersionId: Scalars['String'];
  input: CreateEnergyBusInput;
};


export type MutationUpdateEnergyBusArgs = {
  id: Scalars['String'];
  input: UpdateEnergyBusInput;
};


export type MutationUpdateEnergyBusBoreholeFieldArgs = {
  id: Scalars['String'];
  input: BoreholeFieldContainerInput;
};


export type MutationDeleteEnergyBusArgs = {
  id: Scalars['String'];
};


export type MutationCreateProviderArgs = {
  buildingId?: Maybe<Scalars['String']>;
  localGridId?: Maybe<Scalars['String']>;
  input: CreateProviderInput;
};


export type MutationUpdateProviderArgs = {
  id: Scalars['String'];
  input: UpdateProviderInput;
};


export type MutationDeleteProviderArgs = {
  id: Scalars['String'];
};


export type MutationCreateProjectSpecificTemperatureCurveArgs = {
  input: CreateTemperatureCurveInput;
  projectId: Scalars['String'];
};


export type MutationUpdateTemperatureCurveArgs = {
  id: Scalars['String'];
  input: UpdateTemperatureCurveInput;
};


export type MutationDeleteTemperatureCurveArgs = {
  id: Scalars['String'];
};


export type MutationCreateGlobalPricingModelArgs = {
  input: CreatePricingModelInput;
};


export type MutationCreatePricingModelArgs = {
  projectId: Scalars['String'];
  input: CreatePricingModelInput;
};


export type MutationUpdatePricingModelArgs = {
  id: Scalars['String'];
  input: UpdatePricingModelInput;
};


export type MutationDeletePricingModelArgs = {
  id: Scalars['String'];
};


export type MutationCreateCostArgs = {
  projectVersionId: Scalars['String'];
  input: CreateCostInput;
  providerId?: Maybe<Scalars['String']>;
};


export type MutationUpdateCostArgs = {
  id: Scalars['String'];
  input: UpdateCostInput;
};


export type MutationDeleteCostArgs = {
  id: Scalars['String'];
};


export type MutationCreateEmissionArgs = {
  input: CreateEmissionInput;
  buildingId: Scalars['String'];
};


export type MutationUpdateEmissionArgs = {
  id: Scalars['String'];
  input: UpdateEmissionInput;
};


export type MutationDeleteEmissionArgs = {
  id: Scalars['String'];
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
  projectId?: Maybe<Scalars['String']>;
  projectVersionId?: Maybe<Scalars['String']>;
};


export type MutationUpdateCommentArgs = {
  id: Scalars['String'];
  input: UpdateCommentInput;
};


export type MutationDeleteCommentArgs = {
  id: Scalars['String'];
};


export type MutationCreateEnergySystemArgs = {
  buildingEnergyModelId: Scalars['String'];
  input: CreateEnergySystemInput;
};


export type MutationUpdateEnergySystemArgs = {
  id: Scalars['String'];
  input: UpdateEnergySystemInput;
};


export type MutationDeleteEnergySystemArgs = {
  id: Scalars['String'];
};


export type MutationCreateScheduleArgs = {
  buildingEnergyModelId: Scalars['String'];
  input: CreateScheduleInput;
};


export type MutationUpdateScheduleArgs = {
  id: Scalars['String'];
  input: UpdateScheduleInput;
};


export type MutationDeleteScheduleArgs = {
  id: Scalars['String'];
};

export enum OnOff {
  Off = 'Off',
  On = 'On'
}

export type PerformanceTable = {
  __typename?: 'PerformanceTable';
  id: Scalars['ID'];
  name: Scalars['String'];
  copTable: Array<PerformanceTableRow>;
  powerCoefficientTable: Array<PerformanceTableRow>;
};

export type PerformanceTableColumn = {
  __typename?: 'PerformanceTableColumn';
  condenserTemperature: Scalars['Float'];
  value: Scalars['Float'];
};

export type PerformanceTableRow = {
  __typename?: 'PerformanceTableRow';
  evaporatorTemperature: Scalars['Float'];
  columns: Array<PerformanceTableColumn>;
};

export type PreheaterParameters = ProviderParameters & {
  __typename?: 'PreheaterParameters';
  isWasteSold?: Maybe<Scalars['Boolean']>;
  relativePower: Scalars['Float'];
};

export type PreheaterParametersInput = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
  relativePower: Scalars['Float'];
};

export type PricingModel = {
  __typename?: 'PricingModel';
  id: Scalars['ID'];
  project?: Maybe<Project>;
  usedInVersions: Array<ProjectVersion>;
  type: PricingModelType;
  name: Scalars['String'];
  buildingYear: Scalars['Int'];
  inspectionLengthInYears: Scalars['Int'];
  yearlyDiscountRate: Scalars['Float'];
  yearlyMaintenanceIncreaseRate: Scalars['Float'];
  prices: Array<PricingModelPriceData>;
  sellingPrices: Array<PricingModelPriceData>;
  priceIncreaseRates: Array<PricingModelPriceData>;
};

export type PricingModelPriceData = {
  __typename?: 'PricingModelPriceData';
  energyType: PurchasedEnergyType;
  yearlyValue?: Maybe<Scalars['Float']>;
  monthlyValues?: Maybe<Array<Scalars['Float']>>;
};

export type PricingModelPriceDataInput = {
  energyType: PurchasedEnergyType;
  yearlyValue?: Maybe<Scalars['Float']>;
  monthlyValues?: Maybe<Array<Scalars['Float']>>;
};

export enum PricingModelType {
  Global = 'Global',
  ProjectSpecific = 'ProjectSpecific'
}

export type Project = {
  __typename?: 'Project';
  id: Scalars['ID'];
  userGroup?: Maybe<UserGroup>;
  owner: User;
  hourSeriesCollections: Array<HourSeriesCollection>;
  pricingModels: Array<PricingModel>;
  buildingEnergyModels: Array<BuildingEnergyModel>;
  versions: Array<ProjectVersion>;
  comments: Array<Comment>;
  temperatureHourSeries?: Maybe<HourSeries>;
  temperatureCurves: Array<TemperatureCurve>;
  projectId: Scalars['String'];
  name: Scalars['String'];
  licensePaid: Scalars['Boolean'];
  visibility: ProjectVisibility;
  calendarYear?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  updatedBy: User;
  deletedAt?: Maybe<Scalars['DateTime']>;
};

export type ProjectListFilter = {
  count: Scalars['Int'];
  offset: Scalars['Int'];
  keyword?: Maybe<Scalars['String']>;
  createdAfter?: Maybe<Scalars['DateTime']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
};

export type ProjectListModel = {
  __typename?: 'ProjectListModel';
  totalCount: Scalars['Float'];
  items: Array<Project>;
};

export type ProjectVersion = {
  __typename?: 'ProjectVersion';
  id: Scalars['ID'];
  project: Project;
  pricingModel?: Maybe<PricingModel>;
  buildings: Array<Building>;
  localGrids: Array<LocalGrid>;
  energyBus?: Maybe<EnergyBus>;
  costs: Array<Cost>;
  emissions: Array<Emission>;
  comments: Array<Comment>;
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  isDefault: Scalars['Boolean'];
  baseVersionId?: Maybe<Scalars['ID']>;
};

export enum ProjectVisibility {
  AllUsers = 'AllUsers',
  Self = 'Self',
  UserGroup = 'UserGroup'
}

export type Provider = {
  __typename?: 'Provider';
  id: Scalars['ID'];
  name: Scalars['String'];
  building?: Maybe<Building>;
  localGrid?: Maybe<LocalGrid>;
  localGridId?: Maybe<Scalars['String']>;
  demands: Array<ProviderDemand>;
  hourSeries: Array<HourSeries>;
  performanceTables: Array<PerformanceTable>;
  temperatureCurves: Array<TemperatureCurve>;
  costs: Array<Cost>;
  type: ProviderType;
  parameters: ProviderParameters;
  providesElectricityForProviders: Scalars['Boolean'];
  isFallback: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type ProviderDemand = {
  __typename?: 'ProviderDemand';
  id: Scalars['ID'];
  provider: Provider;
  demand: Demand;
  maxPower?: Maybe<Scalars['Int']>;
  maxPortion: Scalars['Float'];
};

export type ProviderDemandInput = {
  demandId: Scalars['String'];
  maxPower?: Maybe<Scalars['Int']>;
  maxPortion: Scalars['Float'];
};

export type ProviderParameters = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
};

export enum ProviderType {
  DistrictHeating = 'DistrictHeating',
  DistrictCooling = 'DistrictCooling',
  ElectricalGrid = 'ElectricalGrid',
  LocalWaterGrid = 'LocalWaterGrid',
  LocalElectricalGrid = 'LocalElectricalGrid',
  HeatingGroundHeatPump = 'HeatingGroundHeatPump',
  HeatingAirHeatPump = 'HeatingAirHeatPump',
  HeatBoiler = 'HeatBoiler',
  ElectricBoiler = 'ElectricBoiler',
  Preheater = 'Preheater',
  CoolingGroundHeatPump = 'CoolingGroundHeatPump',
  CoolingAirHeatPump = 'CoolingAirHeatPump',
  WaterCoolingHeatPump = 'WaterCoolingHeatPump',
  CirculationHeatPump = 'CirculationHeatPump',
  HybridHeatPump = 'HybridHeatPump',
  SolarPanel = 'SolarPanel',
  Battery = 'Battery'
}

export enum PurchasedEnergyType {
  Heating = 'Heating',
  Cooling = 'Cooling',
  Electricity = 'Electricity',
  Fuel = 'Fuel'
}

export type Query = {
  __typename?: 'Query';
  projects: ProjectListModel;
  project: Project;
  projectVersion: ProjectVersion;
  me: User;
  users: Array<User>;
  userGroups: Array<UserGroup>;
  globalHourSeriesCollections: Array<HourSeriesCollection>;
  performanceTables: Array<PerformanceTable>;
  temperatureCurves: Array<TemperatureCurve>;
  globalPricingModels: Array<PricingModel>;
  pricingModels: Array<PricingModel>;
  getSchedule: Schedule;
};


export type QueryProjectsArgs = {
  filter: ProjectListFilter;
};


export type QueryProjectArgs = {
  id: Scalars['String'];
};


export type QueryProjectVersionArgs = {
  id: Scalars['String'];
};


export type QueryPricingModelsArgs = {
  projectId: Scalars['String'];
};


export type QueryGetScheduleArgs = {
  id: Scalars['String'];
};

export type Schedule = {
  __typename?: 'Schedule';
  id: Scalars['ID'];
  name: Scalars['String'];
  hourlyProfiles?: Maybe<Array<ScheduleHourlyProfileData>>;
  weeklyProfile?: Maybe<ScheduleWeeklyProfileData>;
  monthlyProfile?: Maybe<ScheduleMonthlyProfileData>;
  exceptionData?: Maybe<ScheduleExceptionData>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  buildingEnergyModel: BuildingEnergyModel;
  energySystems: Array<EnergySystem>;
};

export type ScheduleExceptionData = {
  __typename?: 'ScheduleExceptionData';
  inUse: Scalars['Boolean'];
  startAt?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['String']>;
  profileType?: Maybe<DayProfileType>;
};

export type ScheduleExceptionDataInput = {
  inUse: Scalars['Boolean'];
  startAt?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['String']>;
  profileType?: Maybe<DayProfileType>;
};

export type ScheduleHourlyProfileData = {
  __typename?: 'ScheduleHourlyProfileData';
  profileType: DayProfileType;
  values: Array<Scalars['Float']>;
};

export type ScheduleHourlyProfileDataInput = {
  profileType: DayProfileType;
  values: Array<Scalars['Float']>;
};

export type ScheduleMonthlyProfileData = {
  __typename?: 'ScheduleMonthlyProfileData';
  multipliers: Array<Scalars['Float']>;
};

export type ScheduleMonthlyProfileDataInput = {
  multipliers: Array<Scalars['Float']>;
};

export type ScheduleWeeklyProfileData = {
  __typename?: 'ScheduleWeeklyProfileData';
  profileTypes: Array<DayProfileType>;
};

export type ScheduleWeeklyProfileDataInput = {
  profileTypes: Array<DayProfileType>;
};

export type SolarPanelParameters = ProviderParameters & {
  __typename?: 'SolarPanelParameters';
  isWasteSold?: Maybe<Scalars['Boolean']>;
  area: Scalars['Float'];
  solarEfficiency: Scalars['Float'];
  ratingEfficiency: Scalars['Float'];
};

export type SolarPanelParametersInput = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
  area: Scalars['Float'];
  solarEfficiency: Scalars['Float'];
  ratingEfficiency: Scalars['Float'];
};

export type SpaceHeatingParameters = EnergySystemParameters & {
  __typename?: 'SpaceHeatingParameters';
  _?: Maybe<Scalars['String']>;
  exteriorWallArea: Scalars['Float'];
  roofArea: Scalars['Float'];
  baseFloorArea: Scalars['Float'];
  windowsArea: Scalars['Float'];
  doorsArea: Scalars['Float'];
  exteriorWallUvalue: Scalars['Float'];
  roofUvalue: Scalars['Float'];
  baseFloorUvalue: Scalars['Float'];
  windowsUvalue: Scalars['Float'];
  doorsUvalue: Scalars['Float'];
  heatBridgeRatio: Scalars['Float'];
  q50: Scalars['Float'];
  airLeakageXfactor: Scalars['Float'];
  heatSupplyEfficiency: Scalars['Float'];
  basEfficiency: Scalars['Float'];
  affectingHeatLossStartTemp: Scalars['Float'];
  dynamicOutTempWeightFactor: Scalars['Float'];
  heatLossesCorrectionFactor: Scalars['Float'];
  heatLossesCorrectionFactorStartTemp: Scalars['Float'];
  supplyAirHeatingStartTemp: Scalars['Float'];
  supplyAirFullHeatingStartTemp: Scalars['Float'];
};

export type SpaceHeatingParametersInput = {
  _?: Maybe<Scalars['String']>;
  exteriorWallArea: Scalars['Float'];
  roofArea: Scalars['Float'];
  baseFloorArea: Scalars['Float'];
  windowsArea: Scalars['Float'];
  doorsArea: Scalars['Float'];
  exteriorWallUvalue: Scalars['Float'];
  roofUvalue: Scalars['Float'];
  baseFloorUvalue: Scalars['Float'];
  windowsUvalue: Scalars['Float'];
  doorsUvalue: Scalars['Float'];
  heatBridgeRatio: Scalars['Float'];
  q50: Scalars['Float'];
  airLeakageXfactor: Scalars['Float'];
  heatSupplyEfficiency: Scalars['Float'];
  basEfficiency: Scalars['Float'];
  affectingHeatLossStartTemp: Scalars['Float'];
  dynamicOutTempWeightFactor: Scalars['Float'];
  heatLossesCorrectionFactor: Scalars['Float'];
  heatLossesCorrectionFactorStartTemp: Scalars['Float'];
  supplyAirHeatingStartTemp: Scalars['Float'];
  supplyAirFullHeatingStartTemp: Scalars['Float'];
};

export type TemperatureCurve = {
  __typename?: 'TemperatureCurve';
  id: Scalars['ID'];
  name: Scalars['String'];
  table: Array<TemperatureCurveRow>;
  type: TemperatureCurveType;
  project?: Maybe<Project>;
};

export type TemperatureCurveRow = {
  __typename?: 'TemperatureCurveRow';
  outdoor: Scalars['Float'];
  in: Scalars['Float'];
  return: Scalars['Float'];
};

export type TemperatureCurveRowInput = {
  outdoor: Scalars['Float'];
  in: Scalars['Float'];
  return: Scalars['Float'];
};

export enum TemperatureCurveType {
  Global = 'Global',
  ProjectSpecific = 'ProjectSpecific'
}

export type UpdateBuildingEnergyModelInput = {
  name?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['Float']>;
  type?: Maybe<BuildingType>;
  correctionFactors?: Maybe<Array<BemCorrectionFactorsDataInput>>;
  calibrationDescription?: Maybe<Scalars['String']>;
  calibrationArea?: Maybe<Scalars['Float']>;
  calibrationCorrection?: Maybe<Scalars['Float']>;
  calibrationStart?: Maybe<Scalars['DateTime']>;
  calOutdoorHourSeriesId?: Maybe<Scalars['String']>;
  calHeatingHourSeriesId?: Maybe<Scalars['String']>;
  calElectricityHourSeriesId?: Maybe<Scalars['String']>;
  calCoolingHourSeriesId?: Maybe<Scalars['String']>;
  calibrationWeeklyProfile?: Maybe<Array<OnOff>>;
  calibrationMonthlyProfile?: Maybe<Array<OnOff>>;
  calibrationLimitValues?: Maybe<BemLimitValuesDataInput>;
};

export type UpdateBuildingInput = {
  name?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['Float']>;
  type?: Maybe<BuildingType>;
  multiplier?: Maybe<Scalars['Float']>;
  createdParts?: Maybe<Array<CreateBuildingPartInput>>;
  demandHourSeriesIds?: Maybe<Array<Scalars['String']>>;
  updatedParts?: Maybe<Array<UpdateBuildingPartInput>>;
};

export type UpdateBuildingPartInput = {
  area: Scalars['Float'];
  id: Scalars['ID'];
};

export type UpdateCommentInput = {
  text: Scalars['String'];
};

export type UpdateCostInput = {
  costType?: Maybe<CostType>;
  recurrencePeriodInYears?: Maybe<Scalars['Int']>;
  occurrenceYear?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type UpdateEmissionInput = {
  emissionType?: Maybe<EmissionType>;
  value?: Maybe<Scalars['Float']>;
};

export type UpdateEnergyBusInput = {
  wasteHourSeriesId?: Maybe<Scalars['ID']>;
};

export type UpdateEnergySystemInput = {
  name: Scalars['String'];
  type: EnergySystemType;
  scheduleId?: Maybe<Scalars['String']>;
  parameters: AnyEnergySystemParametersInput;
};

export type UpdateHourSeriesCollectionInput = {
  hourSeriesIds: Array<Scalars['String']>;
};

export type UpdateLocalGridInput = {
  type?: Maybe<LocalGridType>;
};

export type UpdatePricingModelInput = {
  name?: Maybe<Scalars['String']>;
  buildingYear?: Maybe<Scalars['Int']>;
  inspectionLengthInYears?: Maybe<Scalars['Int']>;
  yearlyDiscountRate?: Maybe<Scalars['Float']>;
  yearlyMaintenanceIncreaseRate?: Maybe<Scalars['Float']>;
  prices?: Maybe<Array<PricingModelPriceDataInput>>;
  sellingPrices?: Maybe<Array<PricingModelPriceDataInput>>;
  priceIncreaseRates?: Maybe<Array<PricingModelPriceDataInput>>;
};

export type UpdateProjectInput = {
  projectId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  versionName?: Maybe<Scalars['String']>;
  calendarYear?: Maybe<Scalars['Int']>;
  visibility?: Maybe<ProjectVisibility>;
  userGroupId?: Maybe<Scalars['ID']>;
  temperatureHourSeriesId?: Maybe<Scalars['String']>;
  licensePaid?: Maybe<Scalars['Boolean']>;
};

export type UpdateProjectVersionInput = {
  name?: Maybe<Scalars['String']>;
  omitBaseVersion?: Maybe<Scalars['Boolean']>;
  pricingModelId?: Maybe<Scalars['ID']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  baseVersionId?: Maybe<Scalars['ID']>;
};

export type UpdateProviderInput = {
  name?: Maybe<Scalars['String']>;
  type?: Maybe<ProviderType>;
  parameters?: Maybe<AnyProviderParametersInput>;
  hourSeriesIds?: Maybe<Array<Scalars['String']>>;
  performanceTableIds?: Maybe<Array<Scalars['String']>>;
  temperatureCurveIds?: Maybe<Array<Scalars['String']>>;
  demands?: Maybe<Array<ProviderDemandInput>>;
  providesElectricityForProviders?: Maybe<Scalars['Boolean']>;
};

export type UpdateScheduleInput = {
  name: Scalars['String'];
  hourlyProfiles: Array<ScheduleHourlyProfileDataInput>;
  weeklyProfile: ScheduleWeeklyProfileDataInput;
  monthlyProfile: ScheduleMonthlyProfileDataInput;
  exceptionData: ScheduleExceptionDataInput;
};

export type UpdateTemperatureCurveInput = {
  name?: Maybe<Scalars['String']>;
  table?: Maybe<Array<TemperatureCurveRowInput>>;
};

export type UpdateUserGroupInput = {
  name?: Maybe<Scalars['String']>;
  userIds?: Maybe<Array<Scalars['ID']>>;
};


export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  groups: Array<UserGroup>;
  projects: Array<Project>;
  username: Scalars['String'];
  name: Scalars['String'];
  role: UserRole;
  displayName: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  id: Scalars['ID'];
  users: Array<User>;
  projects: Array<Project>;
  name: Scalars['String'];
};

export type UserInput = {
  role: UserRole;
};

export enum UserRole {
  User = 'User',
  Admin = 'Admin'
}

export type VentilationDeviceData = {
  __typename?: 'VentilationDeviceData';
  deviceName: Scalars['String'];
  effectedArea: Scalars['String'];
  airFlow: Scalars['Float'];
  deviceScheduleId: Scalars['String'];
  heatRecoveryEfficiency: Scalars['Float'];
  SFP: Scalars['Float'];
  systemType: VentilationDeviceType;
  demandBasedUsageCoefficient: Scalars['Float'];
  exhaustAirMinimumTemp: Scalars['Float'];
  coolingCoil: Scalars['Int'];
  supplyAirTemp: Scalars['Float'];
  indoorAirTemp: Scalars['Float'];
  returnAirTemp: Scalars['Float'];
  chilldrop: Scalars['Float'];
  chilldropTempLimit: Scalars['Float'];
  exhaustAirHeatPump: Scalars['Int'];
};

export type VentilationDeviceDataInput = {
  deviceName: Scalars['String'];
  effectedArea: Scalars['String'];
  airFlow: Scalars['Float'];
  deviceScheduleId?: Maybe<Scalars['String']>;
  heatRecoveryEfficiency: Scalars['Float'];
  SFP: Scalars['Float'];
  systemType: VentilationDeviceType;
  demandBasedUsageCoefficient: Scalars['Float'];
  exhaustAirMinimumTemp: Scalars['Float'];
  coolingCoil: Scalars['Int'];
  supplyAirTemp: Scalars['Float'];
  indoorAirTemp: Scalars['Float'];
  returnAirTemp: Scalars['Float'];
  chilldrop: Scalars['Float'];
  chilldropTempLimit: Scalars['Float'];
  exhaustAirHeatPump: Scalars['Int'];
};

export enum VentilationDeviceType {
  SupplyAndExhaust = 'SupplyAndExhaust',
  Exhaust = 'Exhaust'
}

export type VentilationParameters = EnergySystemParameters & {
  __typename?: 'VentilationParameters';
  _?: Maybe<Scalars['String']>;
  deviceData: Array<VentilationDeviceData>;
  heatingDistributionEfficiency: Scalars['Float'];
  heatPumpExhaustAirMinimumTemp: Scalars['Float'];
};

export type VentilationParametersInput = {
  deviceData: Array<VentilationDeviceDataInput>;
  heatingDistributionEfficiency: Scalars['Float'];
  heatPumpExhaustAirMinimumTemp: Scalars['Float'];
};

export type WaterCoolingHeatPumpParameters = ProviderParameters & {
  __typename?: 'WaterCoolingHeatPumpParameters';
  isWasteSold?: Maybe<Scalars['Boolean']>;
  eer: Scalars['Float'];
  freeCooling: Scalars['Boolean'];
  freeCoolingMaxOutdoorTemperature?: Maybe<Scalars['Float']>;
  freeCoolingEer?: Maybe<Scalars['Float']>;
};

export type WaterCoolingHeatPumpParametersInput = {
  isWasteSold?: Maybe<Scalars['Boolean']>;
  eer: Scalars['Float'];
  freeCooling: Scalars['Boolean'];
  freeCoolingMaxOutdoorTemperature?: Maybe<Scalars['Float']>;
  freeCoolingEer?: Maybe<Scalars['Float']>;
};

export type BoreholeFieldConfirmationFragment = (
  { __typename?: 'BoreholeFieldConfirmation' }
  & Pick<BoreholeFieldConfirmation, 'id' | 'type' | 'date'>
  & { data: (
    { __typename?: 'BoreholeFieldConfirmationData' }
    & Pick<BoreholeFieldConfirmationData, 'holeCount' | 'holeDepth' | 'holeUsageForHeatingMonthlyTotal' | 'holeUsageForHeatingMonthlyMax' | 'holeUsageForCoolingMonthlyTotal' | 'holeUsageForCoolingMonthlyMax'>
  ), confirmer: (
    { __typename?: 'User' }
    & UserFragment
  ) }
);

export type CreateBuildingEnergyModelMutationVariables = Exact<{
  projectId: Scalars['String'];
  input: CreateBuildingEnergyModelInput;
}>;


export type CreateBuildingEnergyModelMutation = (
  { __typename?: 'Mutation' }
  & { createBuildingEnergyModel: (
    { __typename?: 'BuildingEnergyModel' }
    & BuildingEnergyModelFragment
  ) }
);

export type DeleteBuildingEnergyModelMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBuildingEnergyModelMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteBuildingEnergyModel'>
);

export type UpdateBuildingEnergyModelMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateBuildingEnergyModelInput;
}>;


export type UpdateBuildingEnergyModelMutation = (
  { __typename?: 'Mutation' }
  & { updateBuildingEnergyModel: (
    { __typename?: 'BuildingEnergyModel' }
    & BuildingEnergyModelFragment
  ) }
);

export type BuildingEnergyModelFragment = (
  { __typename?: 'BuildingEnergyModel' }
  & Pick<BuildingEnergyModel, 'id' | 'name' | 'area' | 'type' | 'calibrationDescription' | 'calibrationArea' | 'calibrationCorrection' | 'calibrationStart' | 'calibrationWeeklyProfile' | 'calibrationMonthlyProfile'>
  & { correctionFactors?: Maybe<Array<(
    { __typename?: 'BemCorrectionFactorsData' }
    & Pick<BemCorrectionFactorsData, 'energyType' | 'correctionFactor' | 'energyFactor'>
  )>>, energySystems: Array<(
    { __typename?: 'EnergySystem' }
    & EnergySystemFragment
  )>, schedules: Array<(
    { __typename?: 'Schedule' }
    & ScheduleFragment
  )>, calOutdoorHourSeries?: Maybe<(
    { __typename?: 'HourSeries' }
    & HourSeriesFragment
  )>, calHeatingHourSeries?: Maybe<(
    { __typename?: 'HourSeries' }
    & HourSeriesFragment
  )>, calElectricityHourSeries?: Maybe<(
    { __typename?: 'HourSeries' }
    & HourSeriesFragment
  )>, calCoolingHourSeries?: Maybe<(
    { __typename?: 'HourSeries' }
    & HourSeriesFragment
  )>, calibrationLimitValues?: Maybe<(
    { __typename?: 'BemLimitValuesData' }
    & Pick<BemLimitValuesData, 'winterTempStart' | 'winterTempEnd' | 'summerTempStart' | 'summerTempEnd' | 'zeroWeatherTempStart' | 'zeroWeatherTempEnd' | 'morningStartHour' | 'morningEndHour' | 'dayStartHour' | 'dayEndHour' | 'eveningStartHour' | 'eveningEndHour' | 'nightStartHour' | 'nightEndHour'>
  )> }
);

export type CreateBuildingMutationVariables = Exact<{
  projectVersionId: Scalars['String'];
  input: CreateBuildingInput;
}>;


export type CreateBuildingMutation = (
  { __typename?: 'Mutation' }
  & { createBuilding: (
    { __typename?: 'Building' }
    & BuildingFragment
  ) }
);

export type DeleteBuildingMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBuildingMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteBuilding'>
);

export type UpdateBuildingMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateBuildingInput;
}>;


export type UpdateBuildingMutation = (
  { __typename?: 'Mutation' }
  & { updateBuilding: (
    { __typename?: 'Building' }
    & BuildingFragment
  ) }
);

export type UpdateBuildingBoreholeFieldMutationVariables = Exact<{
  id: Scalars['String'];
  input: BoreholeFieldContainerInput;
}>;


export type UpdateBuildingBoreholeFieldMutation = (
  { __typename?: 'Mutation' }
  & { updateBuildingBoreholeField: (
    { __typename?: 'Building' }
    & BuildingFragment
  ) }
);

export type BuildingFragment = (
  { __typename?: 'Building' }
  & Pick<Building, 'id' | 'name' | 'area' | 'type' | 'multiplier' | 'holeCount' | 'holeDepth' | 'description' | 'modelingInformation' | 'pathToSimulation' | 'confirmationType'>
  & { confirmation?: Maybe<(
    { __typename?: 'BoreholeFieldConfirmation' }
    & BoreholeFieldConfirmationFragment
  )>, demands: Array<(
    { __typename?: 'Demand' }
    & DemandFragment
  )>, parts: Array<(
    { __typename?: 'HourSeriesCollection' }
    & BuildingPartCollectionFragment
  )>, providers: Array<(
    { __typename?: 'Provider' }
    & ProviderFragment
  )>, emissions: Array<(
    { __typename?: 'Emission' }
    & EmissionFragment
  )> }
);

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
  projectId?: Maybe<Scalars['String']>;
  projectVersionId?: Maybe<Scalars['String']>;
}>;


export type CreateCommentMutation = (
  { __typename?: 'Mutation' }
  & { createComment: (
    { __typename?: 'Comment' }
    & CommentFragment
  ) }
);

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCommentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteComment'>
);

export type UpdateCommentMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutation = (
  { __typename?: 'Mutation' }
  & { updateComment: (
    { __typename?: 'Comment' }
    & CommentFragment
  ) }
);

export type CommentFragment = (
  { __typename?: 'Comment' }
  & Pick<Comment, 'id' | 'locationType' | 'text'>
);

export type CreateCostMutationVariables = Exact<{
  projectVersionId: Scalars['String'];
  input: CreateCostInput;
  providerId?: Maybe<Scalars['String']>;
}>;


export type CreateCostMutation = (
  { __typename?: 'Mutation' }
  & { createCost: (
    { __typename?: 'Cost' }
    & CostFragment
  ) }
);

export type DeleteCostMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCostMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteCost'>
);

export type UpdateCostMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateCostInput;
}>;


export type UpdateCostMutation = (
  { __typename?: 'Mutation' }
  & { updateCost: (
    { __typename?: 'Cost' }
    & CostFragment
  ) }
);

export type CostFragment = (
  { __typename?: 'Cost' }
  & Pick<Cost, 'id' | 'costType' | 'recurrencePeriodInYears' | 'occurrenceYear' | 'endYear' | 'description' | 'value' | 'providerId'>
);

export type DemandFragment = (
  { __typename?: 'Demand' }
  & Pick<Demand, 'id' | 'type'>
  & { hourSeries: (
    { __typename?: 'HourSeries' }
    & HourSeriesFragment
  ) }
);

export type CreateEmissionMutationVariables = Exact<{
  buildingId: Scalars['String'];
  input: CreateEmissionInput;
}>;


export type CreateEmissionMutation = (
  { __typename?: 'Mutation' }
  & { createEmission: (
    { __typename?: 'Emission' }
    & EmissionFragment
  ) }
);

export type DeleteEmissionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEmissionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteEmission'>
);

export type UpdateEmissionMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateEmissionInput;
}>;


export type UpdateEmissionMutation = (
  { __typename?: 'Mutation' }
  & { updateEmission: (
    { __typename?: 'Emission' }
    & EmissionFragment
  ) }
);

export type EmissionFragment = (
  { __typename?: 'Emission' }
  & Pick<Emission, 'id' | 'emissionType' | 'value' | 'buildingId'>
);

export type CreateEnergyBusMutationVariables = Exact<{
  projectVersionId: Scalars['String'];
  input: CreateEnergyBusInput;
}>;


export type CreateEnergyBusMutation = (
  { __typename?: 'Mutation' }
  & { createEnergyBus: (
    { __typename?: 'EnergyBus' }
    & EnergyBusFragment
  ) }
);

export type DeleteEnergyBusMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEnergyBusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteEnergyBus'>
);

export type UpdateEnergyBusMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateEnergyBusInput;
}>;


export type UpdateEnergyBusMutation = (
  { __typename?: 'Mutation' }
  & { updateEnergyBus: (
    { __typename?: 'EnergyBus' }
    & EnergyBusFragment
  ) }
);

export type UpdateEnergyBusBoreholeFieldMutationVariables = Exact<{
  id: Scalars['String'];
  input: BoreholeFieldContainerInput;
}>;


export type UpdateEnergyBusBoreholeFieldMutation = (
  { __typename?: 'Mutation' }
  & { updateEnergyBusBoreholeField: (
    { __typename?: 'EnergyBus' }
    & EnergyBusFragment
  ) }
);

export type EnergyBusFragment = (
  { __typename?: 'EnergyBus' }
  & Pick<EnergyBus, 'id' | 'holeCount' | 'holeDepth' | 'description' | 'modelingInformation' | 'pathToSimulation' | 'confirmationType'>
  & { confirmation?: Maybe<(
    { __typename?: 'BoreholeFieldConfirmation' }
    & BoreholeFieldConfirmationFragment
  )>, wasteHourSeries?: Maybe<(
    { __typename?: 'HourSeries' }
    & HourSeriesFragment
  )> }
);

export type CreateEnergySystemMutationVariables = Exact<{
  buildingEnergyModelId: Scalars['String'];
  input: CreateEnergySystemInput;
}>;


export type CreateEnergySystemMutation = (
  { __typename?: 'Mutation' }
  & { createEnergySystem: (
    { __typename?: 'EnergySystem' }
    & EnergySystemFragment
  ) }
);

export type DeleteEnergySystemMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEnergySystemMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteEnergySystem'>
);

export type UpdateEnergySystemMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateEnergySystemInput;
}>;


export type UpdateEnergySystemMutation = (
  { __typename?: 'Mutation' }
  & { updateEnergySystem: (
    { __typename?: 'EnergySystem' }
    & EnergySystemFragment
  ) }
);

export type EnergySystemFragment = (
  { __typename?: 'EnergySystem' }
  & Pick<EnergySystem, 'id' | 'name' | 'type'>
  & { schedule?: Maybe<(
    { __typename?: 'Schedule' }
    & ScheduleFragment
  )>, parameters: (
    { __typename?: 'CoolingParameters' }
    & EnergySystemParameters_CoolingParameters_Fragment
  ) | (
    { __typename?: 'DomesticHotWaterParameters' }
    & EnergySystemParameters_DomesticHotWaterParameters_Fragment
  ) | (
    { __typename?: 'ElectricityConsumptionParameters' }
    & EnergySystemParameters_ElectricityConsumptionParameters_Fragment
  ) | (
    { __typename?: 'HeatLoadParameters' }
    & EnergySystemParameters_HeatLoadParameters_Fragment
  ) | (
    { __typename?: 'SpaceHeatingParameters' }
    & EnergySystemParameters_SpaceHeatingParameters_Fragment
  ) | (
    { __typename?: 'VentilationParameters' }
    & EnergySystemParameters_VentilationParameters_Fragment
  ) }
);

type EnergySystemParameters_CoolingParameters_Fragment = (
  { __typename?: 'CoolingParameters' }
  & Pick<CoolingParameters, 'systemCoolingPower' | 'scStartTemp' | 'scIncreaseSlope' | 'scIncreaseExtraCoef' | 'scExtraCoefStartTemp' | 'scDistributionEfficiency' | 'scSpacesPortion' | 'acDemandDisplacementConstant' | 'acCorrectionCoef' | 'acIncreaseExtraCoef' | 'acExtraCoefStartTemp' | 'acDistributionEfficiency' | '_'>
);

type EnergySystemParameters_DomesticHotWaterParameters_Fragment = (
  { __typename?: 'DomesticHotWaterParameters' }
  & Pick<DomesticHotWaterParameters, 'consumptionDensity' | 'distributionEfficiency' | 'consumptionFactor' | 'circulationSpecificLength' | 'circulationSpecificHeatLoss' | 'circulationHeatersAmount' | 'circulationHeatersPower' | 'wasteWaterHeatContentRatio' | '_'>
);

type EnergySystemParameters_ElectricityConsumptionParameters_Fragment = (
  { __typename?: 'ElectricityConsumptionParameters' }
  & Pick<ElectricityConsumptionParameters, 'electricityBaseLoad' | 'occupantLightingElShare' | 'occupantApplianceElShare' | 'occupantVentilationElShare' | 'occupantBaseLoadElShare' | '_'>
);

type EnergySystemParameters_HeatLoadParameters_Fragment = (
  { __typename?: 'HeatLoadParameters' }
  & Pick<HeatLoadParameters, 'occupantHeatLoad' | 'occupantHeatLoadUtilFactor' | 'occupantScheduleId' | 'applianceHeatLoad' | 'applianceHeatLoadUtilFactor' | 'applianceScheduleId' | 'lightingHeatLoad' | 'lightingHeatLoadUtilFactor' | 'lightingScheduleId' | 'heatLoadUtilStartTemp' | 'affectingSpaceHeatingStartTemp' | '_'>
);

type EnergySystemParameters_SpaceHeatingParameters_Fragment = (
  { __typename?: 'SpaceHeatingParameters' }
  & Pick<SpaceHeatingParameters, 'exteriorWallArea' | 'roofArea' | 'baseFloorArea' | 'windowsArea' | 'doorsArea' | 'exteriorWallUvalue' | 'roofUvalue' | 'baseFloorUvalue' | 'windowsUvalue' | 'doorsUvalue' | 'heatBridgeRatio' | 'q50' | 'airLeakageXfactor' | 'heatSupplyEfficiency' | 'basEfficiency' | 'affectingHeatLossStartTemp' | 'dynamicOutTempWeightFactor' | 'heatLossesCorrectionFactor' | 'heatLossesCorrectionFactorStartTemp' | 'supplyAirHeatingStartTemp' | 'supplyAirFullHeatingStartTemp' | '_'>
);

type EnergySystemParameters_VentilationParameters_Fragment = (
  { __typename?: 'VentilationParameters' }
  & Pick<VentilationParameters, 'heatingDistributionEfficiency' | 'heatPumpExhaustAirMinimumTemp' | '_'>
  & { deviceData: Array<(
    { __typename?: 'VentilationDeviceData' }
    & Pick<VentilationDeviceData, 'deviceName' | 'effectedArea' | 'airFlow' | 'deviceScheduleId' | 'heatRecoveryEfficiency' | 'SFP' | 'systemType' | 'demandBasedUsageCoefficient' | 'exhaustAirMinimumTemp' | 'coolingCoil' | 'supplyAirTemp' | 'indoorAirTemp' | 'returnAirTemp' | 'chilldrop' | 'chilldropTempLimit' | 'exhaustAirHeatPump'>
  )> }
);

export type EnergySystemParametersFragment = EnergySystemParameters_CoolingParameters_Fragment | EnergySystemParameters_DomesticHotWaterParameters_Fragment | EnergySystemParameters_ElectricityConsumptionParameters_Fragment | EnergySystemParameters_HeatLoadParameters_Fragment | EnergySystemParameters_SpaceHeatingParameters_Fragment | EnergySystemParameters_VentilationParameters_Fragment;

export type CreateGlobalHourSeriesCollectionsMutationVariables = Exact<{
  hourSeriesFile: Scalars['Upload'];
  shouldOverwrite: Scalars['Boolean'];
}>;


export type CreateGlobalHourSeriesCollectionsMutation = (
  { __typename?: 'Mutation' }
  & { createGlobalHourSeriesCollections: Array<(
    { __typename?: 'HourSeriesCollection' }
    & HourSeriesCollectionFragment
  )> }
);

export type CreateHourSeriesCollectionMutationVariables = Exact<{
  projectId: Scalars['String'];
  input: CreateHourSeriesCollectionInput;
  shouldOverwrite: Scalars['Boolean'];
}>;


export type CreateHourSeriesCollectionMutation = (
  { __typename?: 'Mutation' }
  & { createHourSeriesCollection: (
    { __typename?: 'HourSeriesCollection' }
    & HourSeriesCollectionFragment
  ) }
);

export type CreateHourSeriesCollectionsMutationVariables = Exact<{
  projectId: Scalars['String'];
  hourSeriesFile: Scalars['Upload'];
  shouldOverwrite: Scalars['Boolean'];
}>;


export type CreateHourSeriesCollectionsMutation = (
  { __typename?: 'Mutation' }
  & { createHourSeriesCollections: Array<(
    { __typename?: 'HourSeriesCollection' }
    & HourSeriesCollectionFragment
  )> }
);

export type DeleteHourSeriesCollectionsMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteHourSeriesCollectionsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteHourSeriesCollection'>
);

export type GlobalHourSeriesCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalHourSeriesCollectionsQuery = (
  { __typename?: 'Query' }
  & { globalHourSeriesCollections: Array<(
    { __typename?: 'HourSeriesCollection' }
    & HourSeriesCollectionFragment
  )> }
);

export type UpdateHourSeriesCollectionsMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateHourSeriesCollectionInput;
}>;


export type UpdateHourSeriesCollectionsMutation = (
  { __typename?: 'Mutation' }
  & { updateHourSeriesCollection: (
    { __typename?: 'HourSeriesCollection' }
    & HourSeriesCollectionFragment
  ) }
);

export type BuildingPartCollectionFragment = (
  { __typename?: 'HourSeriesCollection' }
  & Pick<HourSeriesCollection, 'partArea'>
  & HourSeriesCollectionBaseFragment
);

export type HourSeriesCollectionFragment = (
  { __typename?: 'HourSeriesCollection' }
  & Pick<HourSeriesCollection, 'updatedAt' | 'isInUse'>
  & { originalGlobalCollection?: Maybe<(
    { __typename?: 'HourSeriesCollection' }
    & OriginalGlobalCollectionFragment
  )> }
  & HourSeriesCollectionBaseFragment
);

export type HourSeriesCollectionBaseFragment = (
  { __typename?: 'HourSeriesCollection' }
  & Pick<HourSeriesCollection, 'id' | 'type' | 'name'>
  & { hourSeries: Array<(
    { __typename?: 'HourSeries' }
    & HourSeriesFragment
  )> }
);

export type OriginalGlobalCollectionFragment = (
  { __typename?: 'HourSeriesCollection' }
  & Pick<HourSeriesCollection, 'id' | 'type' | 'name'>
);

export type HourSeriesFragment = (
  { __typename?: 'HourSeries' }
  & Pick<HourSeries, 'id' | 'type' | 'name' | 'values' | 'isInUse'>
);

export type CreateLocalGridMutationVariables = Exact<{
  projectVersionId: Scalars['String'];
  input: CreateLocalGridInput;
}>;


export type CreateLocalGridMutation = (
  { __typename?: 'Mutation' }
  & { createLocalGrid: (
    { __typename?: 'LocalGrid' }
    & LocalGridFragment
  ) }
);

export type DeleteLocalGridMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteLocalGridMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteLocalGrid'>
);

export type UpdateLocalGridMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateLocalGridInput;
}>;


export type UpdateLocalGridMutation = (
  { __typename?: 'Mutation' }
  & { updateLocalGrid: (
    { __typename?: 'LocalGrid' }
    & LocalGridFragment
  ) }
);

export type UpdateLocalGridBoreholeFieldMutationVariables = Exact<{
  id: Scalars['String'];
  input: BoreholeFieldContainerInput;
}>;


export type UpdateLocalGridBoreholeFieldMutation = (
  { __typename?: 'Mutation' }
  & { updateLocalGridBoreholeField: (
    { __typename?: 'LocalGrid' }
    & LocalGridFragment
  ) }
);

export type LocalGridFragment = (
  { __typename?: 'LocalGrid' }
  & Pick<LocalGrid, 'id' | 'type' | 'holeCount' | 'holeDepth' | 'description' | 'modelingInformation' | 'pathToSimulation' | 'confirmationType'>
  & { confirmation?: Maybe<(
    { __typename?: 'BoreholeFieldConfirmation' }
    & BoreholeFieldConfirmationFragment
  )>, providers: Array<(
    { __typename?: 'Provider' }
    & ProviderFragment
  )> }
);

export type PerformanceTablesQueryVariables = Exact<{ [key: string]: never; }>;


export type PerformanceTablesQuery = (
  { __typename?: 'Query' }
  & { performanceTables: Array<(
    { __typename?: 'PerformanceTable' }
    & PerformanceTableFragment
  )> }
);

export type PerformanceTableFragment = (
  { __typename?: 'PerformanceTable' }
  & Pick<PerformanceTable, 'id' | 'name'>
  & { copTable: Array<(
    { __typename?: 'PerformanceTableRow' }
    & Pick<PerformanceTableRow, 'evaporatorTemperature'>
    & { columns: Array<(
      { __typename?: 'PerformanceTableColumn' }
      & Pick<PerformanceTableColumn, 'condenserTemperature' | 'value'>
    )> }
  )>, powerCoefficientTable: Array<(
    { __typename?: 'PerformanceTableRow' }
    & Pick<PerformanceTableRow, 'evaporatorTemperature'>
    & { columns: Array<(
      { __typename?: 'PerformanceTableColumn' }
      & Pick<PerformanceTableColumn, 'condenserTemperature' | 'value'>
    )> }
  )> }
);

export type CreateGlobalPricingModelMutationVariables = Exact<{
  input: CreatePricingModelInput;
}>;


export type CreateGlobalPricingModelMutation = (
  { __typename?: 'Mutation' }
  & { createGlobalPricingModel: (
    { __typename?: 'PricingModel' }
    & PricingModelFragment
  ) }
);

export type CreatePricingModelMutationVariables = Exact<{
  projectId: Scalars['String'];
  input: CreatePricingModelInput;
}>;


export type CreatePricingModelMutation = (
  { __typename?: 'Mutation' }
  & { createPricingModel: (
    { __typename?: 'PricingModel' }
    & PricingModelFragment
  ) }
);

export type DeletePricingModelMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePricingModelMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deletePricingModel'>
);

export type GlobalPricingModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalPricingModelsQuery = (
  { __typename?: 'Query' }
  & { globalPricingModels: Array<(
    { __typename?: 'PricingModel' }
    & PricingModelFragment
  )> }
);

export type UpdatePricingModelMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdatePricingModelInput;
}>;


export type UpdatePricingModelMutation = (
  { __typename?: 'Mutation' }
  & { updatePricingModel: (
    { __typename?: 'PricingModel' }
    & PricingModelFragment
  ) }
);

export type PricingModelFragment = (
  { __typename?: 'PricingModel' }
  & Pick<PricingModel, 'id' | 'type' | 'name' | 'buildingYear' | 'inspectionLengthInYears' | 'yearlyDiscountRate' | 'yearlyMaintenanceIncreaseRate'>
  & { prices: Array<(
    { __typename?: 'PricingModelPriceData' }
    & Pick<PricingModelPriceData, 'energyType' | 'monthlyValues'>
  )>, sellingPrices: Array<(
    { __typename?: 'PricingModelPriceData' }
    & Pick<PricingModelPriceData, 'energyType' | 'monthlyValues'>
  )>, priceIncreaseRates: Array<(
    { __typename?: 'PricingModelPriceData' }
    & Pick<PricingModelPriceData, 'energyType' | 'yearlyValue'>
  )> }
);

export type CreateProjectVersionMutationVariables = Exact<{
  projectId: Scalars['String'];
  input: CreateProjectVersionInput;
  copyOfVersionId?: Maybe<Scalars['String']>;
}>;


export type CreateProjectVersionMutation = (
  { __typename?: 'Mutation' }
  & { createProjectVersion: (
    { __typename?: 'ProjectVersion' }
    & ProjectVersionFragment
  ) }
);

export type DeleteProjectVersionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectVersionMutation = (
  { __typename?: 'Mutation' }
  & { deleteProjectVersion: Array<(
    { __typename?: 'ProjectVersion' }
    & Pick<ProjectVersion, 'id' | 'baseVersionId'>
  )> }
);

export type UpdateProjectVersionMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateProjectVersionInput;
}>;


export type UpdateProjectVersionMutation = (
  { __typename?: 'Mutation' }
  & { updateProjectVersion: (
    { __typename?: 'ProjectVersion' }
    & ProjectVersionFragment
  ) }
);

export type ProjectVersionFragment = (
  { __typename?: 'ProjectVersion' }
  & Pick<ProjectVersion, 'id' | 'name' | 'isDefault' | 'createdAt' | 'baseVersionId'>
  & { buildings: Array<(
    { __typename?: 'Building' }
    & BuildingFragment
  )>, localGrids: Array<(
    { __typename?: 'LocalGrid' }
    & LocalGridFragment
  )>, energyBus?: Maybe<(
    { __typename?: 'EnergyBus' }
    & EnergyBusFragment
  )>, costs: Array<(
    { __typename?: 'Cost' }
    & CostFragment
  )>, pricingModel?: Maybe<(
    { __typename?: 'PricingModel' }
    & PricingModelFragment
  )>, comments: Array<(
    { __typename?: 'Comment' }
    & CommentFragment
  )> }
);

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = (
  { __typename?: 'Mutation' }
  & { createProject: (
    { __typename?: 'Project' }
    & ProjectFragment
  ) }
);

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteProject'>
);

export type ProjectQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ProjectQuery = (
  { __typename?: 'Query' }
  & { project: (
    { __typename?: 'Project' }
    & ProjectFragment
  ) }
);

export type ProjectCollectionsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ProjectCollectionsQuery = (
  { __typename?: 'Query' }
  & { project: (
    { __typename?: 'Project' }
    & ProjectCollectionsFragment
  ) }
);

export type ProjectTemperatureCurvesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ProjectTemperatureCurvesQuery = (
  { __typename?: 'Query' }
  & { project: (
    { __typename?: 'Project' }
    & ProjectTemperatureCurvesFragment
  ) }
);

export type ProjectsQueryVariables = Exact<{
  filter: ProjectListFilter;
}>;


export type ProjectsQuery = (
  { __typename?: 'Query' }
  & { projects: (
    { __typename?: 'ProjectListModel' }
    & Pick<ProjectListModel, 'totalCount'>
    & { items: Array<(
      { __typename?: 'Project' }
      & ListProjectFragment
    )> }
  ) }
);

export type RestoreProjectMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RestoreProjectMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'restoreProject'>
);

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = (
  { __typename?: 'Mutation' }
  & { updateProject: (
    { __typename?: 'Project' }
    & ProjectFragment
  ) }
);

export type ListProjectFragment = (
  { __typename?: 'Project' }
  & Pick<Project, 'id' | 'projectId' | 'name' | 'calendarYear' | 'licensePaid' | 'createdAt' | 'updatedAt' | 'deletedAt'>
  & { owner: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'displayName'>
  ), updatedBy: (
    { __typename?: 'User' }
    & Pick<User, 'id' | 'displayName'>
  ), versions: Array<(
    { __typename?: 'ProjectVersion' }
    & Pick<ProjectVersion, 'id' | 'isDefault'>
    & { buildings: Array<(
      { __typename?: 'Building' }
      & Pick<Building, 'id' | 'area' | 'multiplier'>
    )> }
  )> }
);

export type ProjectFragment = (
  { __typename?: 'Project' }
  & Pick<Project, 'id' | 'projectId' | 'name' | 'visibility' | 'calendarYear' | 'licensePaid' | 'createdAt' | 'updatedAt'>
  & { userGroup?: Maybe<(
    { __typename?: 'UserGroup' }
    & SimpleUserGroupFragment
  )>, owner: (
    { __typename?: 'User' }
    & UserFragment
  ), updatedBy: (
    { __typename?: 'User' }
    & UserFragment
  ), versions: Array<(
    { __typename?: 'ProjectVersion' }
    & ProjectVersionFragment
  )>, hourSeriesCollections: Array<(
    { __typename?: 'HourSeriesCollection' }
    & HourSeriesCollectionFragment
  )>, buildingEnergyModels: Array<(
    { __typename?: 'BuildingEnergyModel' }
    & BuildingEnergyModelFragment
  )>, pricingModels: Array<(
    { __typename?: 'PricingModel' }
    & PricingModelFragment
  )>, temperatureHourSeries?: Maybe<(
    { __typename?: 'HourSeries' }
    & HourSeriesFragment
  )>, comments: Array<(
    { __typename?: 'Comment' }
    & CommentFragment
  )> }
);

export type ProjectCollectionsFragment = (
  { __typename?: 'Project' }
  & Pick<Project, 'id'>
  & { hourSeriesCollections: Array<(
    { __typename?: 'HourSeriesCollection' }
    & HourSeriesCollectionFragment
  )> }
);

export type ProjectTemperatureCurvesFragment = (
  { __typename?: 'Project' }
  & Pick<Project, 'id'>
  & { temperatureCurves: Array<(
    { __typename?: 'TemperatureCurve' }
    & TemperatureCurveFragment
  )> }
);

export type ProviderDemandFragment = (
  { __typename?: 'ProviderDemand' }
  & Pick<ProviderDemand, 'id' | 'maxPortion'>
  & { demand: (
    { __typename?: 'Demand' }
    & DemandFragment
  ) }
);

export type CreateProviderMutationVariables = Exact<{
  buildingId?: Maybe<Scalars['String']>;
  localGridId?: Maybe<Scalars['String']>;
  input: CreateProviderInput;
}>;


export type CreateProviderMutation = (
  { __typename?: 'Mutation' }
  & { createProvider: (
    { __typename?: 'Provider' }
    & ProviderFragment
  ) }
);

export type DeleteProviderMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProviderMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteProvider'>
);

export type UpdateProviderMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateProviderInput;
}>;


export type UpdateProviderMutation = (
  { __typename?: 'Mutation' }
  & { updateProvider: (
    { __typename?: 'Provider' }
    & ProviderFragment
  ) }
);

export type ProviderFragment = (
  { __typename?: 'Provider' }
  & Pick<Provider, 'id' | 'name' | 'type' | 'providesElectricityForProviders' | 'isFallback' | 'createdAt'>
  & { parameters: (
    { __typename?: 'BatteryParameters' }
    & ProviderParameters_BatteryParameters_Fragment
  ) | (
    { __typename?: 'CirculationHeatPumpParameters' }
    & ProviderParameters_CirculationHeatPumpParameters_Fragment
  ) | (
    { __typename?: 'CoolingAirHeatPumpParameters' }
    & ProviderParameters_CoolingAirHeatPumpParameters_Fragment
  ) | (
    { __typename?: 'CoolingGroundHeatPumpParameters' }
    & ProviderParameters_CoolingGroundHeatPumpParameters_Fragment
  ) | (
    { __typename?: 'HeatBoilerParameters' }
    & ProviderParameters_HeatBoilerParameters_Fragment
  ) | (
    { __typename?: 'HeatingAirHeatPumpParameters' }
    & ProviderParameters_HeatingAirHeatPumpParameters_Fragment
  ) | (
    { __typename?: 'HeatingGroundHeatPumpParameters' }
    & ProviderParameters_HeatingGroundHeatPumpParameters_Fragment
  ) | (
    { __typename?: 'HybridHeatPumpParameters' }
    & ProviderParameters_HybridHeatPumpParameters_Fragment
  ) | (
    { __typename?: 'InefficientParameters' }
    & ProviderParameters_InefficientParameters_Fragment
  ) | (
    { __typename?: 'PreheaterParameters' }
    & ProviderParameters_PreheaterParameters_Fragment
  ) | (
    { __typename?: 'SolarPanelParameters' }
    & ProviderParameters_SolarPanelParameters_Fragment
  ) | (
    { __typename?: 'WaterCoolingHeatPumpParameters' }
    & ProviderParameters_WaterCoolingHeatPumpParameters_Fragment
  ), hourSeries: Array<(
    { __typename?: 'HourSeries' }
    & HourSeriesFragment
  )>, performanceTables: Array<(
    { __typename?: 'PerformanceTable' }
    & PerformanceTableFragment
  )>, temperatureCurves: Array<(
    { __typename?: 'TemperatureCurve' }
    & TemperatureCurveFragment
  )>, demands: Array<(
    { __typename?: 'ProviderDemand' }
    & ProviderDemandFragment
  )> }
);

type ProviderParameters_BatteryParameters_Fragment = (
  { __typename?: 'BatteryParameters' }
  & Pick<BatteryParameters, 'capacity' | 'chargePower' | 'dischargePower' | 'isWasteSold'>
);

type ProviderParameters_CirculationHeatPumpParameters_Fragment = (
  { __typename?: 'CirculationHeatPumpParameters' }
  & Pick<CirculationHeatPumpParameters, 'cop' | 'maxPower' | 'isWasteSold'>
);

type ProviderParameters_CoolingAirHeatPumpParameters_Fragment = (
  { __typename?: 'CoolingAirHeatPumpParameters' }
  & Pick<CoolingAirHeatPumpParameters, 'eer' | 'maxPower' | 'freeCooling' | 'freeCoolingMaxOutdoorTemperature' | 'freeCoolingEer' | 'freeCoolingMaxPower' | 'isWasteSold'>
);

type ProviderParameters_CoolingGroundHeatPumpParameters_Fragment = (
  { __typename?: 'CoolingGroundHeatPumpParameters' }
  & Pick<CoolingGroundHeatPumpParameters, 'eer' | 'maxPower' | 'freeCooling' | 'freeCoolingEer' | 'freeCoolingMaxPower' | 'isWasteSold'>
);

type ProviderParameters_HeatBoilerParameters_Fragment = (
  { __typename?: 'HeatBoilerParameters' }
  & Pick<HeatBoilerParameters, 'efficiency' | 'fuelType' | 'isWasteSold'>
);

type ProviderParameters_HeatingAirHeatPumpParameters_Fragment = (
  { __typename?: 'HeatingAirHeatPumpParameters' }
  & Pick<HeatingAirHeatPumpParameters, 'cop' | 'maxPower' | 'minOutdoorTemperature' | 'isWasteSold'>
);

type ProviderParameters_HeatingGroundHeatPumpParameters_Fragment = (
  { __typename?: 'HeatingGroundHeatPumpParameters' }
  & Pick<HeatingGroundHeatPumpParameters, 'cop' | 'maxPower' | 'isWasteSold'>
);

type ProviderParameters_HybridHeatPumpParameters_Fragment = (
  { __typename?: 'HybridHeatPumpParameters' }
  & Pick<HybridHeatPumpParameters, 'performanceTableId' | 'copModifier' | 'heatSourceAvailable' | 'heatExhaustAvailable' | 'heatRecycleAvailable' | 'heatingPower' | 'heatingTemperatureCurveId' | 'dhwHeatingMode' | 'coolingTemperatureCurveId' | 'baseHeatSource' | 'groundHeatSourceTemperature' | 'groundHeatSourceMaxPower' | 'airHeatSourceMinTemperature' | 'wasteHeatSourceAHourSeriesId' | 'wasteHeatSourceATemperature' | 'wasteHeatSourceBHourSeriesId' | 'wasteHeatSourceBTemperature' | 'freeCoolingSource' | 'freeGroundCoolingMaxPower' | 'freeAirCoolingMaxTemperature' | 'freeCoolingEer' | 'coolingSource' | 'groundExhaustTemperature' | 'isWasteSold'>
  & { heatCircuits?: Maybe<Array<(
    { __typename?: 'HeatCircuit' }
    & Pick<HeatCircuit, 'demandId' | 'temperatureCurveId' | 'isDhwCircuit'>
  )>> }
);

type ProviderParameters_InefficientParameters_Fragment = (
  { __typename?: 'InefficientParameters' }
  & Pick<InefficientParameters, 'efficiency' | 'isWasteSold'>
);

type ProviderParameters_PreheaterParameters_Fragment = (
  { __typename?: 'PreheaterParameters' }
  & Pick<PreheaterParameters, 'relativePower' | 'isWasteSold'>
);

type ProviderParameters_SolarPanelParameters_Fragment = (
  { __typename?: 'SolarPanelParameters' }
  & Pick<SolarPanelParameters, 'area' | 'solarEfficiency' | 'ratingEfficiency' | 'isWasteSold'>
);

type ProviderParameters_WaterCoolingHeatPumpParameters_Fragment = (
  { __typename?: 'WaterCoolingHeatPumpParameters' }
  & Pick<WaterCoolingHeatPumpParameters, 'eer' | 'freeCooling' | 'freeCoolingMaxOutdoorTemperature' | 'freeCoolingEer' | 'isWasteSold'>
);

export type ProviderParametersFragment = ProviderParameters_BatteryParameters_Fragment | ProviderParameters_CirculationHeatPumpParameters_Fragment | ProviderParameters_CoolingAirHeatPumpParameters_Fragment | ProviderParameters_CoolingGroundHeatPumpParameters_Fragment | ProviderParameters_HeatBoilerParameters_Fragment | ProviderParameters_HeatingAirHeatPumpParameters_Fragment | ProviderParameters_HeatingGroundHeatPumpParameters_Fragment | ProviderParameters_HybridHeatPumpParameters_Fragment | ProviderParameters_InefficientParameters_Fragment | ProviderParameters_PreheaterParameters_Fragment | ProviderParameters_SolarPanelParameters_Fragment | ProviderParameters_WaterCoolingHeatPumpParameters_Fragment;

export type CreateScheduleMutationVariables = Exact<{
  buildingEnergyModelId: Scalars['String'];
  input: CreateScheduleInput;
}>;


export type CreateScheduleMutation = (
  { __typename?: 'Mutation' }
  & { createSchedule: (
    { __typename?: 'Schedule' }
    & ScheduleFragment
  ) }
);

export type DeleteScheduleMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteScheduleMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteSchedule'>
);

export type GetScheduleQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetScheduleQuery = (
  { __typename?: 'Query' }
  & { getSchedule: (
    { __typename?: 'Schedule' }
    & ScheduleFragment
  ) }
);

export type UpdateScheduleMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateScheduleInput;
}>;


export type UpdateScheduleMutation = (
  { __typename?: 'Mutation' }
  & { updateSchedule: (
    { __typename?: 'Schedule' }
    & ScheduleFragment
  ) }
);

export type ScheduleFragment = (
  { __typename?: 'Schedule' }
  & Pick<Schedule, 'id' | 'name' | 'createdAt'>
  & { hourlyProfiles?: Maybe<Array<(
    { __typename?: 'ScheduleHourlyProfileData' }
    & Pick<ScheduleHourlyProfileData, 'profileType' | 'values'>
  )>>, weeklyProfile?: Maybe<(
    { __typename?: 'ScheduleWeeklyProfileData' }
    & Pick<ScheduleWeeklyProfileData, 'profileTypes'>
  )>, monthlyProfile?: Maybe<(
    { __typename?: 'ScheduleMonthlyProfileData' }
    & Pick<ScheduleMonthlyProfileData, 'multipliers'>
  )>, exceptionData?: Maybe<(
    { __typename?: 'ScheduleExceptionData' }
    & Pick<ScheduleExceptionData, 'inUse' | 'startAt' | 'endAt' | 'profileType'>
  )> }
);

export type CreateTemperatureCurveMutationVariables = Exact<{
  projectId: Scalars['String'];
  input: CreateTemperatureCurveInput;
}>;


export type CreateTemperatureCurveMutation = (
  { __typename?: 'Mutation' }
  & { createProjectSpecificTemperatureCurve: (
    { __typename?: 'TemperatureCurve' }
    & TemperatureCurveFragment
  ) }
);

export type DeleteTemperatureCurveMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTemperatureCurveMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteTemperatureCurve'>
);

export type TemperatureCurvesQueryVariables = Exact<{ [key: string]: never; }>;


export type TemperatureCurvesQuery = (
  { __typename?: 'Query' }
  & { temperatureCurves: Array<(
    { __typename?: 'TemperatureCurve' }
    & TemperatureCurveFragment
  )> }
);

export type UpdateTemperatureCurveMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateTemperatureCurveInput;
}>;


export type UpdateTemperatureCurveMutation = (
  { __typename?: 'Mutation' }
  & { updateTemperatureCurve: (
    { __typename?: 'TemperatureCurve' }
    & TemperatureCurveFragment
  ) }
);

export type TemperatureCurveFragment = (
  { __typename?: 'TemperatureCurve' }
  & Pick<TemperatureCurve, 'id' | 'name' | 'type'>
  & { table: Array<(
    { __typename?: 'TemperatureCurveRow' }
    & Pick<TemperatureCurveRow, 'outdoor' | 'in' | 'return'>
  )> }
);

export type CreateUserGroupMutationVariables = Exact<{
  input: CreateUserGroupInput;
}>;


export type CreateUserGroupMutation = (
  { __typename?: 'Mutation' }
  & { createUserGroup: (
    { __typename?: 'UserGroup' }
    & UserGroupFragment
  ) }
);

export type DeleteUserGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUserGroupMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteUserGroup'>
);

export type UpdateUserGroupMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateUserGroupInput;
}>;


export type UpdateUserGroupMutation = (
  { __typename?: 'Mutation' }
  & { updateUserGroup: (
    { __typename?: 'UserGroup' }
    & UserGroupFragment
  ) }
);

export type UserGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserGroupsQuery = (
  { __typename?: 'Query' }
  & { userGroups: Array<(
    { __typename?: 'UserGroup' }
    & UserGroupFragment
  )> }
);

export type SimpleUserGroupFragment = (
  { __typename?: 'UserGroup' }
  & Pick<UserGroup, 'id' | 'name'>
);

export type UserGroupFragment = (
  { __typename?: 'UserGroup' }
  & Pick<UserGroup, 'id' | 'name'>
  & { users: Array<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'displayName'>
  )> }
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'User' }
    & UserWithRoleFragment
  ) }
);

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String'];
  input: UserInput;
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser: (
    { __typename?: 'User' }
    & UserWithRoleFragment
  ) }
);

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = (
  { __typename?: 'Query' }
  & { users: Array<(
    { __typename?: 'User' }
    & UserWithRoleFragment
  )> }
);

export type UserFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'displayName'>
);

export type UserWithRoleFragment = (
  { __typename?: 'User' }
  & Pick<User, 'role'>
  & { groups: Array<(
    { __typename?: 'UserGroup' }
    & SimpleUserGroupFragment
  )> }
  & UserFragment
);

export const ListProjectFragmentDoc = gql`
    fragment ListProject on Project {
  id
  projectId
  name
  calendarYear
  licensePaid
  createdAt
  updatedAt
  deletedAt
  owner {
    id
    displayName
  }
  updatedBy {
    id
    displayName
  }
  versions {
    id
    isDefault
    buildings {
      id
      area
      multiplier
    }
  }
}
    `;
export const SimpleUserGroupFragmentDoc = gql`
    fragment SimpleUserGroup on UserGroup {
  id
  name
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  displayName
}
    `;
export const BoreholeFieldConfirmationFragmentDoc = gql`
    fragment BoreholeFieldConfirmation on BoreholeFieldConfirmation {
  id
  type
  date
  data {
    holeCount
    holeDepth
    holeUsageForHeatingMonthlyTotal
    holeUsageForHeatingMonthlyMax
    holeUsageForCoolingMonthlyTotal
    holeUsageForCoolingMonthlyMax
  }
  confirmer {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const HourSeriesFragmentDoc = gql`
    fragment HourSeries on HourSeries {
  id
  type
  name
  values
  isInUse
}
    `;
export const DemandFragmentDoc = gql`
    fragment Demand on Demand {
  id
  type
  hourSeries {
    ...HourSeries
  }
}
    ${HourSeriesFragmentDoc}`;
export const HourSeriesCollectionBaseFragmentDoc = gql`
    fragment HourSeriesCollectionBase on HourSeriesCollection {
  id
  type
  name
  hourSeries {
    ...HourSeries
  }
}
    ${HourSeriesFragmentDoc}`;
export const BuildingPartCollectionFragmentDoc = gql`
    fragment BuildingPartCollection on HourSeriesCollection {
  ...HourSeriesCollectionBase
  partArea
}
    ${HourSeriesCollectionBaseFragmentDoc}`;
export const ProviderParametersFragmentDoc = gql`
    fragment ProviderParameters on ProviderParameters {
  isWasteSold
  ... on InefficientParameters {
    efficiency
  }
  ... on HeatBoilerParameters {
    efficiency
    fuelType
  }
  ... on HeatingGroundHeatPumpParameters {
    cop
    maxPower
  }
  ... on HeatingAirHeatPumpParameters {
    cop
    maxPower
    minOutdoorTemperature
  }
  ... on CoolingAirHeatPumpParameters {
    eer
    maxPower
    freeCooling
    freeCoolingMaxOutdoorTemperature
    freeCoolingEer
    freeCoolingMaxPower
  }
  ... on CoolingGroundHeatPumpParameters {
    eer
    maxPower
    freeCooling
    freeCoolingEer
    freeCoolingMaxPower
  }
  ... on WaterCoolingHeatPumpParameters {
    eer
    freeCooling
    freeCoolingMaxOutdoorTemperature
    freeCoolingEer
  }
  ... on CirculationHeatPumpParameters {
    cop
    maxPower
  }
  ... on HybridHeatPumpParameters {
    performanceTableId
    copModifier
    heatSourceAvailable
    heatExhaustAvailable
    heatRecycleAvailable
    heatingPower
    heatingTemperatureCurveId
    dhwHeatingMode
    coolingTemperatureCurveId
    baseHeatSource
    groundHeatSourceTemperature
    groundHeatSourceMaxPower
    airHeatSourceMinTemperature
    wasteHeatSourceAHourSeriesId
    wasteHeatSourceATemperature
    wasteHeatSourceBHourSeriesId
    wasteHeatSourceBTemperature
    freeCoolingSource
    freeGroundCoolingMaxPower
    freeAirCoolingMaxTemperature
    freeCoolingEer
    coolingSource
    groundExhaustTemperature
    heatCircuits {
      demandId
      temperatureCurveId
      isDhwCircuit
    }
  }
  ... on PreheaterParameters {
    relativePower
  }
  ... on SolarPanelParameters {
    area
    solarEfficiency
    ratingEfficiency
    isWasteSold
  }
  ... on BatteryParameters {
    capacity
    chargePower
    dischargePower
  }
}
    `;
export const PerformanceTableFragmentDoc = gql`
    fragment PerformanceTable on PerformanceTable {
  id
  name
  copTable {
    evaporatorTemperature
    columns {
      condenserTemperature
      value
    }
  }
  powerCoefficientTable {
    evaporatorTemperature
    columns {
      condenserTemperature
      value
    }
  }
}
    `;
export const TemperatureCurveFragmentDoc = gql`
    fragment TemperatureCurve on TemperatureCurve {
  id
  name
  type
  table {
    outdoor
    in
    return
  }
}
    `;
export const ProviderDemandFragmentDoc = gql`
    fragment ProviderDemand on ProviderDemand {
  id
  maxPortion
  demand {
    ...Demand
  }
}
    ${DemandFragmentDoc}`;
export const ProviderFragmentDoc = gql`
    fragment Provider on Provider {
  id
  name
  type
  providesElectricityForProviders
  isFallback
  createdAt
  parameters {
    ...ProviderParameters
  }
  hourSeries {
    ...HourSeries
  }
  performanceTables {
    ...PerformanceTable
  }
  temperatureCurves {
    ...TemperatureCurve
  }
  demands {
    ...ProviderDemand
  }
}
    ${ProviderParametersFragmentDoc}
${HourSeriesFragmentDoc}
${PerformanceTableFragmentDoc}
${TemperatureCurveFragmentDoc}
${ProviderDemandFragmentDoc}`;
export const EmissionFragmentDoc = gql`
    fragment Emission on Emission {
  id
  emissionType
  value
  buildingId
}
    `;
export const BuildingFragmentDoc = gql`
    fragment Building on Building {
  id
  name
  area
  type
  multiplier
  holeCount
  holeDepth
  description
  modelingInformation
  pathToSimulation
  confirmationType
  confirmation {
    ...BoreholeFieldConfirmation
  }
  demands {
    ...Demand
  }
  parts {
    ...BuildingPartCollection
  }
  providers {
    ...Provider
  }
  emissions {
    ...Emission
  }
}
    ${BoreholeFieldConfirmationFragmentDoc}
${DemandFragmentDoc}
${BuildingPartCollectionFragmentDoc}
${ProviderFragmentDoc}
${EmissionFragmentDoc}`;
export const LocalGridFragmentDoc = gql`
    fragment LocalGrid on LocalGrid {
  id
  type
  holeCount
  holeDepth
  description
  modelingInformation
  pathToSimulation
  confirmationType
  confirmation {
    ...BoreholeFieldConfirmation
  }
  providers {
    ...Provider
  }
}
    ${BoreholeFieldConfirmationFragmentDoc}
${ProviderFragmentDoc}`;
export const EnergyBusFragmentDoc = gql`
    fragment EnergyBus on EnergyBus {
  id
  holeCount
  holeDepth
  description
  modelingInformation
  pathToSimulation
  confirmationType
  confirmation {
    ...BoreholeFieldConfirmation
  }
  wasteHourSeries {
    ...HourSeries
  }
}
    ${BoreholeFieldConfirmationFragmentDoc}
${HourSeriesFragmentDoc}`;
export const CostFragmentDoc = gql`
    fragment Cost on Cost {
  id
  costType
  recurrencePeriodInYears
  occurrenceYear
  endYear
  description
  value
  providerId
}
    `;
export const PricingModelFragmentDoc = gql`
    fragment PricingModel on PricingModel {
  id
  type
  name
  buildingYear
  inspectionLengthInYears
  yearlyDiscountRate
  yearlyMaintenanceIncreaseRate
  prices {
    energyType
    monthlyValues
  }
  sellingPrices {
    energyType
    monthlyValues
  }
  priceIncreaseRates {
    energyType
    yearlyValue
  }
}
    `;
export const CommentFragmentDoc = gql`
    fragment Comment on Comment {
  id
  locationType
  text
}
    `;
export const ProjectVersionFragmentDoc = gql`
    fragment ProjectVersion on ProjectVersion {
  id
  name
  isDefault
  createdAt
  baseVersionId
  buildings {
    ...Building
  }
  localGrids {
    ...LocalGrid
  }
  energyBus {
    ...EnergyBus
  }
  costs {
    ...Cost
  }
  pricingModel {
    ...PricingModel
  }
  comments {
    ...Comment
  }
}
    ${BuildingFragmentDoc}
${LocalGridFragmentDoc}
${EnergyBusFragmentDoc}
${CostFragmentDoc}
${PricingModelFragmentDoc}
${CommentFragmentDoc}`;
export const OriginalGlobalCollectionFragmentDoc = gql`
    fragment OriginalGlobalCollection on HourSeriesCollection {
  id
  type
  name
}
    `;
export const HourSeriesCollectionFragmentDoc = gql`
    fragment HourSeriesCollection on HourSeriesCollection {
  ...HourSeriesCollectionBase
  updatedAt
  isInUse
  originalGlobalCollection {
    ...OriginalGlobalCollection
  }
}
    ${HourSeriesCollectionBaseFragmentDoc}
${OriginalGlobalCollectionFragmentDoc}`;
export const ScheduleFragmentDoc = gql`
    fragment Schedule on Schedule {
  id
  name
  hourlyProfiles {
    profileType
    values
  }
  weeklyProfile {
    profileTypes
  }
  monthlyProfile {
    multipliers
  }
  exceptionData {
    inUse
    startAt
    endAt
    profileType
  }
  createdAt
}
    `;
export const EnergySystemParametersFragmentDoc = gql`
    fragment EnergySystemParameters on EnergySystemParameters {
  _
  ... on DomesticHotWaterParameters {
    consumptionDensity
    distributionEfficiency
    consumptionFactor
    circulationSpecificLength
    circulationSpecificHeatLoss
    circulationHeatersAmount
    circulationHeatersPower
    wasteWaterHeatContentRatio
  }
  ... on VentilationParameters {
    deviceData {
      deviceName
      effectedArea
      airFlow
      deviceScheduleId
      heatRecoveryEfficiency
      SFP
      systemType
      demandBasedUsageCoefficient
      exhaustAirMinimumTemp
      coolingCoil
      supplyAirTemp
      indoorAirTemp
      returnAirTemp
      chilldrop
      chilldropTempLimit
      exhaustAirHeatPump
    }
    heatingDistributionEfficiency
    heatPumpExhaustAirMinimumTemp
  }
  ... on CoolingParameters {
    systemCoolingPower
    scStartTemp
    scIncreaseSlope
    scIncreaseExtraCoef
    scExtraCoefStartTemp
    scDistributionEfficiency
    scSpacesPortion
    acDemandDisplacementConstant
    acCorrectionCoef
    acIncreaseExtraCoef
    acExtraCoefStartTemp
    acDistributionEfficiency
  }
  ... on HeatLoadParameters {
    occupantHeatLoad
    occupantHeatLoadUtilFactor
    occupantScheduleId
    applianceHeatLoad
    applianceHeatLoadUtilFactor
    applianceScheduleId
    lightingHeatLoad
    lightingHeatLoadUtilFactor
    lightingScheduleId
    heatLoadUtilStartTemp
    affectingSpaceHeatingStartTemp
  }
  ... on ElectricityConsumptionParameters {
    electricityBaseLoad
    occupantLightingElShare
    occupantApplianceElShare
    occupantVentilationElShare
    occupantBaseLoadElShare
  }
  ... on SpaceHeatingParameters {
    exteriorWallArea
    roofArea
    baseFloorArea
    windowsArea
    doorsArea
    exteriorWallUvalue
    roofUvalue
    baseFloorUvalue
    windowsUvalue
    doorsUvalue
    heatBridgeRatio
    q50
    airLeakageXfactor
    heatSupplyEfficiency
    basEfficiency
    affectingHeatLossStartTemp
    dynamicOutTempWeightFactor
    heatLossesCorrectionFactor
    heatLossesCorrectionFactorStartTemp
    supplyAirHeatingStartTemp
    supplyAirFullHeatingStartTemp
  }
}
    `;
export const EnergySystemFragmentDoc = gql`
    fragment EnergySystem on EnergySystem {
  id
  name
  type
  schedule {
    ...Schedule
  }
  parameters {
    ...EnergySystemParameters
  }
}
    ${ScheduleFragmentDoc}
${EnergySystemParametersFragmentDoc}`;
export const BuildingEnergyModelFragmentDoc = gql`
    fragment BuildingEnergyModel on BuildingEnergyModel {
  id
  name
  area
  type
  correctionFactors {
    energyType
    correctionFactor
    energyFactor
  }
  energySystems {
    ...EnergySystem
  }
  schedules {
    ...Schedule
  }
  calibrationDescription
  calibrationArea
  calibrationCorrection
  calibrationStart
  calOutdoorHourSeries {
    ...HourSeries
  }
  calHeatingHourSeries {
    ...HourSeries
  }
  calElectricityHourSeries {
    ...HourSeries
  }
  calCoolingHourSeries {
    ...HourSeries
  }
  calibrationWeeklyProfile
  calibrationMonthlyProfile
  calibrationLimitValues {
    winterTempStart
    winterTempEnd
    summerTempStart
    summerTempEnd
    zeroWeatherTempStart
    zeroWeatherTempEnd
    morningStartHour
    morningEndHour
    dayStartHour
    dayEndHour
    eveningStartHour
    eveningEndHour
    nightStartHour
    nightEndHour
  }
}
    ${EnergySystemFragmentDoc}
${ScheduleFragmentDoc}
${HourSeriesFragmentDoc}`;
export const ProjectFragmentDoc = gql`
    fragment Project on Project {
  id
  projectId
  name
  visibility
  calendarYear
  licensePaid
  createdAt
  updatedAt
  userGroup {
    ...SimpleUserGroup
  }
  owner {
    ...User
  }
  updatedBy {
    ...User
  }
  versions {
    ...ProjectVersion
  }
  hourSeriesCollections {
    ...HourSeriesCollection
  }
  buildingEnergyModels {
    ...BuildingEnergyModel
  }
  pricingModels {
    ...PricingModel
  }
  temperatureHourSeries {
    ...HourSeries
  }
  comments {
    ...Comment
  }
}
    ${SimpleUserGroupFragmentDoc}
${UserFragmentDoc}
${ProjectVersionFragmentDoc}
${HourSeriesCollectionFragmentDoc}
${BuildingEnergyModelFragmentDoc}
${PricingModelFragmentDoc}
${HourSeriesFragmentDoc}
${CommentFragmentDoc}`;
export const ProjectCollectionsFragmentDoc = gql`
    fragment ProjectCollections on Project {
  id
  hourSeriesCollections {
    ...HourSeriesCollection
  }
}
    ${HourSeriesCollectionFragmentDoc}`;
export const ProjectTemperatureCurvesFragmentDoc = gql`
    fragment ProjectTemperatureCurves on Project {
  id
  temperatureCurves {
    ...TemperatureCurve
  }
}
    ${TemperatureCurveFragmentDoc}`;
export const UserGroupFragmentDoc = gql`
    fragment UserGroup on UserGroup {
  id
  name
  users {
    id
    displayName
  }
}
    `;
export const UserWithRoleFragmentDoc = gql`
    fragment UserWithRole on User {
  ...User
  role
  groups {
    ...SimpleUserGroup
  }
}
    ${UserFragmentDoc}
${SimpleUserGroupFragmentDoc}`;
export const CreateBuildingEnergyModelDocument = gql`
    mutation CreateBuildingEnergyModel($projectId: String!, $input: CreateBuildingEnergyModelInput!) {
  createBuildingEnergyModel(projectId: $projectId, input: $input) {
    ...BuildingEnergyModel
  }
}
    ${BuildingEnergyModelFragmentDoc}`;
export type CreateBuildingEnergyModelMutationFn = Apollo.MutationFunction<CreateBuildingEnergyModelMutation, CreateBuildingEnergyModelMutationVariables>;

/**
 * __useCreateBuildingEnergyModelMutation__
 *
 * To run a mutation, you first call `useCreateBuildingEnergyModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildingEnergyModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildingEnergyModelMutation, { data, loading, error }] = useCreateBuildingEnergyModelMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBuildingEnergyModelMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildingEnergyModelMutation, CreateBuildingEnergyModelMutationVariables>) {
        return Apollo.useMutation<CreateBuildingEnergyModelMutation, CreateBuildingEnergyModelMutationVariables>(CreateBuildingEnergyModelDocument, baseOptions);
      }
export type CreateBuildingEnergyModelMutationHookResult = ReturnType<typeof useCreateBuildingEnergyModelMutation>;
export type CreateBuildingEnergyModelMutationResult = Apollo.MutationResult<CreateBuildingEnergyModelMutation>;
export type CreateBuildingEnergyModelMutationOptions = Apollo.BaseMutationOptions<CreateBuildingEnergyModelMutation, CreateBuildingEnergyModelMutationVariables>;
export const DeleteBuildingEnergyModelDocument = gql`
    mutation DeleteBuildingEnergyModel($id: String!) {
  deleteBuildingEnergyModel(id: $id)
}
    `;
export type DeleteBuildingEnergyModelMutationFn = Apollo.MutationFunction<DeleteBuildingEnergyModelMutation, DeleteBuildingEnergyModelMutationVariables>;

/**
 * __useDeleteBuildingEnergyModelMutation__
 *
 * To run a mutation, you first call `useDeleteBuildingEnergyModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBuildingEnergyModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBuildingEnergyModelMutation, { data, loading, error }] = useDeleteBuildingEnergyModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBuildingEnergyModelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBuildingEnergyModelMutation, DeleteBuildingEnergyModelMutationVariables>) {
        return Apollo.useMutation<DeleteBuildingEnergyModelMutation, DeleteBuildingEnergyModelMutationVariables>(DeleteBuildingEnergyModelDocument, baseOptions);
      }
export type DeleteBuildingEnergyModelMutationHookResult = ReturnType<typeof useDeleteBuildingEnergyModelMutation>;
export type DeleteBuildingEnergyModelMutationResult = Apollo.MutationResult<DeleteBuildingEnergyModelMutation>;
export type DeleteBuildingEnergyModelMutationOptions = Apollo.BaseMutationOptions<DeleteBuildingEnergyModelMutation, DeleteBuildingEnergyModelMutationVariables>;
export const UpdateBuildingEnergyModelDocument = gql`
    mutation UpdateBuildingEnergyModel($id: String!, $input: UpdateBuildingEnergyModelInput!) {
  updateBuildingEnergyModel(id: $id, input: $input) {
    ...BuildingEnergyModel
  }
}
    ${BuildingEnergyModelFragmentDoc}`;
export type UpdateBuildingEnergyModelMutationFn = Apollo.MutationFunction<UpdateBuildingEnergyModelMutation, UpdateBuildingEnergyModelMutationVariables>;

/**
 * __useUpdateBuildingEnergyModelMutation__
 *
 * To run a mutation, you first call `useUpdateBuildingEnergyModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuildingEnergyModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuildingEnergyModelMutation, { data, loading, error }] = useUpdateBuildingEnergyModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBuildingEnergyModelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuildingEnergyModelMutation, UpdateBuildingEnergyModelMutationVariables>) {
        return Apollo.useMutation<UpdateBuildingEnergyModelMutation, UpdateBuildingEnergyModelMutationVariables>(UpdateBuildingEnergyModelDocument, baseOptions);
      }
export type UpdateBuildingEnergyModelMutationHookResult = ReturnType<typeof useUpdateBuildingEnergyModelMutation>;
export type UpdateBuildingEnergyModelMutationResult = Apollo.MutationResult<UpdateBuildingEnergyModelMutation>;
export type UpdateBuildingEnergyModelMutationOptions = Apollo.BaseMutationOptions<UpdateBuildingEnergyModelMutation, UpdateBuildingEnergyModelMutationVariables>;
export const CreateBuildingDocument = gql`
    mutation CreateBuilding($projectVersionId: String!, $input: CreateBuildingInput!) {
  createBuilding(projectVersionId: $projectVersionId, input: $input) {
    ...Building
  }
}
    ${BuildingFragmentDoc}`;
export type CreateBuildingMutationFn = Apollo.MutationFunction<CreateBuildingMutation, CreateBuildingMutationVariables>;

/**
 * __useCreateBuildingMutation__
 *
 * To run a mutation, you first call `useCreateBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildingMutation, { data, loading, error }] = useCreateBuildingMutation({
 *   variables: {
 *      projectVersionId: // value for 'projectVersionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBuildingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildingMutation, CreateBuildingMutationVariables>) {
        return Apollo.useMutation<CreateBuildingMutation, CreateBuildingMutationVariables>(CreateBuildingDocument, baseOptions);
      }
export type CreateBuildingMutationHookResult = ReturnType<typeof useCreateBuildingMutation>;
export type CreateBuildingMutationResult = Apollo.MutationResult<CreateBuildingMutation>;
export type CreateBuildingMutationOptions = Apollo.BaseMutationOptions<CreateBuildingMutation, CreateBuildingMutationVariables>;
export const DeleteBuildingDocument = gql`
    mutation DeleteBuilding($id: String!) {
  deleteBuilding(id: $id)
}
    `;
export type DeleteBuildingMutationFn = Apollo.MutationFunction<DeleteBuildingMutation, DeleteBuildingMutationVariables>;

/**
 * __useDeleteBuildingMutation__
 *
 * To run a mutation, you first call `useDeleteBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBuildingMutation, { data, loading, error }] = useDeleteBuildingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBuildingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBuildingMutation, DeleteBuildingMutationVariables>) {
        return Apollo.useMutation<DeleteBuildingMutation, DeleteBuildingMutationVariables>(DeleteBuildingDocument, baseOptions);
      }
export type DeleteBuildingMutationHookResult = ReturnType<typeof useDeleteBuildingMutation>;
export type DeleteBuildingMutationResult = Apollo.MutationResult<DeleteBuildingMutation>;
export type DeleteBuildingMutationOptions = Apollo.BaseMutationOptions<DeleteBuildingMutation, DeleteBuildingMutationVariables>;
export const UpdateBuildingDocument = gql`
    mutation UpdateBuilding($id: String!, $input: UpdateBuildingInput!) {
  updateBuilding(id: $id, input: $input) {
    ...Building
  }
}
    ${BuildingFragmentDoc}`;
export type UpdateBuildingMutationFn = Apollo.MutationFunction<UpdateBuildingMutation, UpdateBuildingMutationVariables>;

/**
 * __useUpdateBuildingMutation__
 *
 * To run a mutation, you first call `useUpdateBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuildingMutation, { data, loading, error }] = useUpdateBuildingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBuildingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuildingMutation, UpdateBuildingMutationVariables>) {
        return Apollo.useMutation<UpdateBuildingMutation, UpdateBuildingMutationVariables>(UpdateBuildingDocument, baseOptions);
      }
export type UpdateBuildingMutationHookResult = ReturnType<typeof useUpdateBuildingMutation>;
export type UpdateBuildingMutationResult = Apollo.MutationResult<UpdateBuildingMutation>;
export type UpdateBuildingMutationOptions = Apollo.BaseMutationOptions<UpdateBuildingMutation, UpdateBuildingMutationVariables>;
export const UpdateBuildingBoreholeFieldDocument = gql`
    mutation UpdateBuildingBoreholeField($id: String!, $input: BoreholeFieldContainerInput!) {
  updateBuildingBoreholeField(id: $id, input: $input) {
    ...Building
  }
}
    ${BuildingFragmentDoc}`;
export type UpdateBuildingBoreholeFieldMutationFn = Apollo.MutationFunction<UpdateBuildingBoreholeFieldMutation, UpdateBuildingBoreholeFieldMutationVariables>;

/**
 * __useUpdateBuildingBoreholeFieldMutation__
 *
 * To run a mutation, you first call `useUpdateBuildingBoreholeFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuildingBoreholeFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuildingBoreholeFieldMutation, { data, loading, error }] = useUpdateBuildingBoreholeFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBuildingBoreholeFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuildingBoreholeFieldMutation, UpdateBuildingBoreholeFieldMutationVariables>) {
        return Apollo.useMutation<UpdateBuildingBoreholeFieldMutation, UpdateBuildingBoreholeFieldMutationVariables>(UpdateBuildingBoreholeFieldDocument, baseOptions);
      }
export type UpdateBuildingBoreholeFieldMutationHookResult = ReturnType<typeof useUpdateBuildingBoreholeFieldMutation>;
export type UpdateBuildingBoreholeFieldMutationResult = Apollo.MutationResult<UpdateBuildingBoreholeFieldMutation>;
export type UpdateBuildingBoreholeFieldMutationOptions = Apollo.BaseMutationOptions<UpdateBuildingBoreholeFieldMutation, UpdateBuildingBoreholeFieldMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($input: CreateCommentInput!, $projectId: String, $projectVersionId: String) {
  createComment(
    input: $input
    projectId: $projectId
    projectVersionId: $projectVersionId
  ) {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      projectId: // value for 'projectId'
 *      projectVersionId: // value for 'projectVersionId'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, baseOptions);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($id: String!) {
  deleteComment(id: $id)
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, baseOptions);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($id: String!, $input: UpdateCommentInput!) {
  updateComment(id: $id, input: $input) {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, baseOptions);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const CreateCostDocument = gql`
    mutation CreateCost($projectVersionId: String!, $input: CreateCostInput!, $providerId: String) {
  createCost(
    projectVersionId: $projectVersionId
    input: $input
    providerId: $providerId
  ) {
    ...Cost
  }
}
    ${CostFragmentDoc}`;
export type CreateCostMutationFn = Apollo.MutationFunction<CreateCostMutation, CreateCostMutationVariables>;

/**
 * __useCreateCostMutation__
 *
 * To run a mutation, you first call `useCreateCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCostMutation, { data, loading, error }] = useCreateCostMutation({
 *   variables: {
 *      projectVersionId: // value for 'projectVersionId'
 *      input: // value for 'input'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useCreateCostMutation(baseOptions?: Apollo.MutationHookOptions<CreateCostMutation, CreateCostMutationVariables>) {
        return Apollo.useMutation<CreateCostMutation, CreateCostMutationVariables>(CreateCostDocument, baseOptions);
      }
export type CreateCostMutationHookResult = ReturnType<typeof useCreateCostMutation>;
export type CreateCostMutationResult = Apollo.MutationResult<CreateCostMutation>;
export type CreateCostMutationOptions = Apollo.BaseMutationOptions<CreateCostMutation, CreateCostMutationVariables>;
export const DeleteCostDocument = gql`
    mutation DeleteCost($id: String!) {
  deleteCost(id: $id)
}
    `;
export type DeleteCostMutationFn = Apollo.MutationFunction<DeleteCostMutation, DeleteCostMutationVariables>;

/**
 * __useDeleteCostMutation__
 *
 * To run a mutation, you first call `useDeleteCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCostMutation, { data, loading, error }] = useDeleteCostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCostMutation, DeleteCostMutationVariables>) {
        return Apollo.useMutation<DeleteCostMutation, DeleteCostMutationVariables>(DeleteCostDocument, baseOptions);
      }
export type DeleteCostMutationHookResult = ReturnType<typeof useDeleteCostMutation>;
export type DeleteCostMutationResult = Apollo.MutationResult<DeleteCostMutation>;
export type DeleteCostMutationOptions = Apollo.BaseMutationOptions<DeleteCostMutation, DeleteCostMutationVariables>;
export const UpdateCostDocument = gql`
    mutation UpdateCost($id: String!, $input: UpdateCostInput!) {
  updateCost(id: $id, input: $input) {
    ...Cost
  }
}
    ${CostFragmentDoc}`;
export type UpdateCostMutationFn = Apollo.MutationFunction<UpdateCostMutation, UpdateCostMutationVariables>;

/**
 * __useUpdateCostMutation__
 *
 * To run a mutation, you first call `useUpdateCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCostMutation, { data, loading, error }] = useUpdateCostMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCostMutation, UpdateCostMutationVariables>) {
        return Apollo.useMutation<UpdateCostMutation, UpdateCostMutationVariables>(UpdateCostDocument, baseOptions);
      }
export type UpdateCostMutationHookResult = ReturnType<typeof useUpdateCostMutation>;
export type UpdateCostMutationResult = Apollo.MutationResult<UpdateCostMutation>;
export type UpdateCostMutationOptions = Apollo.BaseMutationOptions<UpdateCostMutation, UpdateCostMutationVariables>;
export const CreateEmissionDocument = gql`
    mutation CreateEmission($buildingId: String!, $input: CreateEmissionInput!) {
  createEmission(buildingId: $buildingId, input: $input) {
    ...Emission
  }
}
    ${EmissionFragmentDoc}`;
export type CreateEmissionMutationFn = Apollo.MutationFunction<CreateEmissionMutation, CreateEmissionMutationVariables>;

/**
 * __useCreateEmissionMutation__
 *
 * To run a mutation, you first call `useCreateEmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmissionMutation, { data, loading, error }] = useCreateEmissionMutation({
 *   variables: {
 *      buildingId: // value for 'buildingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmissionMutation, CreateEmissionMutationVariables>) {
        return Apollo.useMutation<CreateEmissionMutation, CreateEmissionMutationVariables>(CreateEmissionDocument, baseOptions);
      }
export type CreateEmissionMutationHookResult = ReturnType<typeof useCreateEmissionMutation>;
export type CreateEmissionMutationResult = Apollo.MutationResult<CreateEmissionMutation>;
export type CreateEmissionMutationOptions = Apollo.BaseMutationOptions<CreateEmissionMutation, CreateEmissionMutationVariables>;
export const DeleteEmissionDocument = gql`
    mutation DeleteEmission($id: String!) {
  deleteEmission(id: $id)
}
    `;
export type DeleteEmissionMutationFn = Apollo.MutationFunction<DeleteEmissionMutation, DeleteEmissionMutationVariables>;

/**
 * __useDeleteEmissionMutation__
 *
 * To run a mutation, you first call `useDeleteEmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmissionMutation, { data, loading, error }] = useDeleteEmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmissionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmissionMutation, DeleteEmissionMutationVariables>) {
        return Apollo.useMutation<DeleteEmissionMutation, DeleteEmissionMutationVariables>(DeleteEmissionDocument, baseOptions);
      }
export type DeleteEmissionMutationHookResult = ReturnType<typeof useDeleteEmissionMutation>;
export type DeleteEmissionMutationResult = Apollo.MutationResult<DeleteEmissionMutation>;
export type DeleteEmissionMutationOptions = Apollo.BaseMutationOptions<DeleteEmissionMutation, DeleteEmissionMutationVariables>;
export const UpdateEmissionDocument = gql`
    mutation UpdateEmission($id: String!, $input: UpdateEmissionInput!) {
  updateEmission(id: $id, input: $input) {
    ...Emission
  }
}
    ${EmissionFragmentDoc}`;
export type UpdateEmissionMutationFn = Apollo.MutationFunction<UpdateEmissionMutation, UpdateEmissionMutationVariables>;

/**
 * __useUpdateEmissionMutation__
 *
 * To run a mutation, you first call `useUpdateEmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmissionMutation, { data, loading, error }] = useUpdateEmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmissionMutation, UpdateEmissionMutationVariables>) {
        return Apollo.useMutation<UpdateEmissionMutation, UpdateEmissionMutationVariables>(UpdateEmissionDocument, baseOptions);
      }
export type UpdateEmissionMutationHookResult = ReturnType<typeof useUpdateEmissionMutation>;
export type UpdateEmissionMutationResult = Apollo.MutationResult<UpdateEmissionMutation>;
export type UpdateEmissionMutationOptions = Apollo.BaseMutationOptions<UpdateEmissionMutation, UpdateEmissionMutationVariables>;
export const CreateEnergyBusDocument = gql`
    mutation CreateEnergyBus($projectVersionId: String!, $input: CreateEnergyBusInput!) {
  createEnergyBus(projectVersionId: $projectVersionId, input: $input) {
    ...EnergyBus
  }
}
    ${EnergyBusFragmentDoc}`;
export type CreateEnergyBusMutationFn = Apollo.MutationFunction<CreateEnergyBusMutation, CreateEnergyBusMutationVariables>;

/**
 * __useCreateEnergyBusMutation__
 *
 * To run a mutation, you first call `useCreateEnergyBusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnergyBusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnergyBusMutation, { data, loading, error }] = useCreateEnergyBusMutation({
 *   variables: {
 *      projectVersionId: // value for 'projectVersionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnergyBusMutation(baseOptions?: Apollo.MutationHookOptions<CreateEnergyBusMutation, CreateEnergyBusMutationVariables>) {
        return Apollo.useMutation<CreateEnergyBusMutation, CreateEnergyBusMutationVariables>(CreateEnergyBusDocument, baseOptions);
      }
export type CreateEnergyBusMutationHookResult = ReturnType<typeof useCreateEnergyBusMutation>;
export type CreateEnergyBusMutationResult = Apollo.MutationResult<CreateEnergyBusMutation>;
export type CreateEnergyBusMutationOptions = Apollo.BaseMutationOptions<CreateEnergyBusMutation, CreateEnergyBusMutationVariables>;
export const DeleteEnergyBusDocument = gql`
    mutation DeleteEnergyBus($id: String!) {
  deleteEnergyBus(id: $id)
}
    `;
export type DeleteEnergyBusMutationFn = Apollo.MutationFunction<DeleteEnergyBusMutation, DeleteEnergyBusMutationVariables>;

/**
 * __useDeleteEnergyBusMutation__
 *
 * To run a mutation, you first call `useDeleteEnergyBusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnergyBusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnergyBusMutation, { data, loading, error }] = useDeleteEnergyBusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEnergyBusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEnergyBusMutation, DeleteEnergyBusMutationVariables>) {
        return Apollo.useMutation<DeleteEnergyBusMutation, DeleteEnergyBusMutationVariables>(DeleteEnergyBusDocument, baseOptions);
      }
export type DeleteEnergyBusMutationHookResult = ReturnType<typeof useDeleteEnergyBusMutation>;
export type DeleteEnergyBusMutationResult = Apollo.MutationResult<DeleteEnergyBusMutation>;
export type DeleteEnergyBusMutationOptions = Apollo.BaseMutationOptions<DeleteEnergyBusMutation, DeleteEnergyBusMutationVariables>;
export const UpdateEnergyBusDocument = gql`
    mutation UpdateEnergyBus($id: String!, $input: UpdateEnergyBusInput!) {
  updateEnergyBus(id: $id, input: $input) {
    ...EnergyBus
  }
}
    ${EnergyBusFragmentDoc}`;
export type UpdateEnergyBusMutationFn = Apollo.MutationFunction<UpdateEnergyBusMutation, UpdateEnergyBusMutationVariables>;

/**
 * __useUpdateEnergyBusMutation__
 *
 * To run a mutation, you first call `useUpdateEnergyBusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnergyBusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnergyBusMutation, { data, loading, error }] = useUpdateEnergyBusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnergyBusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnergyBusMutation, UpdateEnergyBusMutationVariables>) {
        return Apollo.useMutation<UpdateEnergyBusMutation, UpdateEnergyBusMutationVariables>(UpdateEnergyBusDocument, baseOptions);
      }
export type UpdateEnergyBusMutationHookResult = ReturnType<typeof useUpdateEnergyBusMutation>;
export type UpdateEnergyBusMutationResult = Apollo.MutationResult<UpdateEnergyBusMutation>;
export type UpdateEnergyBusMutationOptions = Apollo.BaseMutationOptions<UpdateEnergyBusMutation, UpdateEnergyBusMutationVariables>;
export const UpdateEnergyBusBoreholeFieldDocument = gql`
    mutation UpdateEnergyBusBoreholeField($id: String!, $input: BoreholeFieldContainerInput!) {
  updateEnergyBusBoreholeField(id: $id, input: $input) {
    ...EnergyBus
  }
}
    ${EnergyBusFragmentDoc}`;
export type UpdateEnergyBusBoreholeFieldMutationFn = Apollo.MutationFunction<UpdateEnergyBusBoreholeFieldMutation, UpdateEnergyBusBoreholeFieldMutationVariables>;

/**
 * __useUpdateEnergyBusBoreholeFieldMutation__
 *
 * To run a mutation, you first call `useUpdateEnergyBusBoreholeFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnergyBusBoreholeFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnergyBusBoreholeFieldMutation, { data, loading, error }] = useUpdateEnergyBusBoreholeFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnergyBusBoreholeFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnergyBusBoreholeFieldMutation, UpdateEnergyBusBoreholeFieldMutationVariables>) {
        return Apollo.useMutation<UpdateEnergyBusBoreholeFieldMutation, UpdateEnergyBusBoreholeFieldMutationVariables>(UpdateEnergyBusBoreholeFieldDocument, baseOptions);
      }
export type UpdateEnergyBusBoreholeFieldMutationHookResult = ReturnType<typeof useUpdateEnergyBusBoreholeFieldMutation>;
export type UpdateEnergyBusBoreholeFieldMutationResult = Apollo.MutationResult<UpdateEnergyBusBoreholeFieldMutation>;
export type UpdateEnergyBusBoreholeFieldMutationOptions = Apollo.BaseMutationOptions<UpdateEnergyBusBoreholeFieldMutation, UpdateEnergyBusBoreholeFieldMutationVariables>;
export const CreateEnergySystemDocument = gql`
    mutation CreateEnergySystem($buildingEnergyModelId: String!, $input: CreateEnergySystemInput!) {
  createEnergySystem(buildingEnergyModelId: $buildingEnergyModelId, input: $input) {
    ...EnergySystem
  }
}
    ${EnergySystemFragmentDoc}`;
export type CreateEnergySystemMutationFn = Apollo.MutationFunction<CreateEnergySystemMutation, CreateEnergySystemMutationVariables>;

/**
 * __useCreateEnergySystemMutation__
 *
 * To run a mutation, you first call `useCreateEnergySystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnergySystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnergySystemMutation, { data, loading, error }] = useCreateEnergySystemMutation({
 *   variables: {
 *      buildingEnergyModelId: // value for 'buildingEnergyModelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnergySystemMutation(baseOptions?: Apollo.MutationHookOptions<CreateEnergySystemMutation, CreateEnergySystemMutationVariables>) {
        return Apollo.useMutation<CreateEnergySystemMutation, CreateEnergySystemMutationVariables>(CreateEnergySystemDocument, baseOptions);
      }
export type CreateEnergySystemMutationHookResult = ReturnType<typeof useCreateEnergySystemMutation>;
export type CreateEnergySystemMutationResult = Apollo.MutationResult<CreateEnergySystemMutation>;
export type CreateEnergySystemMutationOptions = Apollo.BaseMutationOptions<CreateEnergySystemMutation, CreateEnergySystemMutationVariables>;
export const DeleteEnergySystemDocument = gql`
    mutation DeleteEnergySystem($id: String!) {
  deleteEnergySystem(id: $id)
}
    `;
export type DeleteEnergySystemMutationFn = Apollo.MutationFunction<DeleteEnergySystemMutation, DeleteEnergySystemMutationVariables>;

/**
 * __useDeleteEnergySystemMutation__
 *
 * To run a mutation, you first call `useDeleteEnergySystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnergySystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnergySystemMutation, { data, loading, error }] = useDeleteEnergySystemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEnergySystemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEnergySystemMutation, DeleteEnergySystemMutationVariables>) {
        return Apollo.useMutation<DeleteEnergySystemMutation, DeleteEnergySystemMutationVariables>(DeleteEnergySystemDocument, baseOptions);
      }
export type DeleteEnergySystemMutationHookResult = ReturnType<typeof useDeleteEnergySystemMutation>;
export type DeleteEnergySystemMutationResult = Apollo.MutationResult<DeleteEnergySystemMutation>;
export type DeleteEnergySystemMutationOptions = Apollo.BaseMutationOptions<DeleteEnergySystemMutation, DeleteEnergySystemMutationVariables>;
export const UpdateEnergySystemDocument = gql`
    mutation UpdateEnergySystem($id: String!, $input: UpdateEnergySystemInput!) {
  updateEnergySystem(id: $id, input: $input) {
    ...EnergySystem
  }
}
    ${EnergySystemFragmentDoc}`;
export type UpdateEnergySystemMutationFn = Apollo.MutationFunction<UpdateEnergySystemMutation, UpdateEnergySystemMutationVariables>;

/**
 * __useUpdateEnergySystemMutation__
 *
 * To run a mutation, you first call `useUpdateEnergySystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnergySystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnergySystemMutation, { data, loading, error }] = useUpdateEnergySystemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnergySystemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnergySystemMutation, UpdateEnergySystemMutationVariables>) {
        return Apollo.useMutation<UpdateEnergySystemMutation, UpdateEnergySystemMutationVariables>(UpdateEnergySystemDocument, baseOptions);
      }
export type UpdateEnergySystemMutationHookResult = ReturnType<typeof useUpdateEnergySystemMutation>;
export type UpdateEnergySystemMutationResult = Apollo.MutationResult<UpdateEnergySystemMutation>;
export type UpdateEnergySystemMutationOptions = Apollo.BaseMutationOptions<UpdateEnergySystemMutation, UpdateEnergySystemMutationVariables>;
export const CreateGlobalHourSeriesCollectionsDocument = gql`
    mutation CreateGlobalHourSeriesCollections($hourSeriesFile: Upload!, $shouldOverwrite: Boolean!) {
  createGlobalHourSeriesCollections(
    hourSeriesFile: $hourSeriesFile
    shouldOverwrite: $shouldOverwrite
  ) {
    ...HourSeriesCollection
  }
}
    ${HourSeriesCollectionFragmentDoc}`;
export type CreateGlobalHourSeriesCollectionsMutationFn = Apollo.MutationFunction<CreateGlobalHourSeriesCollectionsMutation, CreateGlobalHourSeriesCollectionsMutationVariables>;

/**
 * __useCreateGlobalHourSeriesCollectionsMutation__
 *
 * To run a mutation, you first call `useCreateGlobalHourSeriesCollectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlobalHourSeriesCollectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlobalHourSeriesCollectionsMutation, { data, loading, error }] = useCreateGlobalHourSeriesCollectionsMutation({
 *   variables: {
 *      hourSeriesFile: // value for 'hourSeriesFile'
 *      shouldOverwrite: // value for 'shouldOverwrite'
 *   },
 * });
 */
export function useCreateGlobalHourSeriesCollectionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateGlobalHourSeriesCollectionsMutation, CreateGlobalHourSeriesCollectionsMutationVariables>) {
        return Apollo.useMutation<CreateGlobalHourSeriesCollectionsMutation, CreateGlobalHourSeriesCollectionsMutationVariables>(CreateGlobalHourSeriesCollectionsDocument, baseOptions);
      }
export type CreateGlobalHourSeriesCollectionsMutationHookResult = ReturnType<typeof useCreateGlobalHourSeriesCollectionsMutation>;
export type CreateGlobalHourSeriesCollectionsMutationResult = Apollo.MutationResult<CreateGlobalHourSeriesCollectionsMutation>;
export type CreateGlobalHourSeriesCollectionsMutationOptions = Apollo.BaseMutationOptions<CreateGlobalHourSeriesCollectionsMutation, CreateGlobalHourSeriesCollectionsMutationVariables>;
export const CreateHourSeriesCollectionDocument = gql`
    mutation CreateHourSeriesCollection($projectId: String!, $input: CreateHourSeriesCollectionInput!, $shouldOverwrite: Boolean!) {
  createHourSeriesCollection(
    projectId: $projectId
    input: $input
    shouldOverwrite: $shouldOverwrite
  ) {
    ...HourSeriesCollection
  }
}
    ${HourSeriesCollectionFragmentDoc}`;
export type CreateHourSeriesCollectionMutationFn = Apollo.MutationFunction<CreateHourSeriesCollectionMutation, CreateHourSeriesCollectionMutationVariables>;

/**
 * __useCreateHourSeriesCollectionMutation__
 *
 * To run a mutation, you first call `useCreateHourSeriesCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHourSeriesCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHourSeriesCollectionMutation, { data, loading, error }] = useCreateHourSeriesCollectionMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *      shouldOverwrite: // value for 'shouldOverwrite'
 *   },
 * });
 */
export function useCreateHourSeriesCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateHourSeriesCollectionMutation, CreateHourSeriesCollectionMutationVariables>) {
        return Apollo.useMutation<CreateHourSeriesCollectionMutation, CreateHourSeriesCollectionMutationVariables>(CreateHourSeriesCollectionDocument, baseOptions);
      }
export type CreateHourSeriesCollectionMutationHookResult = ReturnType<typeof useCreateHourSeriesCollectionMutation>;
export type CreateHourSeriesCollectionMutationResult = Apollo.MutationResult<CreateHourSeriesCollectionMutation>;
export type CreateHourSeriesCollectionMutationOptions = Apollo.BaseMutationOptions<CreateHourSeriesCollectionMutation, CreateHourSeriesCollectionMutationVariables>;
export const CreateHourSeriesCollectionsDocument = gql`
    mutation CreateHourSeriesCollections($projectId: String!, $hourSeriesFile: Upload!, $shouldOverwrite: Boolean!) {
  createHourSeriesCollections(
    projectId: $projectId
    hourSeriesFile: $hourSeriesFile
    shouldOverwrite: $shouldOverwrite
  ) {
    ...HourSeriesCollection
  }
}
    ${HourSeriesCollectionFragmentDoc}`;
export type CreateHourSeriesCollectionsMutationFn = Apollo.MutationFunction<CreateHourSeriesCollectionsMutation, CreateHourSeriesCollectionsMutationVariables>;

/**
 * __useCreateHourSeriesCollectionsMutation__
 *
 * To run a mutation, you first call `useCreateHourSeriesCollectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHourSeriesCollectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHourSeriesCollectionsMutation, { data, loading, error }] = useCreateHourSeriesCollectionsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      hourSeriesFile: // value for 'hourSeriesFile'
 *      shouldOverwrite: // value for 'shouldOverwrite'
 *   },
 * });
 */
export function useCreateHourSeriesCollectionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateHourSeriesCollectionsMutation, CreateHourSeriesCollectionsMutationVariables>) {
        return Apollo.useMutation<CreateHourSeriesCollectionsMutation, CreateHourSeriesCollectionsMutationVariables>(CreateHourSeriesCollectionsDocument, baseOptions);
      }
export type CreateHourSeriesCollectionsMutationHookResult = ReturnType<typeof useCreateHourSeriesCollectionsMutation>;
export type CreateHourSeriesCollectionsMutationResult = Apollo.MutationResult<CreateHourSeriesCollectionsMutation>;
export type CreateHourSeriesCollectionsMutationOptions = Apollo.BaseMutationOptions<CreateHourSeriesCollectionsMutation, CreateHourSeriesCollectionsMutationVariables>;
export const DeleteHourSeriesCollectionsDocument = gql`
    mutation DeleteHourSeriesCollections($id: String!) {
  deleteHourSeriesCollection(id: $id)
}
    `;
export type DeleteHourSeriesCollectionsMutationFn = Apollo.MutationFunction<DeleteHourSeriesCollectionsMutation, DeleteHourSeriesCollectionsMutationVariables>;

/**
 * __useDeleteHourSeriesCollectionsMutation__
 *
 * To run a mutation, you first call `useDeleteHourSeriesCollectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHourSeriesCollectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHourSeriesCollectionsMutation, { data, loading, error }] = useDeleteHourSeriesCollectionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHourSeriesCollectionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHourSeriesCollectionsMutation, DeleteHourSeriesCollectionsMutationVariables>) {
        return Apollo.useMutation<DeleteHourSeriesCollectionsMutation, DeleteHourSeriesCollectionsMutationVariables>(DeleteHourSeriesCollectionsDocument, baseOptions);
      }
export type DeleteHourSeriesCollectionsMutationHookResult = ReturnType<typeof useDeleteHourSeriesCollectionsMutation>;
export type DeleteHourSeriesCollectionsMutationResult = Apollo.MutationResult<DeleteHourSeriesCollectionsMutation>;
export type DeleteHourSeriesCollectionsMutationOptions = Apollo.BaseMutationOptions<DeleteHourSeriesCollectionsMutation, DeleteHourSeriesCollectionsMutationVariables>;
export const GlobalHourSeriesCollectionsDocument = gql`
    query GlobalHourSeriesCollections {
  globalHourSeriesCollections {
    ...HourSeriesCollection
  }
}
    ${HourSeriesCollectionFragmentDoc}`;

/**
 * __useGlobalHourSeriesCollectionsQuery__
 *
 * To run a query within a React component, call `useGlobalHourSeriesCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalHourSeriesCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalHourSeriesCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalHourSeriesCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<GlobalHourSeriesCollectionsQuery, GlobalHourSeriesCollectionsQueryVariables>) {
        return Apollo.useQuery<GlobalHourSeriesCollectionsQuery, GlobalHourSeriesCollectionsQueryVariables>(GlobalHourSeriesCollectionsDocument, baseOptions);
      }
export function useGlobalHourSeriesCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalHourSeriesCollectionsQuery, GlobalHourSeriesCollectionsQueryVariables>) {
          return Apollo.useLazyQuery<GlobalHourSeriesCollectionsQuery, GlobalHourSeriesCollectionsQueryVariables>(GlobalHourSeriesCollectionsDocument, baseOptions);
        }
export type GlobalHourSeriesCollectionsQueryHookResult = ReturnType<typeof useGlobalHourSeriesCollectionsQuery>;
export type GlobalHourSeriesCollectionsLazyQueryHookResult = ReturnType<typeof useGlobalHourSeriesCollectionsLazyQuery>;
export type GlobalHourSeriesCollectionsQueryResult = Apollo.QueryResult<GlobalHourSeriesCollectionsQuery, GlobalHourSeriesCollectionsQueryVariables>;
export const UpdateHourSeriesCollectionsDocument = gql`
    mutation UpdateHourSeriesCollections($id: String!, $input: UpdateHourSeriesCollectionInput!) {
  updateHourSeriesCollection(id: $id, input: $input) {
    ...HourSeriesCollection
  }
}
    ${HourSeriesCollectionFragmentDoc}`;
export type UpdateHourSeriesCollectionsMutationFn = Apollo.MutationFunction<UpdateHourSeriesCollectionsMutation, UpdateHourSeriesCollectionsMutationVariables>;

/**
 * __useUpdateHourSeriesCollectionsMutation__
 *
 * To run a mutation, you first call `useUpdateHourSeriesCollectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHourSeriesCollectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHourSeriesCollectionsMutation, { data, loading, error }] = useUpdateHourSeriesCollectionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHourSeriesCollectionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHourSeriesCollectionsMutation, UpdateHourSeriesCollectionsMutationVariables>) {
        return Apollo.useMutation<UpdateHourSeriesCollectionsMutation, UpdateHourSeriesCollectionsMutationVariables>(UpdateHourSeriesCollectionsDocument, baseOptions);
      }
export type UpdateHourSeriesCollectionsMutationHookResult = ReturnType<typeof useUpdateHourSeriesCollectionsMutation>;
export type UpdateHourSeriesCollectionsMutationResult = Apollo.MutationResult<UpdateHourSeriesCollectionsMutation>;
export type UpdateHourSeriesCollectionsMutationOptions = Apollo.BaseMutationOptions<UpdateHourSeriesCollectionsMutation, UpdateHourSeriesCollectionsMutationVariables>;
export const CreateLocalGridDocument = gql`
    mutation CreateLocalGrid($projectVersionId: String!, $input: CreateLocalGridInput!) {
  createLocalGrid(projectVersionId: $projectVersionId, input: $input) {
    ...LocalGrid
  }
}
    ${LocalGridFragmentDoc}`;
export type CreateLocalGridMutationFn = Apollo.MutationFunction<CreateLocalGridMutation, CreateLocalGridMutationVariables>;

/**
 * __useCreateLocalGridMutation__
 *
 * To run a mutation, you first call `useCreateLocalGridMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocalGridMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocalGridMutation, { data, loading, error }] = useCreateLocalGridMutation({
 *   variables: {
 *      projectVersionId: // value for 'projectVersionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocalGridMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocalGridMutation, CreateLocalGridMutationVariables>) {
        return Apollo.useMutation<CreateLocalGridMutation, CreateLocalGridMutationVariables>(CreateLocalGridDocument, baseOptions);
      }
export type CreateLocalGridMutationHookResult = ReturnType<typeof useCreateLocalGridMutation>;
export type CreateLocalGridMutationResult = Apollo.MutationResult<CreateLocalGridMutation>;
export type CreateLocalGridMutationOptions = Apollo.BaseMutationOptions<CreateLocalGridMutation, CreateLocalGridMutationVariables>;
export const DeleteLocalGridDocument = gql`
    mutation DeleteLocalGrid($id: String!) {
  deleteLocalGrid(id: $id)
}
    `;
export type DeleteLocalGridMutationFn = Apollo.MutationFunction<DeleteLocalGridMutation, DeleteLocalGridMutationVariables>;

/**
 * __useDeleteLocalGridMutation__
 *
 * To run a mutation, you first call `useDeleteLocalGridMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocalGridMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocalGridMutation, { data, loading, error }] = useDeleteLocalGridMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLocalGridMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocalGridMutation, DeleteLocalGridMutationVariables>) {
        return Apollo.useMutation<DeleteLocalGridMutation, DeleteLocalGridMutationVariables>(DeleteLocalGridDocument, baseOptions);
      }
export type DeleteLocalGridMutationHookResult = ReturnType<typeof useDeleteLocalGridMutation>;
export type DeleteLocalGridMutationResult = Apollo.MutationResult<DeleteLocalGridMutation>;
export type DeleteLocalGridMutationOptions = Apollo.BaseMutationOptions<DeleteLocalGridMutation, DeleteLocalGridMutationVariables>;
export const UpdateLocalGridDocument = gql`
    mutation UpdateLocalGrid($id: String!, $input: UpdateLocalGridInput!) {
  updateLocalGrid(id: $id, input: $input) {
    ...LocalGrid
  }
}
    ${LocalGridFragmentDoc}`;
export type UpdateLocalGridMutationFn = Apollo.MutationFunction<UpdateLocalGridMutation, UpdateLocalGridMutationVariables>;

/**
 * __useUpdateLocalGridMutation__
 *
 * To run a mutation, you first call `useUpdateLocalGridMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalGridMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalGridMutation, { data, loading, error }] = useUpdateLocalGridMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocalGridMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocalGridMutation, UpdateLocalGridMutationVariables>) {
        return Apollo.useMutation<UpdateLocalGridMutation, UpdateLocalGridMutationVariables>(UpdateLocalGridDocument, baseOptions);
      }
export type UpdateLocalGridMutationHookResult = ReturnType<typeof useUpdateLocalGridMutation>;
export type UpdateLocalGridMutationResult = Apollo.MutationResult<UpdateLocalGridMutation>;
export type UpdateLocalGridMutationOptions = Apollo.BaseMutationOptions<UpdateLocalGridMutation, UpdateLocalGridMutationVariables>;
export const UpdateLocalGridBoreholeFieldDocument = gql`
    mutation UpdateLocalGridBoreholeField($id: String!, $input: BoreholeFieldContainerInput!) {
  updateLocalGridBoreholeField(id: $id, input: $input) {
    ...LocalGrid
  }
}
    ${LocalGridFragmentDoc}`;
export type UpdateLocalGridBoreholeFieldMutationFn = Apollo.MutationFunction<UpdateLocalGridBoreholeFieldMutation, UpdateLocalGridBoreholeFieldMutationVariables>;

/**
 * __useUpdateLocalGridBoreholeFieldMutation__
 *
 * To run a mutation, you first call `useUpdateLocalGridBoreholeFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalGridBoreholeFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalGridBoreholeFieldMutation, { data, loading, error }] = useUpdateLocalGridBoreholeFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocalGridBoreholeFieldMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocalGridBoreholeFieldMutation, UpdateLocalGridBoreholeFieldMutationVariables>) {
        return Apollo.useMutation<UpdateLocalGridBoreholeFieldMutation, UpdateLocalGridBoreholeFieldMutationVariables>(UpdateLocalGridBoreholeFieldDocument, baseOptions);
      }
export type UpdateLocalGridBoreholeFieldMutationHookResult = ReturnType<typeof useUpdateLocalGridBoreholeFieldMutation>;
export type UpdateLocalGridBoreholeFieldMutationResult = Apollo.MutationResult<UpdateLocalGridBoreholeFieldMutation>;
export type UpdateLocalGridBoreholeFieldMutationOptions = Apollo.BaseMutationOptions<UpdateLocalGridBoreholeFieldMutation, UpdateLocalGridBoreholeFieldMutationVariables>;
export const PerformanceTablesDocument = gql`
    query PerformanceTables {
  performanceTables {
    ...PerformanceTable
  }
}
    ${PerformanceTableFragmentDoc}`;

/**
 * __usePerformanceTablesQuery__
 *
 * To run a query within a React component, call `usePerformanceTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePerformanceTablesQuery(baseOptions?: Apollo.QueryHookOptions<PerformanceTablesQuery, PerformanceTablesQueryVariables>) {
        return Apollo.useQuery<PerformanceTablesQuery, PerformanceTablesQueryVariables>(PerformanceTablesDocument, baseOptions);
      }
export function usePerformanceTablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceTablesQuery, PerformanceTablesQueryVariables>) {
          return Apollo.useLazyQuery<PerformanceTablesQuery, PerformanceTablesQueryVariables>(PerformanceTablesDocument, baseOptions);
        }
export type PerformanceTablesQueryHookResult = ReturnType<typeof usePerformanceTablesQuery>;
export type PerformanceTablesLazyQueryHookResult = ReturnType<typeof usePerformanceTablesLazyQuery>;
export type PerformanceTablesQueryResult = Apollo.QueryResult<PerformanceTablesQuery, PerformanceTablesQueryVariables>;
export const CreateGlobalPricingModelDocument = gql`
    mutation CreateGlobalPricingModel($input: CreatePricingModelInput!) {
  createGlobalPricingModel(input: $input) {
    ...PricingModel
  }
}
    ${PricingModelFragmentDoc}`;
export type CreateGlobalPricingModelMutationFn = Apollo.MutationFunction<CreateGlobalPricingModelMutation, CreateGlobalPricingModelMutationVariables>;

/**
 * __useCreateGlobalPricingModelMutation__
 *
 * To run a mutation, you first call `useCreateGlobalPricingModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlobalPricingModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlobalPricingModelMutation, { data, loading, error }] = useCreateGlobalPricingModelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGlobalPricingModelMutation(baseOptions?: Apollo.MutationHookOptions<CreateGlobalPricingModelMutation, CreateGlobalPricingModelMutationVariables>) {
        return Apollo.useMutation<CreateGlobalPricingModelMutation, CreateGlobalPricingModelMutationVariables>(CreateGlobalPricingModelDocument, baseOptions);
      }
export type CreateGlobalPricingModelMutationHookResult = ReturnType<typeof useCreateGlobalPricingModelMutation>;
export type CreateGlobalPricingModelMutationResult = Apollo.MutationResult<CreateGlobalPricingModelMutation>;
export type CreateGlobalPricingModelMutationOptions = Apollo.BaseMutationOptions<CreateGlobalPricingModelMutation, CreateGlobalPricingModelMutationVariables>;
export const CreatePricingModelDocument = gql`
    mutation CreatePricingModel($projectId: String!, $input: CreatePricingModelInput!) {
  createPricingModel(projectId: $projectId, input: $input) {
    ...PricingModel
  }
}
    ${PricingModelFragmentDoc}`;
export type CreatePricingModelMutationFn = Apollo.MutationFunction<CreatePricingModelMutation, CreatePricingModelMutationVariables>;

/**
 * __useCreatePricingModelMutation__
 *
 * To run a mutation, you first call `useCreatePricingModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePricingModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPricingModelMutation, { data, loading, error }] = useCreatePricingModelMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePricingModelMutation(baseOptions?: Apollo.MutationHookOptions<CreatePricingModelMutation, CreatePricingModelMutationVariables>) {
        return Apollo.useMutation<CreatePricingModelMutation, CreatePricingModelMutationVariables>(CreatePricingModelDocument, baseOptions);
      }
export type CreatePricingModelMutationHookResult = ReturnType<typeof useCreatePricingModelMutation>;
export type CreatePricingModelMutationResult = Apollo.MutationResult<CreatePricingModelMutation>;
export type CreatePricingModelMutationOptions = Apollo.BaseMutationOptions<CreatePricingModelMutation, CreatePricingModelMutationVariables>;
export const DeletePricingModelDocument = gql`
    mutation DeletePricingModel($id: String!) {
  deletePricingModel(id: $id)
}
    `;
export type DeletePricingModelMutationFn = Apollo.MutationFunction<DeletePricingModelMutation, DeletePricingModelMutationVariables>;

/**
 * __useDeletePricingModelMutation__
 *
 * To run a mutation, you first call `useDeletePricingModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePricingModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePricingModelMutation, { data, loading, error }] = useDeletePricingModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePricingModelMutation(baseOptions?: Apollo.MutationHookOptions<DeletePricingModelMutation, DeletePricingModelMutationVariables>) {
        return Apollo.useMutation<DeletePricingModelMutation, DeletePricingModelMutationVariables>(DeletePricingModelDocument, baseOptions);
      }
export type DeletePricingModelMutationHookResult = ReturnType<typeof useDeletePricingModelMutation>;
export type DeletePricingModelMutationResult = Apollo.MutationResult<DeletePricingModelMutation>;
export type DeletePricingModelMutationOptions = Apollo.BaseMutationOptions<DeletePricingModelMutation, DeletePricingModelMutationVariables>;
export const GlobalPricingModelsDocument = gql`
    query GlobalPricingModels {
  globalPricingModels {
    ...PricingModel
  }
}
    ${PricingModelFragmentDoc}`;

/**
 * __useGlobalPricingModelsQuery__
 *
 * To run a query within a React component, call `useGlobalPricingModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalPricingModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalPricingModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalPricingModelsQuery(baseOptions?: Apollo.QueryHookOptions<GlobalPricingModelsQuery, GlobalPricingModelsQueryVariables>) {
        return Apollo.useQuery<GlobalPricingModelsQuery, GlobalPricingModelsQueryVariables>(GlobalPricingModelsDocument, baseOptions);
      }
export function useGlobalPricingModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalPricingModelsQuery, GlobalPricingModelsQueryVariables>) {
          return Apollo.useLazyQuery<GlobalPricingModelsQuery, GlobalPricingModelsQueryVariables>(GlobalPricingModelsDocument, baseOptions);
        }
export type GlobalPricingModelsQueryHookResult = ReturnType<typeof useGlobalPricingModelsQuery>;
export type GlobalPricingModelsLazyQueryHookResult = ReturnType<typeof useGlobalPricingModelsLazyQuery>;
export type GlobalPricingModelsQueryResult = Apollo.QueryResult<GlobalPricingModelsQuery, GlobalPricingModelsQueryVariables>;
export const UpdatePricingModelDocument = gql`
    mutation UpdatePricingModel($id: String!, $input: UpdatePricingModelInput!) {
  updatePricingModel(id: $id, input: $input) {
    ...PricingModel
  }
}
    ${PricingModelFragmentDoc}`;
export type UpdatePricingModelMutationFn = Apollo.MutationFunction<UpdatePricingModelMutation, UpdatePricingModelMutationVariables>;

/**
 * __useUpdatePricingModelMutation__
 *
 * To run a mutation, you first call `useUpdatePricingModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePricingModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePricingModelMutation, { data, loading, error }] = useUpdatePricingModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePricingModelMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePricingModelMutation, UpdatePricingModelMutationVariables>) {
        return Apollo.useMutation<UpdatePricingModelMutation, UpdatePricingModelMutationVariables>(UpdatePricingModelDocument, baseOptions);
      }
export type UpdatePricingModelMutationHookResult = ReturnType<typeof useUpdatePricingModelMutation>;
export type UpdatePricingModelMutationResult = Apollo.MutationResult<UpdatePricingModelMutation>;
export type UpdatePricingModelMutationOptions = Apollo.BaseMutationOptions<UpdatePricingModelMutation, UpdatePricingModelMutationVariables>;
export const CreateProjectVersionDocument = gql`
    mutation CreateProjectVersion($projectId: String!, $input: CreateProjectVersionInput!, $copyOfVersionId: String) {
  createProjectVersion(
    projectId: $projectId
    input: $input
    copyOfVersionId: $copyOfVersionId
  ) {
    ...ProjectVersion
  }
}
    ${ProjectVersionFragmentDoc}`;
export type CreateProjectVersionMutationFn = Apollo.MutationFunction<CreateProjectVersionMutation, CreateProjectVersionMutationVariables>;

/**
 * __useCreateProjectVersionMutation__
 *
 * To run a mutation, you first call `useCreateProjectVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectVersionMutation, { data, loading, error }] = useCreateProjectVersionMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *      copyOfVersionId: // value for 'copyOfVersionId'
 *   },
 * });
 */
export function useCreateProjectVersionMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectVersionMutation, CreateProjectVersionMutationVariables>) {
        return Apollo.useMutation<CreateProjectVersionMutation, CreateProjectVersionMutationVariables>(CreateProjectVersionDocument, baseOptions);
      }
export type CreateProjectVersionMutationHookResult = ReturnType<typeof useCreateProjectVersionMutation>;
export type CreateProjectVersionMutationResult = Apollo.MutationResult<CreateProjectVersionMutation>;
export type CreateProjectVersionMutationOptions = Apollo.BaseMutationOptions<CreateProjectVersionMutation, CreateProjectVersionMutationVariables>;
export const DeleteProjectVersionDocument = gql`
    mutation DeleteProjectVersion($id: String!) {
  deleteProjectVersion(id: $id) {
    id
    baseVersionId
  }
}
    `;
export type DeleteProjectVersionMutationFn = Apollo.MutationFunction<DeleteProjectVersionMutation, DeleteProjectVersionMutationVariables>;

/**
 * __useDeleteProjectVersionMutation__
 *
 * To run a mutation, you first call `useDeleteProjectVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectVersionMutation, { data, loading, error }] = useDeleteProjectVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectVersionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectVersionMutation, DeleteProjectVersionMutationVariables>) {
        return Apollo.useMutation<DeleteProjectVersionMutation, DeleteProjectVersionMutationVariables>(DeleteProjectVersionDocument, baseOptions);
      }
export type DeleteProjectVersionMutationHookResult = ReturnType<typeof useDeleteProjectVersionMutation>;
export type DeleteProjectVersionMutationResult = Apollo.MutationResult<DeleteProjectVersionMutation>;
export type DeleteProjectVersionMutationOptions = Apollo.BaseMutationOptions<DeleteProjectVersionMutation, DeleteProjectVersionMutationVariables>;
export const UpdateProjectVersionDocument = gql`
    mutation UpdateProjectVersion($id: String!, $input: UpdateProjectVersionInput!) {
  updateProjectVersion(id: $id, input: $input) {
    ...ProjectVersion
  }
}
    ${ProjectVersionFragmentDoc}`;
export type UpdateProjectVersionMutationFn = Apollo.MutationFunction<UpdateProjectVersionMutation, UpdateProjectVersionMutationVariables>;

/**
 * __useUpdateProjectVersionMutation__
 *
 * To run a mutation, you first call `useUpdateProjectVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectVersionMutation, { data, loading, error }] = useUpdateProjectVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectVersionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectVersionMutation, UpdateProjectVersionMutationVariables>) {
        return Apollo.useMutation<UpdateProjectVersionMutation, UpdateProjectVersionMutationVariables>(UpdateProjectVersionDocument, baseOptions);
      }
export type UpdateProjectVersionMutationHookResult = ReturnType<typeof useUpdateProjectVersionMutation>;
export type UpdateProjectVersionMutationResult = Apollo.MutationResult<UpdateProjectVersionMutation>;
export type UpdateProjectVersionMutationOptions = Apollo.BaseMutationOptions<UpdateProjectVersionMutation, UpdateProjectVersionMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, baseOptions);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: String!) {
  deleteProject(id: $id)
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, baseOptions);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const ProjectDocument = gql`
    query Project($id: String!) {
  project(id: $id) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectQuery(baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
        return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, baseOptions);
      }
export function useProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>) {
          return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(ProjectDocument, baseOptions);
        }
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>;
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>;
export type ProjectQueryResult = Apollo.QueryResult<ProjectQuery, ProjectQueryVariables>;
export const ProjectCollectionsDocument = gql`
    query ProjectCollections($id: String!) {
  project(id: $id) {
    ...ProjectCollections
  }
}
    ${ProjectCollectionsFragmentDoc}`;

/**
 * __useProjectCollectionsQuery__
 *
 * To run a query within a React component, call `useProjectCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCollectionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectCollectionsQuery(baseOptions: Apollo.QueryHookOptions<ProjectCollectionsQuery, ProjectCollectionsQueryVariables>) {
        return Apollo.useQuery<ProjectCollectionsQuery, ProjectCollectionsQueryVariables>(ProjectCollectionsDocument, baseOptions);
      }
export function useProjectCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectCollectionsQuery, ProjectCollectionsQueryVariables>) {
          return Apollo.useLazyQuery<ProjectCollectionsQuery, ProjectCollectionsQueryVariables>(ProjectCollectionsDocument, baseOptions);
        }
export type ProjectCollectionsQueryHookResult = ReturnType<typeof useProjectCollectionsQuery>;
export type ProjectCollectionsLazyQueryHookResult = ReturnType<typeof useProjectCollectionsLazyQuery>;
export type ProjectCollectionsQueryResult = Apollo.QueryResult<ProjectCollectionsQuery, ProjectCollectionsQueryVariables>;
export const ProjectTemperatureCurvesDocument = gql`
    query ProjectTemperatureCurves($id: String!) {
  project(id: $id) {
    ...ProjectTemperatureCurves
  }
}
    ${ProjectTemperatureCurvesFragmentDoc}`;

/**
 * __useProjectTemperatureCurvesQuery__
 *
 * To run a query within a React component, call `useProjectTemperatureCurvesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTemperatureCurvesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTemperatureCurvesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectTemperatureCurvesQuery(baseOptions: Apollo.QueryHookOptions<ProjectTemperatureCurvesQuery, ProjectTemperatureCurvesQueryVariables>) {
        return Apollo.useQuery<ProjectTemperatureCurvesQuery, ProjectTemperatureCurvesQueryVariables>(ProjectTemperatureCurvesDocument, baseOptions);
      }
export function useProjectTemperatureCurvesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectTemperatureCurvesQuery, ProjectTemperatureCurvesQueryVariables>) {
          return Apollo.useLazyQuery<ProjectTemperatureCurvesQuery, ProjectTemperatureCurvesQueryVariables>(ProjectTemperatureCurvesDocument, baseOptions);
        }
export type ProjectTemperatureCurvesQueryHookResult = ReturnType<typeof useProjectTemperatureCurvesQuery>;
export type ProjectTemperatureCurvesLazyQueryHookResult = ReturnType<typeof useProjectTemperatureCurvesLazyQuery>;
export type ProjectTemperatureCurvesQueryResult = Apollo.QueryResult<ProjectTemperatureCurvesQuery, ProjectTemperatureCurvesQueryVariables>;
export const ProjectsDocument = gql`
    query Projects($filter: ProjectListFilter!) {
  projects(filter: $filter) {
    totalCount
    items {
      ...ListProject
    }
  }
}
    ${ListProjectFragmentDoc}`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProjectsQuery(baseOptions: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
        return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, baseOptions);
      }
export function useProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, baseOptions);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsQueryResult = Apollo.QueryResult<ProjectsQuery, ProjectsQueryVariables>;
export const RestoreProjectDocument = gql`
    mutation RestoreProject($id: String!) {
  restoreProject(id: $id)
}
    `;
export type RestoreProjectMutationFn = Apollo.MutationFunction<RestoreProjectMutation, RestoreProjectMutationVariables>;

/**
 * __useRestoreProjectMutation__
 *
 * To run a mutation, you first call `useRestoreProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreProjectMutation, { data, loading, error }] = useRestoreProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreProjectMutation(baseOptions?: Apollo.MutationHookOptions<RestoreProjectMutation, RestoreProjectMutationVariables>) {
        return Apollo.useMutation<RestoreProjectMutation, RestoreProjectMutationVariables>(RestoreProjectDocument, baseOptions);
      }
export type RestoreProjectMutationHookResult = ReturnType<typeof useRestoreProjectMutation>;
export type RestoreProjectMutationResult = Apollo.MutationResult<RestoreProjectMutation>;
export type RestoreProjectMutationOptions = Apollo.BaseMutationOptions<RestoreProjectMutation, RestoreProjectMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($id: String!, $input: UpdateProjectInput!) {
  updateProject(id: $id, input: $input) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, baseOptions);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const CreateProviderDocument = gql`
    mutation CreateProvider($buildingId: String, $localGridId: String, $input: CreateProviderInput!) {
  createProvider(
    buildingId: $buildingId
    localGridId: $localGridId
    input: $input
  ) {
    ...Provider
  }
}
    ${ProviderFragmentDoc}`;
export type CreateProviderMutationFn = Apollo.MutationFunction<CreateProviderMutation, CreateProviderMutationVariables>;

/**
 * __useCreateProviderMutation__
 *
 * To run a mutation, you first call `useCreateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderMutation, { data, loading, error }] = useCreateProviderMutation({
 *   variables: {
 *      buildingId: // value for 'buildingId'
 *      localGridId: // value for 'localGridId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderMutation(baseOptions?: Apollo.MutationHookOptions<CreateProviderMutation, CreateProviderMutationVariables>) {
        return Apollo.useMutation<CreateProviderMutation, CreateProviderMutationVariables>(CreateProviderDocument, baseOptions);
      }
export type CreateProviderMutationHookResult = ReturnType<typeof useCreateProviderMutation>;
export type CreateProviderMutationResult = Apollo.MutationResult<CreateProviderMutation>;
export type CreateProviderMutationOptions = Apollo.BaseMutationOptions<CreateProviderMutation, CreateProviderMutationVariables>;
export const DeleteProviderDocument = gql`
    mutation DeleteProvider($id: String!) {
  deleteProvider(id: $id)
}
    `;
export type DeleteProviderMutationFn = Apollo.MutationFunction<DeleteProviderMutation, DeleteProviderMutationVariables>;

/**
 * __useDeleteProviderMutation__
 *
 * To run a mutation, you first call `useDeleteProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderMutation, { data, loading, error }] = useDeleteProviderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProviderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderMutation, DeleteProviderMutationVariables>) {
        return Apollo.useMutation<DeleteProviderMutation, DeleteProviderMutationVariables>(DeleteProviderDocument, baseOptions);
      }
export type DeleteProviderMutationHookResult = ReturnType<typeof useDeleteProviderMutation>;
export type DeleteProviderMutationResult = Apollo.MutationResult<DeleteProviderMutation>;
export type DeleteProviderMutationOptions = Apollo.BaseMutationOptions<DeleteProviderMutation, DeleteProviderMutationVariables>;
export const UpdateProviderDocument = gql`
    mutation UpdateProvider($id: String!, $input: UpdateProviderInput!) {
  updateProvider(id: $id, input: $input) {
    ...Provider
  }
}
    ${ProviderFragmentDoc}`;
export type UpdateProviderMutationFn = Apollo.MutationFunction<UpdateProviderMutation, UpdateProviderMutationVariables>;

/**
 * __useUpdateProviderMutation__
 *
 * To run a mutation, you first call `useUpdateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderMutation, { data, loading, error }] = useUpdateProviderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderMutation, UpdateProviderMutationVariables>) {
        return Apollo.useMutation<UpdateProviderMutation, UpdateProviderMutationVariables>(UpdateProviderDocument, baseOptions);
      }
export type UpdateProviderMutationHookResult = ReturnType<typeof useUpdateProviderMutation>;
export type UpdateProviderMutationResult = Apollo.MutationResult<UpdateProviderMutation>;
export type UpdateProviderMutationOptions = Apollo.BaseMutationOptions<UpdateProviderMutation, UpdateProviderMutationVariables>;
export const CreateScheduleDocument = gql`
    mutation CreateSchedule($buildingEnergyModelId: String!, $input: CreateScheduleInput!) {
  createSchedule(buildingEnergyModelId: $buildingEnergyModelId, input: $input) {
    ...Schedule
  }
}
    ${ScheduleFragmentDoc}`;
export type CreateScheduleMutationFn = Apollo.MutationFunction<CreateScheduleMutation, CreateScheduleMutationVariables>;

/**
 * __useCreateScheduleMutation__
 *
 * To run a mutation, you first call `useCreateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleMutation, { data, loading, error }] = useCreateScheduleMutation({
 *   variables: {
 *      buildingEnergyModelId: // value for 'buildingEnergyModelId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleMutation, CreateScheduleMutationVariables>) {
        return Apollo.useMutation<CreateScheduleMutation, CreateScheduleMutationVariables>(CreateScheduleDocument, baseOptions);
      }
export type CreateScheduleMutationHookResult = ReturnType<typeof useCreateScheduleMutation>;
export type CreateScheduleMutationResult = Apollo.MutationResult<CreateScheduleMutation>;
export type CreateScheduleMutationOptions = Apollo.BaseMutationOptions<CreateScheduleMutation, CreateScheduleMutationVariables>;
export const DeleteScheduleDocument = gql`
    mutation DeleteSchedule($id: String!) {
  deleteSchedule(id: $id)
}
    `;
export type DeleteScheduleMutationFn = Apollo.MutationFunction<DeleteScheduleMutation, DeleteScheduleMutationVariables>;

/**
 * __useDeleteScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleMutation, { data, loading, error }] = useDeleteScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>) {
        return Apollo.useMutation<DeleteScheduleMutation, DeleteScheduleMutationVariables>(DeleteScheduleDocument, baseOptions);
      }
export type DeleteScheduleMutationHookResult = ReturnType<typeof useDeleteScheduleMutation>;
export type DeleteScheduleMutationResult = Apollo.MutationResult<DeleteScheduleMutation>;
export type DeleteScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>;
export const GetScheduleDocument = gql`
    query GetSchedule($id: String!) {
  getSchedule(id: $id) {
    ...Schedule
  }
}
    ${ScheduleFragmentDoc}`;

/**
 * __useGetScheduleQuery__
 *
 * To run a query within a React component, call `useGetScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetScheduleQuery, GetScheduleQueryVariables>) {
        return Apollo.useQuery<GetScheduleQuery, GetScheduleQueryVariables>(GetScheduleDocument, baseOptions);
      }
export function useGetScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleQuery, GetScheduleQueryVariables>) {
          return Apollo.useLazyQuery<GetScheduleQuery, GetScheduleQueryVariables>(GetScheduleDocument, baseOptions);
        }
export type GetScheduleQueryHookResult = ReturnType<typeof useGetScheduleQuery>;
export type GetScheduleLazyQueryHookResult = ReturnType<typeof useGetScheduleLazyQuery>;
export type GetScheduleQueryResult = Apollo.QueryResult<GetScheduleQuery, GetScheduleQueryVariables>;
export const UpdateScheduleDocument = gql`
    mutation UpdateSchedule($id: String!, $input: UpdateScheduleInput!) {
  updateSchedule(id: $id, input: $input) {
    ...Schedule
  }
}
    ${ScheduleFragmentDoc}`;
export type UpdateScheduleMutationFn = Apollo.MutationFunction<UpdateScheduleMutation, UpdateScheduleMutationVariables>;

/**
 * __useUpdateScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleMutation, { data, loading, error }] = useUpdateScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>) {
        return Apollo.useMutation<UpdateScheduleMutation, UpdateScheduleMutationVariables>(UpdateScheduleDocument, baseOptions);
      }
export type UpdateScheduleMutationHookResult = ReturnType<typeof useUpdateScheduleMutation>;
export type UpdateScheduleMutationResult = Apollo.MutationResult<UpdateScheduleMutation>;
export type UpdateScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>;
export const CreateTemperatureCurveDocument = gql`
    mutation CreateTemperatureCurve($projectId: String!, $input: CreateTemperatureCurveInput!) {
  createProjectSpecificTemperatureCurve(projectId: $projectId, input: $input) {
    ...TemperatureCurve
  }
}
    ${TemperatureCurveFragmentDoc}`;
export type CreateTemperatureCurveMutationFn = Apollo.MutationFunction<CreateTemperatureCurveMutation, CreateTemperatureCurveMutationVariables>;

/**
 * __useCreateTemperatureCurveMutation__
 *
 * To run a mutation, you first call `useCreateTemperatureCurveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemperatureCurveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemperatureCurveMutation, { data, loading, error }] = useCreateTemperatureCurveMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemperatureCurveMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemperatureCurveMutation, CreateTemperatureCurveMutationVariables>) {
        return Apollo.useMutation<CreateTemperatureCurveMutation, CreateTemperatureCurveMutationVariables>(CreateTemperatureCurveDocument, baseOptions);
      }
export type CreateTemperatureCurveMutationHookResult = ReturnType<typeof useCreateTemperatureCurveMutation>;
export type CreateTemperatureCurveMutationResult = Apollo.MutationResult<CreateTemperatureCurveMutation>;
export type CreateTemperatureCurveMutationOptions = Apollo.BaseMutationOptions<CreateTemperatureCurveMutation, CreateTemperatureCurveMutationVariables>;
export const DeleteTemperatureCurveDocument = gql`
    mutation DeleteTemperatureCurve($id: String!) {
  deleteTemperatureCurve(id: $id)
}
    `;
export type DeleteTemperatureCurveMutationFn = Apollo.MutationFunction<DeleteTemperatureCurveMutation, DeleteTemperatureCurveMutationVariables>;

/**
 * __useDeleteTemperatureCurveMutation__
 *
 * To run a mutation, you first call `useDeleteTemperatureCurveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemperatureCurveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemperatureCurveMutation, { data, loading, error }] = useDeleteTemperatureCurveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemperatureCurveMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemperatureCurveMutation, DeleteTemperatureCurveMutationVariables>) {
        return Apollo.useMutation<DeleteTemperatureCurveMutation, DeleteTemperatureCurveMutationVariables>(DeleteTemperatureCurveDocument, baseOptions);
      }
export type DeleteTemperatureCurveMutationHookResult = ReturnType<typeof useDeleteTemperatureCurveMutation>;
export type DeleteTemperatureCurveMutationResult = Apollo.MutationResult<DeleteTemperatureCurveMutation>;
export type DeleteTemperatureCurveMutationOptions = Apollo.BaseMutationOptions<DeleteTemperatureCurveMutation, DeleteTemperatureCurveMutationVariables>;
export const TemperatureCurvesDocument = gql`
    query TemperatureCurves {
  temperatureCurves {
    ...TemperatureCurve
  }
}
    ${TemperatureCurveFragmentDoc}`;

/**
 * __useTemperatureCurvesQuery__
 *
 * To run a query within a React component, call `useTemperatureCurvesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemperatureCurvesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemperatureCurvesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTemperatureCurvesQuery(baseOptions?: Apollo.QueryHookOptions<TemperatureCurvesQuery, TemperatureCurvesQueryVariables>) {
        return Apollo.useQuery<TemperatureCurvesQuery, TemperatureCurvesQueryVariables>(TemperatureCurvesDocument, baseOptions);
      }
export function useTemperatureCurvesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemperatureCurvesQuery, TemperatureCurvesQueryVariables>) {
          return Apollo.useLazyQuery<TemperatureCurvesQuery, TemperatureCurvesQueryVariables>(TemperatureCurvesDocument, baseOptions);
        }
export type TemperatureCurvesQueryHookResult = ReturnType<typeof useTemperatureCurvesQuery>;
export type TemperatureCurvesLazyQueryHookResult = ReturnType<typeof useTemperatureCurvesLazyQuery>;
export type TemperatureCurvesQueryResult = Apollo.QueryResult<TemperatureCurvesQuery, TemperatureCurvesQueryVariables>;
export const UpdateTemperatureCurveDocument = gql`
    mutation UpdateTemperatureCurve($id: String!, $input: UpdateTemperatureCurveInput!) {
  updateTemperatureCurve(id: $id, input: $input) {
    ...TemperatureCurve
  }
}
    ${TemperatureCurveFragmentDoc}`;
export type UpdateTemperatureCurveMutationFn = Apollo.MutationFunction<UpdateTemperatureCurveMutation, UpdateTemperatureCurveMutationVariables>;

/**
 * __useUpdateTemperatureCurveMutation__
 *
 * To run a mutation, you first call `useUpdateTemperatureCurveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemperatureCurveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemperatureCurveMutation, { data, loading, error }] = useUpdateTemperatureCurveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemperatureCurveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemperatureCurveMutation, UpdateTemperatureCurveMutationVariables>) {
        return Apollo.useMutation<UpdateTemperatureCurveMutation, UpdateTemperatureCurveMutationVariables>(UpdateTemperatureCurveDocument, baseOptions);
      }
export type UpdateTemperatureCurveMutationHookResult = ReturnType<typeof useUpdateTemperatureCurveMutation>;
export type UpdateTemperatureCurveMutationResult = Apollo.MutationResult<UpdateTemperatureCurveMutation>;
export type UpdateTemperatureCurveMutationOptions = Apollo.BaseMutationOptions<UpdateTemperatureCurveMutation, UpdateTemperatureCurveMutationVariables>;
export const CreateUserGroupDocument = gql`
    mutation CreateUserGroup($input: CreateUserGroupInput!) {
  createUserGroup(input: $input) {
    ...UserGroup
  }
}
    ${UserGroupFragmentDoc}`;
export type CreateUserGroupMutationFn = Apollo.MutationFunction<CreateUserGroupMutation, CreateUserGroupMutationVariables>;

/**
 * __useCreateUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserGroupMutation, { data, loading, error }] = useCreateUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>) {
        return Apollo.useMutation<CreateUserGroupMutation, CreateUserGroupMutationVariables>(CreateUserGroupDocument, baseOptions);
      }
export type CreateUserGroupMutationHookResult = ReturnType<typeof useCreateUserGroupMutation>;
export type CreateUserGroupMutationResult = Apollo.MutationResult<CreateUserGroupMutation>;
export type CreateUserGroupMutationOptions = Apollo.BaseMutationOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>;
export const DeleteUserGroupDocument = gql`
    mutation DeleteUserGroup($id: String!) {
  deleteUserGroup(id: $id)
}
    `;
export type DeleteUserGroupMutationFn = Apollo.MutationFunction<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;

/**
 * __useDeleteUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserGroupMutation, { data, loading, error }] = useDeleteUserGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>) {
        return Apollo.useMutation<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>(DeleteUserGroupDocument, baseOptions);
      }
export type DeleteUserGroupMutationHookResult = ReturnType<typeof useDeleteUserGroupMutation>;
export type DeleteUserGroupMutationResult = Apollo.MutationResult<DeleteUserGroupMutation>;
export type DeleteUserGroupMutationOptions = Apollo.BaseMutationOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;
export const UpdateUserGroupDocument = gql`
    mutation UpdateUserGroup($id: String!, $input: UpdateUserGroupInput!) {
  updateUserGroup(id: $id, input: $input) {
    ...UserGroup
  }
}
    ${UserGroupFragmentDoc}`;
export type UpdateUserGroupMutationFn = Apollo.MutationFunction<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>;

/**
 * __useUpdateUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserGroupMutation, { data, loading, error }] = useUpdateUserGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>) {
        return Apollo.useMutation<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>(UpdateUserGroupDocument, baseOptions);
      }
export type UpdateUserGroupMutationHookResult = ReturnType<typeof useUpdateUserGroupMutation>;
export type UpdateUserGroupMutationResult = Apollo.MutationResult<UpdateUserGroupMutation>;
export type UpdateUserGroupMutationOptions = Apollo.BaseMutationOptions<UpdateUserGroupMutation, UpdateUserGroupMutationVariables>;
export const UserGroupsDocument = gql`
    query UserGroups {
  userGroups {
    ...UserGroup
  }
}
    ${UserGroupFragmentDoc}`;

/**
 * __useUserGroupsQuery__
 *
 * To run a query within a React component, call `useUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserGroupsQuery(baseOptions?: Apollo.QueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
        return Apollo.useQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, baseOptions);
      }
export function useUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
          return Apollo.useLazyQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, baseOptions);
        }
export type UserGroupsQueryHookResult = ReturnType<typeof useUserGroupsQuery>;
export type UserGroupsLazyQueryHookResult = ReturnType<typeof useUserGroupsLazyQuery>;
export type UserGroupsQueryResult = Apollo.QueryResult<UserGroupsQuery, UserGroupsQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...UserWithRole
  }
}
    ${UserWithRoleFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: String!, $input: UserInput!) {
  updateUser(id: $id, input: $input) {
    ...UserWithRole
  }
}
    ${UserWithRoleFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, baseOptions);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UsersDocument = gql`
    query Users {
  users {
    ...UserWithRole
  }
}
    ${UserWithRoleFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export type BatteryParametersKeySpecifier = ('isWasteSold' | 'capacity' | 'chargePower' | 'dischargePower' | BatteryParametersKeySpecifier)[];
export type BatteryParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>,
	capacity?: FieldPolicy<any> | FieldReadFunction<any>,
	chargePower?: FieldPolicy<any> | FieldReadFunction<any>,
	dischargePower?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BemCorrectionFactorsDataKeySpecifier = ('energyType' | 'correctionFactor' | 'energyFactor' | BemCorrectionFactorsDataKeySpecifier)[];
export type BemCorrectionFactorsDataFieldPolicy = {
	energyType?: FieldPolicy<any> | FieldReadFunction<any>,
	correctionFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	energyFactor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BemLimitValuesDataKeySpecifier = ('winterTempStart' | 'winterTempEnd' | 'summerTempStart' | 'summerTempEnd' | 'zeroWeatherTempStart' | 'zeroWeatherTempEnd' | 'morningStartHour' | 'morningEndHour' | 'dayStartHour' | 'dayEndHour' | 'eveningStartHour' | 'eveningEndHour' | 'nightStartHour' | 'nightEndHour' | BemLimitValuesDataKeySpecifier)[];
export type BemLimitValuesDataFieldPolicy = {
	winterTempStart?: FieldPolicy<any> | FieldReadFunction<any>,
	winterTempEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	summerTempStart?: FieldPolicy<any> | FieldReadFunction<any>,
	summerTempEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	zeroWeatherTempStart?: FieldPolicy<any> | FieldReadFunction<any>,
	zeroWeatherTempEnd?: FieldPolicy<any> | FieldReadFunction<any>,
	morningStartHour?: FieldPolicy<any> | FieldReadFunction<any>,
	morningEndHour?: FieldPolicy<any> | FieldReadFunction<any>,
	dayStartHour?: FieldPolicy<any> | FieldReadFunction<any>,
	dayEndHour?: FieldPolicy<any> | FieldReadFunction<any>,
	eveningStartHour?: FieldPolicy<any> | FieldReadFunction<any>,
	eveningEndHour?: FieldPolicy<any> | FieldReadFunction<any>,
	nightStartHour?: FieldPolicy<any> | FieldReadFunction<any>,
	nightEndHour?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BoreholeFieldConfirmationKeySpecifier = ('id' | 'type' | 'date' | 'confirmer' | 'data' | BoreholeFieldConfirmationKeySpecifier)[];
export type BoreholeFieldConfirmationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmer?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BoreholeFieldConfirmationDataKeySpecifier = ('holeCount' | 'holeDepth' | 'holeUsageForHeatingMonthlyTotal' | 'holeUsageForHeatingMonthlyMax' | 'holeUsageForCoolingMonthlyTotal' | 'holeUsageForCoolingMonthlyMax' | BoreholeFieldConfirmationDataKeySpecifier)[];
export type BoreholeFieldConfirmationDataFieldPolicy = {
	holeCount?: FieldPolicy<any> | FieldReadFunction<any>,
	holeDepth?: FieldPolicy<any> | FieldReadFunction<any>,
	holeUsageForHeatingMonthlyTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	holeUsageForHeatingMonthlyMax?: FieldPolicy<any> | FieldReadFunction<any>,
	holeUsageForCoolingMonthlyTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	holeUsageForCoolingMonthlyMax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BuildingKeySpecifier = ('id' | 'createdAt' | 'updatedAt' | 'holeCount' | 'holeDepth' | 'description' | 'modelingInformation' | 'pathToSimulation' | 'confirmationType' | 'confirmation' | 'projectVersion' | 'providers' | 'demands' | 'parts' | 'emissions' | 'name' | 'area' | 'type' | 'multiplier' | BuildingKeySpecifier)[];
export type BuildingFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	holeCount?: FieldPolicy<any> | FieldReadFunction<any>,
	holeDepth?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	modelingInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	pathToSimulation?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmationType?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	projectVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	providers?: FieldPolicy<any> | FieldReadFunction<any>,
	demands?: FieldPolicy<any> | FieldReadFunction<any>,
	parts?: FieldPolicy<any> | FieldReadFunction<any>,
	emissions?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	area?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	multiplier?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BuildingEnergyModelKeySpecifier = ('id' | 'project' | 'energySystems' | 'schedules' | 'createdAt' | 'updatedAt' | 'name' | 'area' | 'type' | 'correctionFactors' | 'calibrationDescription' | 'calibrationArea' | 'calibrationCorrection' | 'calibrationStart' | 'calOutdoorHourSeries' | 'calHeatingHourSeries' | 'calElectricityHourSeries' | 'calCoolingHourSeries' | 'calibrationWeeklyProfile' | 'calibrationMonthlyProfile' | 'calibrationLimitValues' | BuildingEnergyModelKeySpecifier)[];
export type BuildingEnergyModelFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	project?: FieldPolicy<any> | FieldReadFunction<any>,
	energySystems?: FieldPolicy<any> | FieldReadFunction<any>,
	schedules?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	area?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	correctionFactors?: FieldPolicy<any> | FieldReadFunction<any>,
	calibrationDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	calibrationArea?: FieldPolicy<any> | FieldReadFunction<any>,
	calibrationCorrection?: FieldPolicy<any> | FieldReadFunction<any>,
	calibrationStart?: FieldPolicy<any> | FieldReadFunction<any>,
	calOutdoorHourSeries?: FieldPolicy<any> | FieldReadFunction<any>,
	calHeatingHourSeries?: FieldPolicy<any> | FieldReadFunction<any>,
	calElectricityHourSeries?: FieldPolicy<any> | FieldReadFunction<any>,
	calCoolingHourSeries?: FieldPolicy<any> | FieldReadFunction<any>,
	calibrationWeeklyProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	calibrationMonthlyProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	calibrationLimitValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CirculationHeatPumpParametersKeySpecifier = ('isWasteSold' | 'cop' | 'maxPower' | CirculationHeatPumpParametersKeySpecifier)[];
export type CirculationHeatPumpParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>,
	cop?: FieldPolicy<any> | FieldReadFunction<any>,
	maxPower?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CommentKeySpecifier = ('id' | 'project' | 'projectVersion' | 'relationType' | 'locationType' | 'text' | CommentKeySpecifier)[];
export type CommentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	project?: FieldPolicy<any> | FieldReadFunction<any>,
	projectVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	relationType?: FieldPolicy<any> | FieldReadFunction<any>,
	locationType?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CoolingAirHeatPumpParametersKeySpecifier = ('isWasteSold' | 'eer' | 'maxPower' | 'freeCooling' | 'freeCoolingMaxOutdoorTemperature' | 'freeCoolingEer' | 'freeCoolingMaxPower' | CoolingAirHeatPumpParametersKeySpecifier)[];
export type CoolingAirHeatPumpParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>,
	eer?: FieldPolicy<any> | FieldReadFunction<any>,
	maxPower?: FieldPolicy<any> | FieldReadFunction<any>,
	freeCooling?: FieldPolicy<any> | FieldReadFunction<any>,
	freeCoolingMaxOutdoorTemperature?: FieldPolicy<any> | FieldReadFunction<any>,
	freeCoolingEer?: FieldPolicy<any> | FieldReadFunction<any>,
	freeCoolingMaxPower?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CoolingGroundHeatPumpParametersKeySpecifier = ('isWasteSold' | 'eer' | 'maxPower' | 'freeCooling' | 'freeCoolingEer' | 'freeCoolingMaxPower' | CoolingGroundHeatPumpParametersKeySpecifier)[];
export type CoolingGroundHeatPumpParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>,
	eer?: FieldPolicy<any> | FieldReadFunction<any>,
	maxPower?: FieldPolicy<any> | FieldReadFunction<any>,
	freeCooling?: FieldPolicy<any> | FieldReadFunction<any>,
	freeCoolingEer?: FieldPolicy<any> | FieldReadFunction<any>,
	freeCoolingMaxPower?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CoolingParametersKeySpecifier = ('_' | 'systemCoolingPower' | 'scStartTemp' | 'scIncreaseSlope' | 'scIncreaseExtraCoef' | 'scExtraCoefStartTemp' | 'scDistributionEfficiency' | 'scSpacesPortion' | 'acDemandDisplacementConstant' | 'acCorrectionCoef' | 'acIncreaseExtraCoef' | 'acExtraCoefStartTemp' | 'acDistributionEfficiency' | CoolingParametersKeySpecifier)[];
export type CoolingParametersFieldPolicy = {
	_?: FieldPolicy<any> | FieldReadFunction<any>,
	systemCoolingPower?: FieldPolicy<any> | FieldReadFunction<any>,
	scStartTemp?: FieldPolicy<any> | FieldReadFunction<any>,
	scIncreaseSlope?: FieldPolicy<any> | FieldReadFunction<any>,
	scIncreaseExtraCoef?: FieldPolicy<any> | FieldReadFunction<any>,
	scExtraCoefStartTemp?: FieldPolicy<any> | FieldReadFunction<any>,
	scDistributionEfficiency?: FieldPolicy<any> | FieldReadFunction<any>,
	scSpacesPortion?: FieldPolicy<any> | FieldReadFunction<any>,
	acDemandDisplacementConstant?: FieldPolicy<any> | FieldReadFunction<any>,
	acCorrectionCoef?: FieldPolicy<any> | FieldReadFunction<any>,
	acIncreaseExtraCoef?: FieldPolicy<any> | FieldReadFunction<any>,
	acExtraCoefStartTemp?: FieldPolicy<any> | FieldReadFunction<any>,
	acDistributionEfficiency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CostKeySpecifier = ('id' | 'projectVersion' | 'provider' | 'providerId' | 'costType' | 'recurrencePeriodInYears' | 'occurrenceYear' | 'endYear' | 'value' | 'description' | CostKeySpecifier)[];
export type CostFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	projectVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	providerId?: FieldPolicy<any> | FieldReadFunction<any>,
	costType?: FieldPolicy<any> | FieldReadFunction<any>,
	recurrencePeriodInYears?: FieldPolicy<any> | FieldReadFunction<any>,
	occurrenceYear?: FieldPolicy<any> | FieldReadFunction<any>,
	endYear?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DemandKeySpecifier = ('id' | 'hourSeries' | 'building' | 'providers' | 'type' | 'createdAt' | 'updatedAt' | DemandKeySpecifier)[];
export type DemandFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	hourSeries?: FieldPolicy<any> | FieldReadFunction<any>,
	building?: FieldPolicy<any> | FieldReadFunction<any>,
	providers?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DomesticHotWaterParametersKeySpecifier = ('_' | 'consumptionDensity' | 'distributionEfficiency' | 'consumptionFactor' | 'circulationSpecificLength' | 'circulationSpecificHeatLoss' | 'circulationHeatersAmount' | 'circulationHeatersPower' | 'wasteWaterHeatContentRatio' | DomesticHotWaterParametersKeySpecifier)[];
export type DomesticHotWaterParametersFieldPolicy = {
	_?: FieldPolicy<any> | FieldReadFunction<any>,
	consumptionDensity?: FieldPolicy<any> | FieldReadFunction<any>,
	distributionEfficiency?: FieldPolicy<any> | FieldReadFunction<any>,
	consumptionFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	circulationSpecificLength?: FieldPolicy<any> | FieldReadFunction<any>,
	circulationSpecificHeatLoss?: FieldPolicy<any> | FieldReadFunction<any>,
	circulationHeatersAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	circulationHeatersPower?: FieldPolicy<any> | FieldReadFunction<any>,
	wasteWaterHeatContentRatio?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ElectricityConsumptionParametersKeySpecifier = ('_' | 'electricityBaseLoad' | 'occupantLightingElShare' | 'occupantApplianceElShare' | 'occupantVentilationElShare' | 'occupantBaseLoadElShare' | ElectricityConsumptionParametersKeySpecifier)[];
export type ElectricityConsumptionParametersFieldPolicy = {
	_?: FieldPolicy<any> | FieldReadFunction<any>,
	electricityBaseLoad?: FieldPolicy<any> | FieldReadFunction<any>,
	occupantLightingElShare?: FieldPolicy<any> | FieldReadFunction<any>,
	occupantApplianceElShare?: FieldPolicy<any> | FieldReadFunction<any>,
	occupantVentilationElShare?: FieldPolicy<any> | FieldReadFunction<any>,
	occupantBaseLoadElShare?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EmissionKeySpecifier = ('id' | 'projectVersion' | 'building' | 'buildingId' | 'emissionType' | 'value' | EmissionKeySpecifier)[];
export type EmissionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	projectVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	building?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingId?: FieldPolicy<any> | FieldReadFunction<any>,
	emissionType?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnergyBusKeySpecifier = ('id' | 'createdAt' | 'updatedAt' | 'holeCount' | 'holeDepth' | 'description' | 'modelingInformation' | 'pathToSimulation' | 'confirmationType' | 'confirmation' | 'projectVersion' | 'wasteHourSeries' | EnergyBusKeySpecifier)[];
export type EnergyBusFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	holeCount?: FieldPolicy<any> | FieldReadFunction<any>,
	holeDepth?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	modelingInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	pathToSimulation?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmationType?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	projectVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	wasteHourSeries?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnergySystemKeySpecifier = ('id' | 'name' | 'buildingEnergyModel' | 'type' | 'parameters' | 'schedule' | 'createdAt' | 'updatedAt' | EnergySystemKeySpecifier)[];
export type EnergySystemFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingEnergyModel?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	parameters?: FieldPolicy<any> | FieldReadFunction<any>,
	schedule?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EnergySystemParametersKeySpecifier = ('_' | EnergySystemParametersKeySpecifier)[];
export type EnergySystemParametersFieldPolicy = {
	_?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeatBoilerParametersKeySpecifier = ('isWasteSold' | 'efficiency' | 'fuelType' | HeatBoilerParametersKeySpecifier)[];
export type HeatBoilerParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>,
	efficiency?: FieldPolicy<any> | FieldReadFunction<any>,
	fuelType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeatCircuitKeySpecifier = ('demandId' | 'temperatureCurveId' | 'isDhwCircuit' | HeatCircuitKeySpecifier)[];
export type HeatCircuitFieldPolicy = {
	demandId?: FieldPolicy<any> | FieldReadFunction<any>,
	temperatureCurveId?: FieldPolicy<any> | FieldReadFunction<any>,
	isDhwCircuit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeatLoadParametersKeySpecifier = ('_' | 'occupantHeatLoad' | 'occupantHeatLoadUtilFactor' | 'occupantScheduleId' | 'applianceHeatLoad' | 'applianceHeatLoadUtilFactor' | 'applianceScheduleId' | 'lightingHeatLoad' | 'lightingHeatLoadUtilFactor' | 'lightingScheduleId' | 'heatLoadUtilStartTemp' | 'affectingSpaceHeatingStartTemp' | HeatLoadParametersKeySpecifier)[];
export type HeatLoadParametersFieldPolicy = {
	_?: FieldPolicy<any> | FieldReadFunction<any>,
	occupantHeatLoad?: FieldPolicy<any> | FieldReadFunction<any>,
	occupantHeatLoadUtilFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	occupantScheduleId?: FieldPolicy<any> | FieldReadFunction<any>,
	applianceHeatLoad?: FieldPolicy<any> | FieldReadFunction<any>,
	applianceHeatLoadUtilFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	applianceScheduleId?: FieldPolicy<any> | FieldReadFunction<any>,
	lightingHeatLoad?: FieldPolicy<any> | FieldReadFunction<any>,
	lightingHeatLoadUtilFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	lightingScheduleId?: FieldPolicy<any> | FieldReadFunction<any>,
	heatLoadUtilStartTemp?: FieldPolicy<any> | FieldReadFunction<any>,
	affectingSpaceHeatingStartTemp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeatingAirHeatPumpParametersKeySpecifier = ('isWasteSold' | 'cop' | 'maxPower' | 'minOutdoorTemperature' | HeatingAirHeatPumpParametersKeySpecifier)[];
export type HeatingAirHeatPumpParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>,
	cop?: FieldPolicy<any> | FieldReadFunction<any>,
	maxPower?: FieldPolicy<any> | FieldReadFunction<any>,
	minOutdoorTemperature?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HeatingGroundHeatPumpParametersKeySpecifier = ('isWasteSold' | 'cop' | 'maxPower' | HeatingGroundHeatPumpParametersKeySpecifier)[];
export type HeatingGroundHeatPumpParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>,
	cop?: FieldPolicy<any> | FieldReadFunction<any>,
	maxPower?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HourSeriesKeySpecifier = ('id' | 'collection' | 'type' | 'name' | 'values' | 'createdAt' | 'updatedAt' | 'calOutdoorHourSeriesBems' | 'calHeatingHourSeriesBems' | 'calElectricityHourSeriesBems' | 'calCoolingHourSeriesBems' | 'isInUse' | HourSeriesKeySpecifier)[];
export type HourSeriesFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	calOutdoorHourSeriesBems?: FieldPolicy<any> | FieldReadFunction<any>,
	calHeatingHourSeriesBems?: FieldPolicy<any> | FieldReadFunction<any>,
	calElectricityHourSeriesBems?: FieldPolicy<any> | FieldReadFunction<any>,
	calCoolingHourSeriesBems?: FieldPolicy<any> | FieldReadFunction<any>,
	isInUse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HourSeriesCollectionKeySpecifier = ('id' | 'project' | 'building' | 'hourSeries' | 'type' | 'name' | 'createdAt' | 'updatedAt' | 'originalGlobalCollection' | 'partArea' | 'isInUse' | HourSeriesCollectionKeySpecifier)[];
export type HourSeriesCollectionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	project?: FieldPolicy<any> | FieldReadFunction<any>,
	building?: FieldPolicy<any> | FieldReadFunction<any>,
	hourSeries?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	originalGlobalCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	partArea?: FieldPolicy<any> | FieldReadFunction<any>,
	isInUse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HybridHeatPumpParametersKeySpecifier = ('isWasteSold' | 'performanceTableId' | 'copModifier' | 'heatSourceAvailable' | 'heatExhaustAvailable' | 'heatRecycleAvailable' | 'heatingPower' | 'heatingTemperatureCurveId' | 'dhwHeatingMode' | 'heatCircuits' | 'coolingTemperatureCurveId' | 'baseHeatSource' | 'groundHeatSourceTemperature' | 'groundHeatSourceMaxPower' | 'airHeatSourceMinTemperature' | 'wasteHeatSourceAHourSeriesId' | 'wasteHeatSourceATemperature' | 'wasteHeatSourceBHourSeriesId' | 'wasteHeatSourceBTemperature' | 'freeCoolingSource' | 'freeGroundCoolingMaxPower' | 'freeAirCoolingMaxTemperature' | 'freeCoolingEer' | 'coolingSource' | 'groundExhaustTemperature' | HybridHeatPumpParametersKeySpecifier)[];
export type HybridHeatPumpParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>,
	performanceTableId?: FieldPolicy<any> | FieldReadFunction<any>,
	copModifier?: FieldPolicy<any> | FieldReadFunction<any>,
	heatSourceAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	heatExhaustAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	heatRecycleAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	heatingPower?: FieldPolicy<any> | FieldReadFunction<any>,
	heatingTemperatureCurveId?: FieldPolicy<any> | FieldReadFunction<any>,
	dhwHeatingMode?: FieldPolicy<any> | FieldReadFunction<any>,
	heatCircuits?: FieldPolicy<any> | FieldReadFunction<any>,
	coolingTemperatureCurveId?: FieldPolicy<any> | FieldReadFunction<any>,
	baseHeatSource?: FieldPolicy<any> | FieldReadFunction<any>,
	groundHeatSourceTemperature?: FieldPolicy<any> | FieldReadFunction<any>,
	groundHeatSourceMaxPower?: FieldPolicy<any> | FieldReadFunction<any>,
	airHeatSourceMinTemperature?: FieldPolicy<any> | FieldReadFunction<any>,
	wasteHeatSourceAHourSeriesId?: FieldPolicy<any> | FieldReadFunction<any>,
	wasteHeatSourceATemperature?: FieldPolicy<any> | FieldReadFunction<any>,
	wasteHeatSourceBHourSeriesId?: FieldPolicy<any> | FieldReadFunction<any>,
	wasteHeatSourceBTemperature?: FieldPolicy<any> | FieldReadFunction<any>,
	freeCoolingSource?: FieldPolicy<any> | FieldReadFunction<any>,
	freeGroundCoolingMaxPower?: FieldPolicy<any> | FieldReadFunction<any>,
	freeAirCoolingMaxTemperature?: FieldPolicy<any> | FieldReadFunction<any>,
	freeCoolingEer?: FieldPolicy<any> | FieldReadFunction<any>,
	coolingSource?: FieldPolicy<any> | FieldReadFunction<any>,
	groundExhaustTemperature?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InefficientParametersKeySpecifier = ('isWasteSold' | 'efficiency' | InefficientParametersKeySpecifier)[];
export type InefficientParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>,
	efficiency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LocalGridKeySpecifier = ('id' | 'createdAt' | 'updatedAt' | 'holeCount' | 'holeDepth' | 'description' | 'modelingInformation' | 'pathToSimulation' | 'confirmationType' | 'confirmation' | 'projectVersion' | 'providers' | 'type' | LocalGridKeySpecifier)[];
export type LocalGridFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	holeCount?: FieldPolicy<any> | FieldReadFunction<any>,
	holeDepth?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	modelingInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	pathToSimulation?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmationType?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	projectVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	providers?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('createProject' | 'updateProject' | 'deleteProject' | 'restoreProject' | 'createProjectVersion' | 'updateProjectVersion' | 'deleteProjectVersion' | 'updateUser' | 'createUserGroup' | 'updateUserGroup' | 'deleteUserGroup' | 'createHourSeriesCollections' | 'createHourSeriesCollection' | 'updateHourSeriesCollection' | 'deleteHourSeriesCollection' | 'createGlobalHourSeriesCollections' | 'createBuilding' | 'updateBuilding' | 'updateBuildingBoreholeField' | 'deleteBuilding' | 'createBuildingEnergyModel' | 'updateBuildingEnergyModel' | 'deleteBuildingEnergyModel' | 'createLocalGrid' | 'updateLocalGrid' | 'updateLocalGridBoreholeField' | 'deleteLocalGrid' | 'createEnergyBus' | 'updateEnergyBus' | 'updateEnergyBusBoreholeField' | 'deleteEnergyBus' | 'createProvider' | 'updateProvider' | 'deleteProvider' | 'createProjectSpecificTemperatureCurve' | 'updateTemperatureCurve' | 'deleteTemperatureCurve' | 'createGlobalPricingModel' | 'createPricingModel' | 'updatePricingModel' | 'deletePricingModel' | 'createCost' | 'updateCost' | 'deleteCost' | 'createEmission' | 'updateEmission' | 'deleteEmission' | 'createComment' | 'updateComment' | 'deleteComment' | 'createEnergySystem' | 'updateEnergySystem' | 'deleteEnergySystem' | 'createSchedule' | 'updateSchedule' | 'deleteSchedule' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	createProject?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProject?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteProject?: FieldPolicy<any> | FieldReadFunction<any>,
	restoreProject?: FieldPolicy<any> | FieldReadFunction<any>,
	createProjectVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProjectVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteProjectVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createUserGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUserGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteUserGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	createHourSeriesCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	createHourSeriesCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	updateHourSeriesCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteHourSeriesCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	createGlobalHourSeriesCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	createBuilding?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBuilding?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBuildingBoreholeField?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBuilding?: FieldPolicy<any> | FieldReadFunction<any>,
	createBuildingEnergyModel?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBuildingEnergyModel?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteBuildingEnergyModel?: FieldPolicy<any> | FieldReadFunction<any>,
	createLocalGrid?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLocalGrid?: FieldPolicy<any> | FieldReadFunction<any>,
	updateLocalGridBoreholeField?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteLocalGrid?: FieldPolicy<any> | FieldReadFunction<any>,
	createEnergyBus?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEnergyBus?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEnergyBusBoreholeField?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEnergyBus?: FieldPolicy<any> | FieldReadFunction<any>,
	createProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	updateProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	createProjectSpecificTemperatureCurve?: FieldPolicy<any> | FieldReadFunction<any>,
	updateTemperatureCurve?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTemperatureCurve?: FieldPolicy<any> | FieldReadFunction<any>,
	createGlobalPricingModel?: FieldPolicy<any> | FieldReadFunction<any>,
	createPricingModel?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePricingModel?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePricingModel?: FieldPolicy<any> | FieldReadFunction<any>,
	createCost?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCost?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteCost?: FieldPolicy<any> | FieldReadFunction<any>,
	createEmission?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEmission?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEmission?: FieldPolicy<any> | FieldReadFunction<any>,
	createComment?: FieldPolicy<any> | FieldReadFunction<any>,
	updateComment?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteComment?: FieldPolicy<any> | FieldReadFunction<any>,
	createEnergySystem?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEnergySystem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEnergySystem?: FieldPolicy<any> | FieldReadFunction<any>,
	createSchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSchedule?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSchedule?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PerformanceTableKeySpecifier = ('id' | 'name' | 'copTable' | 'powerCoefficientTable' | PerformanceTableKeySpecifier)[];
export type PerformanceTableFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	copTable?: FieldPolicy<any> | FieldReadFunction<any>,
	powerCoefficientTable?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PerformanceTableColumnKeySpecifier = ('condenserTemperature' | 'value' | PerformanceTableColumnKeySpecifier)[];
export type PerformanceTableColumnFieldPolicy = {
	condenserTemperature?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PerformanceTableRowKeySpecifier = ('evaporatorTemperature' | 'columns' | PerformanceTableRowKeySpecifier)[];
export type PerformanceTableRowFieldPolicy = {
	evaporatorTemperature?: FieldPolicy<any> | FieldReadFunction<any>,
	columns?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PreheaterParametersKeySpecifier = ('isWasteSold' | 'relativePower' | PreheaterParametersKeySpecifier)[];
export type PreheaterParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>,
	relativePower?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PricingModelKeySpecifier = ('id' | 'project' | 'usedInVersions' | 'type' | 'name' | 'buildingYear' | 'inspectionLengthInYears' | 'yearlyDiscountRate' | 'yearlyMaintenanceIncreaseRate' | 'prices' | 'sellingPrices' | 'priceIncreaseRates' | PricingModelKeySpecifier)[];
export type PricingModelFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	project?: FieldPolicy<any> | FieldReadFunction<any>,
	usedInVersions?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingYear?: FieldPolicy<any> | FieldReadFunction<any>,
	inspectionLengthInYears?: FieldPolicy<any> | FieldReadFunction<any>,
	yearlyDiscountRate?: FieldPolicy<any> | FieldReadFunction<any>,
	yearlyMaintenanceIncreaseRate?: FieldPolicy<any> | FieldReadFunction<any>,
	prices?: FieldPolicy<any> | FieldReadFunction<any>,
	sellingPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	priceIncreaseRates?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PricingModelPriceDataKeySpecifier = ('energyType' | 'yearlyValue' | 'monthlyValues' | PricingModelPriceDataKeySpecifier)[];
export type PricingModelPriceDataFieldPolicy = {
	energyType?: FieldPolicy<any> | FieldReadFunction<any>,
	yearlyValue?: FieldPolicy<any> | FieldReadFunction<any>,
	monthlyValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectKeySpecifier = ('id' | 'userGroup' | 'owner' | 'hourSeriesCollections' | 'pricingModels' | 'buildingEnergyModels' | 'versions' | 'comments' | 'temperatureHourSeries' | 'temperatureCurves' | 'projectId' | 'name' | 'licensePaid' | 'visibility' | 'calendarYear' | 'createdAt' | 'updatedAt' | 'updatedBy' | 'deletedAt' | ProjectKeySpecifier)[];
export type ProjectFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	userGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	owner?: FieldPolicy<any> | FieldReadFunction<any>,
	hourSeriesCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingModels?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingEnergyModels?: FieldPolicy<any> | FieldReadFunction<any>,
	versions?: FieldPolicy<any> | FieldReadFunction<any>,
	comments?: FieldPolicy<any> | FieldReadFunction<any>,
	temperatureHourSeries?: FieldPolicy<any> | FieldReadFunction<any>,
	temperatureCurves?: FieldPolicy<any> | FieldReadFunction<any>,
	projectId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	licensePaid?: FieldPolicy<any> | FieldReadFunction<any>,
	visibility?: FieldPolicy<any> | FieldReadFunction<any>,
	calendarYear?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectListModelKeySpecifier = ('totalCount' | 'items' | ProjectListModelKeySpecifier)[];
export type ProjectListModelFieldPolicy = {
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProjectVersionKeySpecifier = ('id' | 'project' | 'pricingModel' | 'buildings' | 'localGrids' | 'energyBus' | 'costs' | 'emissions' | 'comments' | 'name' | 'createdAt' | 'updatedAt' | 'isDefault' | 'baseVersionId' | ProjectVersionKeySpecifier)[];
export type ProjectVersionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	project?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingModel?: FieldPolicy<any> | FieldReadFunction<any>,
	buildings?: FieldPolicy<any> | FieldReadFunction<any>,
	localGrids?: FieldPolicy<any> | FieldReadFunction<any>,
	energyBus?: FieldPolicy<any> | FieldReadFunction<any>,
	costs?: FieldPolicy<any> | FieldReadFunction<any>,
	emissions?: FieldPolicy<any> | FieldReadFunction<any>,
	comments?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	baseVersionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderKeySpecifier = ('id' | 'name' | 'building' | 'localGrid' | 'localGridId' | 'demands' | 'hourSeries' | 'performanceTables' | 'temperatureCurves' | 'costs' | 'type' | 'parameters' | 'providesElectricityForProviders' | 'isFallback' | 'createdAt' | 'updatedAt' | ProviderKeySpecifier)[];
export type ProviderFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	building?: FieldPolicy<any> | FieldReadFunction<any>,
	localGrid?: FieldPolicy<any> | FieldReadFunction<any>,
	localGridId?: FieldPolicy<any> | FieldReadFunction<any>,
	demands?: FieldPolicy<any> | FieldReadFunction<any>,
	hourSeries?: FieldPolicy<any> | FieldReadFunction<any>,
	performanceTables?: FieldPolicy<any> | FieldReadFunction<any>,
	temperatureCurves?: FieldPolicy<any> | FieldReadFunction<any>,
	costs?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	parameters?: FieldPolicy<any> | FieldReadFunction<any>,
	providesElectricityForProviders?: FieldPolicy<any> | FieldReadFunction<any>,
	isFallback?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderDemandKeySpecifier = ('id' | 'provider' | 'demand' | 'maxPower' | 'maxPortion' | ProviderDemandKeySpecifier)[];
export type ProviderDemandFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	provider?: FieldPolicy<any> | FieldReadFunction<any>,
	demand?: FieldPolicy<any> | FieldReadFunction<any>,
	maxPower?: FieldPolicy<any> | FieldReadFunction<any>,
	maxPortion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProviderParametersKeySpecifier = ('isWasteSold' | ProviderParametersKeySpecifier)[];
export type ProviderParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('projects' | 'project' | 'projectVersion' | 'me' | 'users' | 'userGroups' | 'globalHourSeriesCollections' | 'performanceTables' | 'temperatureCurves' | 'globalPricingModels' | 'pricingModels' | 'getSchedule' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	projects?: FieldPolicy<any> | FieldReadFunction<any>,
	project?: FieldPolicy<any> | FieldReadFunction<any>,
	projectVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	me?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	userGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	globalHourSeriesCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	performanceTables?: FieldPolicy<any> | FieldReadFunction<any>,
	temperatureCurves?: FieldPolicy<any> | FieldReadFunction<any>,
	globalPricingModels?: FieldPolicy<any> | FieldReadFunction<any>,
	pricingModels?: FieldPolicy<any> | FieldReadFunction<any>,
	getSchedule?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduleKeySpecifier = ('id' | 'name' | 'hourlyProfiles' | 'weeklyProfile' | 'monthlyProfile' | 'exceptionData' | 'createdAt' | 'updatedAt' | 'buildingEnergyModel' | 'energySystems' | ScheduleKeySpecifier)[];
export type ScheduleFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	hourlyProfiles?: FieldPolicy<any> | FieldReadFunction<any>,
	weeklyProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	monthlyProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	exceptionData?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	buildingEnergyModel?: FieldPolicy<any> | FieldReadFunction<any>,
	energySystems?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduleExceptionDataKeySpecifier = ('inUse' | 'startAt' | 'endAt' | 'profileType' | ScheduleExceptionDataKeySpecifier)[];
export type ScheduleExceptionDataFieldPolicy = {
	inUse?: FieldPolicy<any> | FieldReadFunction<any>,
	startAt?: FieldPolicy<any> | FieldReadFunction<any>,
	endAt?: FieldPolicy<any> | FieldReadFunction<any>,
	profileType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduleHourlyProfileDataKeySpecifier = ('profileType' | 'values' | ScheduleHourlyProfileDataKeySpecifier)[];
export type ScheduleHourlyProfileDataFieldPolicy = {
	profileType?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduleMonthlyProfileDataKeySpecifier = ('multipliers' | ScheduleMonthlyProfileDataKeySpecifier)[];
export type ScheduleMonthlyProfileDataFieldPolicy = {
	multipliers?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ScheduleWeeklyProfileDataKeySpecifier = ('profileTypes' | ScheduleWeeklyProfileDataKeySpecifier)[];
export type ScheduleWeeklyProfileDataFieldPolicy = {
	profileTypes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SolarPanelParametersKeySpecifier = ('isWasteSold' | 'area' | 'solarEfficiency' | 'ratingEfficiency' | SolarPanelParametersKeySpecifier)[];
export type SolarPanelParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>,
	area?: FieldPolicy<any> | FieldReadFunction<any>,
	solarEfficiency?: FieldPolicy<any> | FieldReadFunction<any>,
	ratingEfficiency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SpaceHeatingParametersKeySpecifier = ('_' | 'exteriorWallArea' | 'roofArea' | 'baseFloorArea' | 'windowsArea' | 'doorsArea' | 'exteriorWallUvalue' | 'roofUvalue' | 'baseFloorUvalue' | 'windowsUvalue' | 'doorsUvalue' | 'heatBridgeRatio' | 'q50' | 'airLeakageXfactor' | 'heatSupplyEfficiency' | 'basEfficiency' | 'affectingHeatLossStartTemp' | 'dynamicOutTempWeightFactor' | 'heatLossesCorrectionFactor' | 'heatLossesCorrectionFactorStartTemp' | 'supplyAirHeatingStartTemp' | 'supplyAirFullHeatingStartTemp' | SpaceHeatingParametersKeySpecifier)[];
export type SpaceHeatingParametersFieldPolicy = {
	_?: FieldPolicy<any> | FieldReadFunction<any>,
	exteriorWallArea?: FieldPolicy<any> | FieldReadFunction<any>,
	roofArea?: FieldPolicy<any> | FieldReadFunction<any>,
	baseFloorArea?: FieldPolicy<any> | FieldReadFunction<any>,
	windowsArea?: FieldPolicy<any> | FieldReadFunction<any>,
	doorsArea?: FieldPolicy<any> | FieldReadFunction<any>,
	exteriorWallUvalue?: FieldPolicy<any> | FieldReadFunction<any>,
	roofUvalue?: FieldPolicy<any> | FieldReadFunction<any>,
	baseFloorUvalue?: FieldPolicy<any> | FieldReadFunction<any>,
	windowsUvalue?: FieldPolicy<any> | FieldReadFunction<any>,
	doorsUvalue?: FieldPolicy<any> | FieldReadFunction<any>,
	heatBridgeRatio?: FieldPolicy<any> | FieldReadFunction<any>,
	q50?: FieldPolicy<any> | FieldReadFunction<any>,
	airLeakageXfactor?: FieldPolicy<any> | FieldReadFunction<any>,
	heatSupplyEfficiency?: FieldPolicy<any> | FieldReadFunction<any>,
	basEfficiency?: FieldPolicy<any> | FieldReadFunction<any>,
	affectingHeatLossStartTemp?: FieldPolicy<any> | FieldReadFunction<any>,
	dynamicOutTempWeightFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	heatLossesCorrectionFactor?: FieldPolicy<any> | FieldReadFunction<any>,
	heatLossesCorrectionFactorStartTemp?: FieldPolicy<any> | FieldReadFunction<any>,
	supplyAirHeatingStartTemp?: FieldPolicy<any> | FieldReadFunction<any>,
	supplyAirFullHeatingStartTemp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemperatureCurveKeySpecifier = ('id' | 'name' | 'table' | 'type' | 'project' | TemperatureCurveKeySpecifier)[];
export type TemperatureCurveFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	table?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	project?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemperatureCurveRowKeySpecifier = ('outdoor' | 'in' | 'return' | TemperatureCurveRowKeySpecifier)[];
export type TemperatureCurveRowFieldPolicy = {
	outdoor?: FieldPolicy<any> | FieldReadFunction<any>,
	in?: FieldPolicy<any> | FieldReadFunction<any>,
	return?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('id' | 'groups' | 'projects' | 'username' | 'name' | 'role' | 'displayName' | 'deletedAt' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	projects?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserGroupKeySpecifier = ('id' | 'users' | 'projects' | 'name' | UserGroupKeySpecifier)[];
export type UserGroupFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	projects?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VentilationDeviceDataKeySpecifier = ('deviceName' | 'effectedArea' | 'airFlow' | 'deviceScheduleId' | 'heatRecoveryEfficiency' | 'SFP' | 'systemType' | 'demandBasedUsageCoefficient' | 'exhaustAirMinimumTemp' | 'coolingCoil' | 'supplyAirTemp' | 'indoorAirTemp' | 'returnAirTemp' | 'chilldrop' | 'chilldropTempLimit' | 'exhaustAirHeatPump' | VentilationDeviceDataKeySpecifier)[];
export type VentilationDeviceDataFieldPolicy = {
	deviceName?: FieldPolicy<any> | FieldReadFunction<any>,
	effectedArea?: FieldPolicy<any> | FieldReadFunction<any>,
	airFlow?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceScheduleId?: FieldPolicy<any> | FieldReadFunction<any>,
	heatRecoveryEfficiency?: FieldPolicy<any> | FieldReadFunction<any>,
	SFP?: FieldPolicy<any> | FieldReadFunction<any>,
	systemType?: FieldPolicy<any> | FieldReadFunction<any>,
	demandBasedUsageCoefficient?: FieldPolicy<any> | FieldReadFunction<any>,
	exhaustAirMinimumTemp?: FieldPolicy<any> | FieldReadFunction<any>,
	coolingCoil?: FieldPolicy<any> | FieldReadFunction<any>,
	supplyAirTemp?: FieldPolicy<any> | FieldReadFunction<any>,
	indoorAirTemp?: FieldPolicy<any> | FieldReadFunction<any>,
	returnAirTemp?: FieldPolicy<any> | FieldReadFunction<any>,
	chilldrop?: FieldPolicy<any> | FieldReadFunction<any>,
	chilldropTempLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	exhaustAirHeatPump?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VentilationParametersKeySpecifier = ('_' | 'deviceData' | 'heatingDistributionEfficiency' | 'heatPumpExhaustAirMinimumTemp' | VentilationParametersKeySpecifier)[];
export type VentilationParametersFieldPolicy = {
	_?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceData?: FieldPolicy<any> | FieldReadFunction<any>,
	heatingDistributionEfficiency?: FieldPolicy<any> | FieldReadFunction<any>,
	heatPumpExhaustAirMinimumTemp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WaterCoolingHeatPumpParametersKeySpecifier = ('isWasteSold' | 'eer' | 'freeCooling' | 'freeCoolingMaxOutdoorTemperature' | 'freeCoolingEer' | WaterCoolingHeatPumpParametersKeySpecifier)[];
export type WaterCoolingHeatPumpParametersFieldPolicy = {
	isWasteSold?: FieldPolicy<any> | FieldReadFunction<any>,
	eer?: FieldPolicy<any> | FieldReadFunction<any>,
	freeCooling?: FieldPolicy<any> | FieldReadFunction<any>,
	freeCoolingMaxOutdoorTemperature?: FieldPolicy<any> | FieldReadFunction<any>,
	freeCoolingEer?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TypedTypePolicies = TypePolicies & {
	BatteryParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BatteryParametersKeySpecifier | (() => undefined | BatteryParametersKeySpecifier),
		fields?: BatteryParametersFieldPolicy,
	},
	BemCorrectionFactorsData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BemCorrectionFactorsDataKeySpecifier | (() => undefined | BemCorrectionFactorsDataKeySpecifier),
		fields?: BemCorrectionFactorsDataFieldPolicy,
	},
	BemLimitValuesData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BemLimitValuesDataKeySpecifier | (() => undefined | BemLimitValuesDataKeySpecifier),
		fields?: BemLimitValuesDataFieldPolicy,
	},
	BoreholeFieldConfirmation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BoreholeFieldConfirmationKeySpecifier | (() => undefined | BoreholeFieldConfirmationKeySpecifier),
		fields?: BoreholeFieldConfirmationFieldPolicy,
	},
	BoreholeFieldConfirmationData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BoreholeFieldConfirmationDataKeySpecifier | (() => undefined | BoreholeFieldConfirmationDataKeySpecifier),
		fields?: BoreholeFieldConfirmationDataFieldPolicy,
	},
	Building?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BuildingKeySpecifier | (() => undefined | BuildingKeySpecifier),
		fields?: BuildingFieldPolicy,
	},
	BuildingEnergyModel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BuildingEnergyModelKeySpecifier | (() => undefined | BuildingEnergyModelKeySpecifier),
		fields?: BuildingEnergyModelFieldPolicy,
	},
	CirculationHeatPumpParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CirculationHeatPumpParametersKeySpecifier | (() => undefined | CirculationHeatPumpParametersKeySpecifier),
		fields?: CirculationHeatPumpParametersFieldPolicy,
	},
	Comment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CommentKeySpecifier | (() => undefined | CommentKeySpecifier),
		fields?: CommentFieldPolicy,
	},
	CoolingAirHeatPumpParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CoolingAirHeatPumpParametersKeySpecifier | (() => undefined | CoolingAirHeatPumpParametersKeySpecifier),
		fields?: CoolingAirHeatPumpParametersFieldPolicy,
	},
	CoolingGroundHeatPumpParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CoolingGroundHeatPumpParametersKeySpecifier | (() => undefined | CoolingGroundHeatPumpParametersKeySpecifier),
		fields?: CoolingGroundHeatPumpParametersFieldPolicy,
	},
	CoolingParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CoolingParametersKeySpecifier | (() => undefined | CoolingParametersKeySpecifier),
		fields?: CoolingParametersFieldPolicy,
	},
	Cost?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CostKeySpecifier | (() => undefined | CostKeySpecifier),
		fields?: CostFieldPolicy,
	},
	Demand?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DemandKeySpecifier | (() => undefined | DemandKeySpecifier),
		fields?: DemandFieldPolicy,
	},
	DomesticHotWaterParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DomesticHotWaterParametersKeySpecifier | (() => undefined | DomesticHotWaterParametersKeySpecifier),
		fields?: DomesticHotWaterParametersFieldPolicy,
	},
	ElectricityConsumptionParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ElectricityConsumptionParametersKeySpecifier | (() => undefined | ElectricityConsumptionParametersKeySpecifier),
		fields?: ElectricityConsumptionParametersFieldPolicy,
	},
	Emission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EmissionKeySpecifier | (() => undefined | EmissionKeySpecifier),
		fields?: EmissionFieldPolicy,
	},
	EnergyBus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnergyBusKeySpecifier | (() => undefined | EnergyBusKeySpecifier),
		fields?: EnergyBusFieldPolicy,
	},
	EnergySystem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnergySystemKeySpecifier | (() => undefined | EnergySystemKeySpecifier),
		fields?: EnergySystemFieldPolicy,
	},
	EnergySystemParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EnergySystemParametersKeySpecifier | (() => undefined | EnergySystemParametersKeySpecifier),
		fields?: EnergySystemParametersFieldPolicy,
	},
	HeatBoilerParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeatBoilerParametersKeySpecifier | (() => undefined | HeatBoilerParametersKeySpecifier),
		fields?: HeatBoilerParametersFieldPolicy,
	},
	HeatCircuit?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeatCircuitKeySpecifier | (() => undefined | HeatCircuitKeySpecifier),
		fields?: HeatCircuitFieldPolicy,
	},
	HeatLoadParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeatLoadParametersKeySpecifier | (() => undefined | HeatLoadParametersKeySpecifier),
		fields?: HeatLoadParametersFieldPolicy,
	},
	HeatingAirHeatPumpParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeatingAirHeatPumpParametersKeySpecifier | (() => undefined | HeatingAirHeatPumpParametersKeySpecifier),
		fields?: HeatingAirHeatPumpParametersFieldPolicy,
	},
	HeatingGroundHeatPumpParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HeatingGroundHeatPumpParametersKeySpecifier | (() => undefined | HeatingGroundHeatPumpParametersKeySpecifier),
		fields?: HeatingGroundHeatPumpParametersFieldPolicy,
	},
	HourSeries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HourSeriesKeySpecifier | (() => undefined | HourSeriesKeySpecifier),
		fields?: HourSeriesFieldPolicy,
	},
	HourSeriesCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HourSeriesCollectionKeySpecifier | (() => undefined | HourSeriesCollectionKeySpecifier),
		fields?: HourSeriesCollectionFieldPolicy,
	},
	HybridHeatPumpParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HybridHeatPumpParametersKeySpecifier | (() => undefined | HybridHeatPumpParametersKeySpecifier),
		fields?: HybridHeatPumpParametersFieldPolicy,
	},
	InefficientParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InefficientParametersKeySpecifier | (() => undefined | InefficientParametersKeySpecifier),
		fields?: InefficientParametersFieldPolicy,
	},
	LocalGrid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LocalGridKeySpecifier | (() => undefined | LocalGridKeySpecifier),
		fields?: LocalGridFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	PerformanceTable?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PerformanceTableKeySpecifier | (() => undefined | PerformanceTableKeySpecifier),
		fields?: PerformanceTableFieldPolicy,
	},
	PerformanceTableColumn?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PerformanceTableColumnKeySpecifier | (() => undefined | PerformanceTableColumnKeySpecifier),
		fields?: PerformanceTableColumnFieldPolicy,
	},
	PerformanceTableRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PerformanceTableRowKeySpecifier | (() => undefined | PerformanceTableRowKeySpecifier),
		fields?: PerformanceTableRowFieldPolicy,
	},
	PreheaterParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PreheaterParametersKeySpecifier | (() => undefined | PreheaterParametersKeySpecifier),
		fields?: PreheaterParametersFieldPolicy,
	},
	PricingModel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PricingModelKeySpecifier | (() => undefined | PricingModelKeySpecifier),
		fields?: PricingModelFieldPolicy,
	},
	PricingModelPriceData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PricingModelPriceDataKeySpecifier | (() => undefined | PricingModelPriceDataKeySpecifier),
		fields?: PricingModelPriceDataFieldPolicy,
	},
	Project?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectKeySpecifier | (() => undefined | ProjectKeySpecifier),
		fields?: ProjectFieldPolicy,
	},
	ProjectListModel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectListModelKeySpecifier | (() => undefined | ProjectListModelKeySpecifier),
		fields?: ProjectListModelFieldPolicy,
	},
	ProjectVersion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProjectVersionKeySpecifier | (() => undefined | ProjectVersionKeySpecifier),
		fields?: ProjectVersionFieldPolicy,
	},
	Provider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderKeySpecifier | (() => undefined | ProviderKeySpecifier),
		fields?: ProviderFieldPolicy,
	},
	ProviderDemand?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderDemandKeySpecifier | (() => undefined | ProviderDemandKeySpecifier),
		fields?: ProviderDemandFieldPolicy,
	},
	ProviderParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProviderParametersKeySpecifier | (() => undefined | ProviderParametersKeySpecifier),
		fields?: ProviderParametersFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	Schedule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduleKeySpecifier | (() => undefined | ScheduleKeySpecifier),
		fields?: ScheduleFieldPolicy,
	},
	ScheduleExceptionData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduleExceptionDataKeySpecifier | (() => undefined | ScheduleExceptionDataKeySpecifier),
		fields?: ScheduleExceptionDataFieldPolicy,
	},
	ScheduleHourlyProfileData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduleHourlyProfileDataKeySpecifier | (() => undefined | ScheduleHourlyProfileDataKeySpecifier),
		fields?: ScheduleHourlyProfileDataFieldPolicy,
	},
	ScheduleMonthlyProfileData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduleMonthlyProfileDataKeySpecifier | (() => undefined | ScheduleMonthlyProfileDataKeySpecifier),
		fields?: ScheduleMonthlyProfileDataFieldPolicy,
	},
	ScheduleWeeklyProfileData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ScheduleWeeklyProfileDataKeySpecifier | (() => undefined | ScheduleWeeklyProfileDataKeySpecifier),
		fields?: ScheduleWeeklyProfileDataFieldPolicy,
	},
	SolarPanelParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SolarPanelParametersKeySpecifier | (() => undefined | SolarPanelParametersKeySpecifier),
		fields?: SolarPanelParametersFieldPolicy,
	},
	SpaceHeatingParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SpaceHeatingParametersKeySpecifier | (() => undefined | SpaceHeatingParametersKeySpecifier),
		fields?: SpaceHeatingParametersFieldPolicy,
	},
	TemperatureCurve?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemperatureCurveKeySpecifier | (() => undefined | TemperatureCurveKeySpecifier),
		fields?: TemperatureCurveFieldPolicy,
	},
	TemperatureCurveRow?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemperatureCurveRowKeySpecifier | (() => undefined | TemperatureCurveRowKeySpecifier),
		fields?: TemperatureCurveRowFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserGroupKeySpecifier | (() => undefined | UserGroupKeySpecifier),
		fields?: UserGroupFieldPolicy,
	},
	VentilationDeviceData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VentilationDeviceDataKeySpecifier | (() => undefined | VentilationDeviceDataKeySpecifier),
		fields?: VentilationDeviceDataFieldPolicy,
	},
	VentilationParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VentilationParametersKeySpecifier | (() => undefined | VentilationParametersKeySpecifier),
		fields?: VentilationParametersFieldPolicy,
	},
	WaterCoolingHeatPumpParameters?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WaterCoolingHeatPumpParametersKeySpecifier | (() => undefined | WaterCoolingHeatPumpParametersKeySpecifier),
		fields?: WaterCoolingHeatPumpParametersFieldPolicy,
	}
};